var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhmcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1536,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.01148588 2.40936821 8.63583144 5.96147055 11 11 C12.2664912 15.62522585 13.19384768 20.27450551 14 25 C18.36562709 24.14010375 20.7539739 22.03432874 24 19 C25.17148312 16.91360963 25.17148312 16.91360963 26 15 C34.88846448 15.72406031 41.57518378 16.52851441 48 23 C48.94875 23.9075 49.8975 24.815 50.875 25.75 C53.70433512 30.07721843 54.99261275 33.80676331 55 39 C54.03150459 42.84964759 52.65737695 46.39760216 51 50 C52.485 49.505 52.485 49.505 54 49 C54 49.66 54 50.32 54 51 C51.5 52.625 51.5 52.625 49 54 C49.66 54.33 50.32 54.66 51 55 C51.33 54.34 51.66 53.68 52 53 C52 53.66 52 54.32 52 55 C52.8353125 54.48308594 53.670625 53.96617187 54.53125 53.43359375 C58.81844508 51.66174623 61.00557615 52.08048666 65.5 53.0625 C66.7684375 53.32160156 68.036875 53.58070313 69.34375 53.84765625 C74.41690202 55.44656634 77.94673943 57.38500046 80.875 61.875 C82.35443225 65.98453403 82.90493765 68.76507822 81.2265625 72.91015625 C77.89248974 79.04626888 72.83060701 82.37709855 67 86 C67.64066406 86.268125 68.28132812 86.53625 68.94140625 86.8125 C76.4985554 90.23630528 81.37173951 94.40054414 85.5 101.625 C86.3998356 105.8992191 85.64829469 108.86548429 83.5 112.625 C79.99550784 115.95426755 74.98726293 119 70 119 C70 119.66 70 120.32 70 121 C71.27875 121.12375 72.5575 121.2475 73.875 121.375 C77.75 121.75 77.75 121.75 80 124 C81.71582941 124.80003196 83.45934218 125.54124337 85.21484375 126.25 C86.28436279 126.68844238 87.35388184 127.12688477 88.45581055 127.57861328 C90.17924683 128.28219971 90.17924683 128.28219971 91.9375 129 C107.09128058 135.30359005 121.41916308 142.58426183 135.37182617 151.22119141 C137.90941193 152.78914813 140.15579311 154.05193104 143 155 C144.35646909 156.30978898 145.68787623 157.64578924 147 159 C148.35715755 160.08519797 149.73300917 161.14735925 151.125 162.1875 C167.05439442 174.44894176 181.57782511 189.68132024 186 210 C187.1292511 232.10726198 180.33948291 245.47210452 166.171875 262.15234375 C125.56374294 305.41280877 56.79256748 319.39232584 1 329 C-0.11020508 329.19190918 -1.22041016 329.38381836 -2.36425781 329.58154297 C-32.36606602 334.68028152 -62.62588427 337.46919796 -93 339 C-95.01302733 339.1131658 -97.02604861 339.22643926 -99.0390625 339.33984375 C-114.95490466 340.16247539 -130.87399187 340.0668775 -146.8059082 339.96337891 C-148.18865433 339.95692856 -148.18865433 339.95692856 -149.59933472 339.9503479 C-151.35149692 339.9419418 -153.10364538 339.92939239 -154.85574341 339.91220093 C-159.06104717 339.77408299 -159.06104717 339.77408299 -163 341 C-163 340.34 -163 339.68 -163 339 C-164.01255859 339.01450195 -165.02511719 339.02900391 -166.06835938 339.04394531 C-176.93743282 339.15058159 -187.66936187 338.62681115 -198.5 337.75 C-199.75608063 337.65063141 -199.75608063 337.65063141 -201.03753662 337.54925537 C-276.39000372 331.5491474 -378.69264003 320.2872418 -431 259 C-436.50940692 251.85266129 -440.3619939 244.64679776 -443 236 C-443.99 235.67 -444.98 235.34 -446 235 C-445.67 234.67 -445.34 234.34 -445 234 C-445.66 233.34 -446.32 232.68 -447 232 C-447.33 231.01 -447.66 230.02 -448 229 C-447.34 228.67 -446.68 228.34 -446 228 C-446.01160156 226.96359375 -446.02320313 225.9271875 -446.03515625 224.859375 C-446.04453837 223.48958514 -446.05363812 222.11979332 -446.0625 220.75 C-446.07506836 219.72712891 -446.07506836 219.72712891 -446.08789062 218.68359375 C-446.10428392 215.30657446 -446.05628768 212.22708361 -445 209 C-445.66 208.67 -446.32 208.34 -447 208 C-446.01 208 -445.02 208 -444 208 C-444.061875 207.113125 -444.12375 206.22625 -444.1875 205.3125 C-443.97133906 201.49365669 -443.04523032 200.18300485 -441 197 C-440.39285156 195.9790625 -439.78570312 194.958125 -439.16015625 193.90625 C-429.65166852 178.28958495 -416.97066845 165.13462532 -401 156 C-401.33 155.34 -401.66 154.68 -402 154 C-401.2977832 153.89743896 -400.59556641 153.79487793 -399.87207031 153.68920898 C-396.56423968 152.89543086 -394.03589624 151.59697179 -391.046875 149.97265625 C-389.88317383 149.35011963 -388.71947266 148.72758301 -387.52050781 148.08618164 C-386.59945251 147.59071335 -386.59945251 147.59071335 -385.65979004 147.0852356 C-350.22343037 128.10826657 -311.62543817 116.97437358 -272.47192383 108.45825195 C-271.64072021 108.27738037 -270.8095166 108.09650879 -269.953125 107.91015625 C-269.23286133 107.75683838 -268.51259766 107.60352051 -267.77050781 107.44555664 C-265.91075123 107.04512999 -265.91075123 107.04512999 -264 106 C-262.64715487 105.8338935 -261.28888171 105.71122 -259.9296875 105.609375 C-255.33650087 105.18629676 -250.80546893 104.52520109 -246.2578125 103.765625 C-244.78841156 103.52123962 -243.31901052 103.27685487 -241.84960938 103.0324707 C-241.08285889 102.90490387 -240.3161084 102.77733704 -239.52612305 102.64590454 C-206.67166877 97.22876123 -173.71907409 93.76130041 -140.47070312 91.98754883 C-139.05942139 91.90815063 -139.05942139 91.90815063 -137.61962891 91.82714844 C-135.86125972 91.72905694 -134.10245737 91.63834035 -132.34326172 91.55639648 C-126.900839 91.27444253 -126.900839 91.27444253 -122 89 C-122.0928125 87.4221875 -122.0928125 87.4221875 -122.1875 85.8125 C-121.93431551 80.66441543 -120.40146013 78.48639711 -116.9375 74.8125 C-109.56669226 70.2645548 -102.27820999 70.87521863 -93.98046875 72.19921875 C-90.87125983 73.03458943 -88.69676658 74.27352275 -86 76 C-84.948125 76.33 -83.89625 76.66 -82.8125 77 C-80 78 -80 78 -78 81 C-74.91634129 81.2502157 -74.91634129 81.2502157 -72 81 C-73.35093261 78.59834202 -74.71055964 76.33994167 -76.5 74.23828125 C-80.27211178 69.76796609 -81.97557503 66.22933301 -82.23828125 60.33203125 C-81.77033243 55.75226986 -79.28222822 53.16201933 -76 50.1875 C-70.44157182 46.88718327 -63.23528945 47.24392692 -57.125 48.671875 C-54.72684867 49.39404557 -52.35817248 50.15707877 -50 51 C-50.40992188 50.21496094 -50.81984375 49.42992187 -51.2421875 48.62109375 C-59.1738725 33.15620553 -59.1738725 33.15620553 -58 24 C-56.40464359 19.29369858 -54.41207061 15.62532502 -51 12 C-44.82496145 9.94165382 -39.62661438 10.38534755 -33.75 13.1875 C-27.82922098 16.44117887 -24.16172853 20.77607297 -20 26 C-19.75765625 24.85402344 -19.5153125 23.70804687 -19.265625 22.52734375 C-18.92769264 20.99726113 -18.58911656 19.46732059 -18.25 17.9375 C-18.09273437 17.18533203 -17.93546875 16.43316406 -17.7734375 15.65820312 C-15.44648882 5.32118112 -11.54928041 -1.56499683 0 0 Z M63 117 C64.98 117.99 64.98 117.99 67 119 C67 118.34 67 117.68 67 117 C65.68 117 64.36 117 63 117 Z M68 118 C67.67 118.66 67.34 119.32 67 120 C67.66 120 68.32 120 69 120 C68.67 119.34 68.34 118.68 68 118 Z ",
    fill: "#269442",
    transform: "translate(922,278)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.01148588 2.40936821 8.63583144 5.96147055 11 11 C12.2664912 15.62522585 13.19384768 20.27450551 14 25 C18.36562709 24.14010375 20.7539739 22.03432874 24 19 C25.17148312 16.91360963 25.17148312 16.91360963 26 15 C34.88846448 15.72406031 41.57518378 16.52851441 48 23 C48.94875 23.9075 49.8975 24.815 50.875 25.75 C53.70433512 30.07721843 54.99261275 33.80676331 55 39 C54.03150459 42.84964759 52.65737695 46.39760216 51 50 C51.99 49.67 52.98 49.34 54 49 C54 49.66 54 50.32 54 51 C51.5 52.625 51.5 52.625 49 54 C49.66 54.33 50.32 54.66 51 55 C51.33 54.34 51.66 53.68 52 53 C52 53.66 52 54.32 52 55 C52.8353125 54.48308594 53.670625 53.96617187 54.53125 53.43359375 C58.81844508 51.66174623 61.00557615 52.08048666 65.5 53.0625 C66.7684375 53.32160156 68.036875 53.58070313 69.34375 53.84765625 C74.41690202 55.44656634 77.94673943 57.38500046 80.875 61.875 C82.35443225 65.98453403 82.90493765 68.76507822 81.2265625 72.91015625 C77.89248974 79.04626888 72.83060701 82.37709855 67 86 C67.64066406 86.268125 68.28132812 86.53625 68.94140625 86.8125 C76.4985554 90.23630528 81.37173951 94.40054414 85.5 101.625 C86.3998356 105.8992191 85.64829469 108.86548429 83.5 112.625 C79.99550784 115.95426755 74.98726293 119 70 119 C69.67 119.66 69.34 120.32 69 121 C68.34 119.68 67.68 118.36 67 117 C66.34 117.66 65.68 118.32 65 119 C62.375 119.125 62.375 119.125 60 119 C60.639375 120.093125 61.27875 121.18625 61.9375 122.3125 C64.74091579 127.10543667 65.71239174 131.44928102 65 137 C63.24178055 142.28421388 60.76568564 145.97785789 56 149 C52.26035749 150.79427292 49.67500875 151.12166732 45.5625 150.8125 C41.63654551 150.71726121 39.45025466 150.8402977 36.4375 153.4375 C35.633125 154.283125 34.82875 155.12875 34 156 C29.50770592 158.24614704 23.86119237 157.57552048 19 157 C10.91266418 153.76745132 6.27094464 147.01200221 2.125 139.6875 C1 137 1 137 1 134 C0.34 134 -0.32 134 -1 134 C-1.09796875 134.73863281 -1.1959375 135.47726562 -1.296875 136.23828125 C-2.0883242 139.34691784 -3.13240724 140.80750988 -5.25 143.1875 C-5.83265625 143.86167969 -6.4153125 144.53585937 -7.015625 145.23046875 C-11.7817584 149.48058377 -16.94319495 149.42902589 -23.0546875 149.31640625 C-28.4709874 148.7345491 -31.50969633 146.53058215 -35.3125 142.625 C-38.58338128 137.53696246 -39.28724335 132.59203421 -39.625 126.625 C-39.69976563 125.37976563 -39.77453125 124.13453125 -39.8515625 122.8515625 C-39.90054688 121.91054688 -39.94953125 120.96953125 -40 120 C-40.85464844 120.32355469 -41.70929687 120.64710938 -42.58984375 120.98046875 C-46.08759348 122.02618774 -48.92280135 122.29960851 -52.5625 122.3125 C-53.65691406 122.32925781 -54.75132812 122.34601563 -55.87890625 122.36328125 C-59.37588843 121.95624828 -61.19225129 121.08743621 -64 119 C-66.43323274 115.82327948 -68.5128457 113.019023 -69 109 C-69.144375 108.01 -69.28875 107.02 -69.4375 106 C-69.3497283 100.20706798 -66.12193636 94.71502323 -63 90 C-61.08579857 88.17264325 -59.10821315 86.61216299 -57 85 C-57.99 84.67128906 -58.98 84.34257812 -60 84.00390625 C-68.6025933 80.97269251 -74.89830977 77.97588191 -80 70 C-81.91006867 65.94110407 -82.55820992 62.46567936 -82 58 C-79.60939226 53.64567876 -77.07770394 49.9364078 -72.1640625 48.44140625 C-64.36360474 46.85033815 -57.37668439 48.36322771 -50 51 C-50.40992188 50.21496094 -50.81984375 49.42992187 -51.2421875 48.62109375 C-59.1738725 33.15620553 -59.1738725 33.15620553 -58 24 C-56.40464359 19.29369858 -54.41207061 15.62532502 -51 12 C-44.82496145 9.94165382 -39.62661438 10.38534755 -33.75 13.1875 C-27.82922098 16.44117887 -24.16172853 20.77607297 -20 26 C-19.75765625 24.85402344 -19.5153125 23.70804687 -19.265625 22.52734375 C-18.92769264 20.99726113 -18.58911656 19.46732059 -18.25 17.9375 C-18.09273437 17.18533203 -17.93546875 16.43316406 -17.7734375 15.65820312 C-15.44648882 5.32118112 -11.54928041 -1.56499683 0 0 Z ",
    fill: "#FAF6F1",
    transform: "translate(922,278)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0370105 -0.00361794 1.0370105 -0.00361794 2.0949707 -0.00730896 C3.55067708 -0.00633331 5.00642186 0.00699336 6.46191406 0.03198242 C8.6816291 0.06631544 10.8973626 0.05262782 13.1171875 0.03320312 C14.53647516 0.04010211 15.95575262 0.04977499 17.375 0.0625 C18.65761719 0.07337646 19.94023438 0.08425293 21.26171875 0.09545898 C25.34169081 0.7307739 26.88655778 1.6172628 29.6875 4.62890625 C31.24658203 7.7109375 31.24658203 7.7109375 32.5703125 11.44140625 C32.81629181 12.13081299 33.06227112 12.82021973 33.31570435 13.53051758 C36.77589965 23.44087911 39.64023218 33.55053378 42.5625 43.62890625 C43.16090459 45.67594321 43.75985952 47.72281936 44.359375 49.76953125 C45.80841718 54.72083052 47.25005535 59.67422821 48.6875 64.62890625 C50.41187413 62.04234505 51.13155771 60.55741848 51.93676758 57.67089844 C52.27270683 56.48255402 52.27270683 56.48255402 52.61543274 55.27020264 C52.85191025 54.41404358 53.08838776 53.55788452 53.33203125 52.67578125 C53.58369553 51.78336731 53.8353598 50.89095337 54.09465027 49.97149658 C54.90147282 47.10868743 55.70132993 44.24399959 56.5 41.37890625 C58.52853159 34.11889844 60.57967581 26.86632855 62.6875 19.62890625 C63.0229483 18.46621216 63.0229483 18.46621216 63.36517334 17.2800293 C63.97748619 15.18650414 64.61419363 13.10239368 65.26171875 11.01953125 C65.787052 9.29524902 65.787052 9.29524902 66.32299805 7.53613281 C67.97150089 4.02381006 69.34235189 2.58918937 72.6875 0.62890625 C76.02148438 0.09545898 76.02148438 0.09545898 79.78125 0.0625 C80.78496643 0.05320213 80.78496643 0.05320213 81.80895996 0.04371643 C83.21751457 0.03664245 84.62615321 0.03975006 86.03466797 0.05249023 C88.18223651 0.06637223 90.32545434 0.03224645 92.47265625 -0.00585938 C93.84635523 -0.00681061 95.22005962 -0.00495152 96.59375 0 C97.83447266 -0.0007251 99.07519531 -0.0014502 100.35351562 -0.00219727 C104.69228434 0.81910598 105.9527273 2.19789456 108.6875 5.62890625 C109.22869618 8.36997733 109.46785555 10.52133802 109.48730469 13.26416016 C109.51122662 14.00715174 109.53514854 14.75014332 109.55979538 15.5156498 C109.62830483 17.88695507 109.66065721 20.25679393 109.6875 22.62890625 C109.71706147 24.14427839 109.74720673 25.65963925 109.7779541 27.17498779 C109.85976599 31.93826951 109.8797638 36.70094367 109.890625 41.46484375 C109.89486607 42.74320036 109.89486607 42.74320036 109.89919281 44.04738235 C109.91399699 48.53126567 109.92335217 53.0151182 109.92773438 57.49902344 C109.93328566 62.12025947 109.9575036 66.74121067 109.98570633 71.36235619 C110.00427583 74.9361966 110.00953459 78.50996626 110.01107025 82.08385086 C110.01409496 83.78953282 110.0221174 85.49521358 110.03525543 87.20084763 C110.05224515 89.56951333 110.05045701 91.93745105 110.04394531 94.30615234 C110.0531601 95.0073671 110.06237488 95.70858185 110.0718689 96.43104553 C110.04737887 99.26420502 110.0116138 101.16871624 108.35272217 103.52407837 C104.79306826 105.88580821 101.45749309 105.79269347 97.3125 105.81640625 C96.19101562 105.83058594 95.06953125 105.84476563 93.9140625 105.859375 C89.58207107 105.54994704 86.77335122 104.71475747 83.6875 101.62890625 C83.4090271 98.69296265 83.4090271 98.69296265 83.36865234 94.88427734 C83.35860672 94.19148178 83.3485611 93.49868622 83.33821106 92.78489685 C83.30727447 90.49072107 83.29031524 88.19666252 83.2734375 85.90234375 C83.25473423 84.31335433 83.23516146 82.72437492 83.2147522 81.13540649 C83.16333591 76.94988907 83.12376123 72.76433942 83.08660889 68.57867432 C83.04662857 64.30887822 82.99550907 60.0392173 82.9453125 55.76953125 C82.84844085 47.38941512 82.76407228 39.00923232 82.6875 30.62890625 C82.42076477 31.50951721 82.15402954 32.39012817 81.87921143 33.29742432 C79.36192652 41.5999801 76.83250495 49.89871851 74.28941727 58.19340897 C72.9824495 62.45782243 71.68020198 66.72355906 70.38867188 70.99267578 C69.14185041 75.11338457 67.88272309 79.23014624 66.61501312 83.34447479 C66.1337844 84.91397875 65.65698806 86.48484887 65.18473053 88.0570755 C64.52192005 90.26091869 63.84344181 92.45935487 63.16113281 94.65722656 C62.58821503 96.53586395 62.58821503 96.53586395 62.00372314 98.45245361 C60.6414898 101.73994306 59.4793421 103.45359491 56.6875 105.62890625 C53.41015625 106.16015625 53.41015625 106.16015625 49.75 106.12890625 C48.54472656 106.13921875 47.33945312 106.14953125 46.09765625 106.16015625 C42.01318686 105.52385861 40.63371094 104.48706036 37.6875 101.62890625 C36.30244446 98.68264771 36.30244446 98.68264771 35.22387695 95.21142578 C35.02153442 94.57674377 34.81919189 93.94206177 34.61071777 93.28814697 C33.94957498 91.20069754 33.312694 89.10667516 32.67578125 87.01171875 C32.21839104 85.55160321 31.75947913 84.09196356 31.29911804 82.63278198 C30.0930483 78.79603554 28.90735481 74.95328883 27.72595215 71.10888672 C26.52391172 67.2094813 25.30334568 63.31589164 24.08398438 59.421875 C22.71284881 55.03927382 21.34376958 50.65609593 19.98762512 46.26882935 C19.78056442 45.59901031 19.57350372 44.92919128 19.36016846 44.23907471 C18.80332889 42.4359616 18.24742994 40.63255809 17.69160461 38.82913208 C16.72542181 35.74976853 15.71805171 32.68726065 14.6875 29.62890625 C14.69860306 30.5072966 14.70970612 31.38568695 14.72114563 32.29069519 C14.82138774 40.57424128 14.89748523 48.85758328 14.94656086 57.14159679 C14.97263973 61.4004068 15.00800551 65.65871508 15.06469727 69.91723633 C15.11907963 74.02807345 15.14893341 78.13842843 15.16188622 82.24959755 C15.17111508 83.81692405 15.18913749 85.38422457 15.21615028 86.95134544 C15.25252658 89.14937433 15.25744225 91.34541904 15.25512695 93.54370117 C15.26623001 94.79390549 15.27733307 96.0441098 15.28877258 97.3321991 C14.51885381 101.55357354 13.03323935 103.02325998 9.6875 105.62890625 C6.09375 106.22265625 6.09375 106.22265625 2.1875 106.12890625 C0.8984375 106.11859375 -0.390625 106.10828125 -1.71875 106.09765625 C-5.70601533 105.57757816 -8.44619907 104.49520718 -11.3125 101.62890625 C-11.55758117 98.55256535 -11.7282966 95.50033972 -11.8515625 92.41796875 C-11.89278229 91.41351715 -11.93400208 90.40906555 -11.97647095 89.37417603 C-12.51190734 74.91471821 -12.60961335 60.44738287 -12.66259766 45.97949219 C-12.67612553 42.62994223 -12.704387 39.28097453 -12.74462891 35.93164062 C-12.79386217 31.82667208 -12.81869641 27.72224397 -12.82582474 23.61699295 C-12.83251474 22.06922013 -12.84767801 20.5214585 -12.87171555 18.97385788 C-12.90329863 16.82615326 -12.90342193 14.68059009 -12.89599609 12.53271484 C-12.90408295 11.31635345 -12.9121698 10.09999207 -12.92050171 8.84677124 C-11.54470278 1.56531933 -6.76248774 -0.00382301 0 0 Z ",
    fill: "#FCFDF6",
    transform: "translate(807.3125,433.37109375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.69600699 2.67798401 6.46300818 5.19451227 9 9 C9.69920885 13.79689791 9.71482085 17.77459282 7.25 22 C3.21036049 25.59079068 -0.28435307 26.62093639 -5.62890625 26.515625 C-10.1242759 25.53804873 -12.88717144 22.20614676 -16 19 C-22.52572225 12.7580048 -29.15977495 10.88584417 -38.0625 10.625 C-45.93126668 10.84722448 -52.91114466 12.85829993 -59 18 C-67.1903113 27.79625469 -69.03803178 38.55190907 -68.21142578 51.01025391 C-67.31568602 59.44013733 -64.45006675 68.24194446 -58 74 C-49.23512329 80.38819384 -40.4251611 81.21962719 -30 80 C-21.06740126 78.1257983 -14.46856248 73.69934272 -9.0625 66.375 C-7.95986295 63.91028188 -7.48782289 61.64567006 -7 59 C-7.73637695 59.02094727 -8.47275391 59.04189453 -9.23144531 59.06347656 C-12.57082442 59.14667144 -15.90998549 59.19867157 -19.25 59.25 C-20.40886719 59.28351563 -21.56773437 59.31703125 -22.76171875 59.3515625 C-23.87675781 59.36445313 -24.99179687 59.37734375 -26.140625 59.390625 C-27.16704102 59.41157227 -28.19345703 59.43251953 -29.25097656 59.45410156 C-32.71129955 58.88250292 -33.8576787 57.71712104 -36 55 C-36.53125 52.78125 -36.53125 52.78125 -36.5 50.5 C-36.5103125 49.7471875 -36.520625 48.994375 -36.53125 48.21875 C-35.74901957 44.95178761 -34.73902841 43.99131918 -32 42 C-28.6255383 41.41220363 -25.28832501 41.48759964 -21.87109375 41.5390625 C-20.88504654 41.53997894 -19.89899933 41.54089539 -18.8830719 41.5418396 C-16.80098652 41.54787585 -14.71890984 41.56362253 -12.63696289 41.58837891 C-9.44580185 41.62490498 -6.25580145 41.6293981 -3.06445312 41.62890625 C-1.04165661 41.63873678 0.98113203 41.6503935 3.00390625 41.6640625 C4.43833824 41.66740097 4.43833824 41.66740097 5.90174866 41.67080688 C6.78954514 41.68356659 7.67734161 41.69632629 8.59204102 41.70947266 C9.37273453 41.71709625 10.15342804 41.72471985 10.95777893 41.73257446 C13 42 13 42 16 44 C16.93630677 46.8089203 17.14110975 48.5885588 17.17700195 51.49975586 C17.19625481 52.8614817 17.19625481 52.8614817 17.21589661 54.25071716 C17.22328354 55.22887894 17.23067047 56.20704071 17.23828125 57.21484375 C17.246353 58.22213028 17.25442474 59.22941681 17.26274109 60.26722717 C17.27657119 62.39810468 17.28729815 64.52900424 17.29516602 66.65991211 C17.3124153 69.92148509 17.3563156 73.1820539 17.40039062 76.44335938 C17.41051454 78.51301338 17.41903158 80.58267599 17.42578125 82.65234375 C17.44328934 83.62848129 17.46079742 84.60461884 17.47883606 85.6103363 C17.45716726 92.35761111 17.45716726 92.35761111 15.16088867 95.58422852 C10.66478274 98.52998813 6.19388722 98.46553295 1 98 C-1.9375 97.0625 -1.9375 97.0625 -4 95 C-4.9974504 92.03914725 -5.56598252 89.08994534 -6 86 C-6.46148438 86.44730469 -6.92296875 86.89460937 -7.3984375 87.35546875 C-19.9101652 98.95230727 -32.90684188 100.60306854 -49.33984375 100.30859375 C-63.49588175 99.74664265 -75.53962936 93.46902475 -85.22265625 83.15234375 C-96.39945839 69.61735919 -99.33120282 53.09162856 -98 36 C-95.31254396 20.64310836 -88.08763288 8.49320972 -75.5546875 -0.81640625 C-53.30657475 -15.08810558 -22.12957253 -13.45717248 0 0 Z ",
    fill: "#FCFDF6",
    transform: "translate(638,442)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.02867187 -0.01417969 2.05734375 -0.02835937 3.1171875 -0.04296875 C7.08975769 0.26142299 9.86010472 0.95185744 12.75073242 3.77563477 C14.66751382 7.13962187 14.49888996 10.25289499 14.41796875 14.015625 C14.41494751 14.67997559 14.41192627 15.34432617 14.40881348 16.02880859 C14.39317697 18.49853157 14.35129284 20.96803221 14.3125 23.4375 C14.250625 28.965 14.18875 34.4925 14.125 40.1875 C28.975 40.1875 43.825 40.1875 59.125 40.1875 C58.92751484 29.22264194 58.92751484 29.22264194 58.67456055 18.2590332 C58.65994774 16.87713558 58.64720894 15.49521632 58.63671875 14.11328125 C58.61113892 13.40473999 58.58555908 12.69619873 58.5592041 11.96618652 C58.55576035 8.03548951 58.98335616 6.36480202 61.46801758 3.25463867 C66.3116886 -0.51374896 71.2198205 -0.32249277 77.125 0.1875 C81.25965177 1.28152282 83.68900257 2.53350385 86.125 6.1875 C86.3255115 9.2525973 86.40826813 12.2270993 86.3996582 15.29296875 C86.40476913 16.22493073 86.40988007 17.1568927 86.41514587 18.11709595 C86.42906621 21.20312896 86.42808344 24.28893929 86.42578125 27.375 C86.42966648 29.51586999 86.43400079 31.65673921 86.43876648 33.79760742 C86.44623369 38.28664651 86.44593351 42.77560695 86.44067383 47.26464844 C86.43487479 53.02522543 86.45181838 58.78548137 86.4750185 64.54600525 C86.48972874 68.96742646 86.4906313 73.38876984 86.48750877 77.81021118 C86.48802323 79.93454627 86.4932841 82.05888558 86.50332069 84.18319702 C86.51561693 87.14968935 86.5089347 90.11554952 86.49731445 93.08203125 C86.50495819 93.96420319 86.51260193 94.84637512 86.52047729 95.75527954 C86.51346298 96.56282684 86.50644867 97.37037415 86.4992218 98.20239258 C86.49938954 98.90366776 86.49955729 99.60494293 86.49973011 100.32746887 C86.00459917 102.78512822 85.07254489 103.65036383 83.125 105.1875 C79.67834258 106.33638581 76.88148095 106.3914347 73.25 106.4375 C72.03570313 106.46328125 70.82140625 106.4890625 69.5703125 106.515625 C65.85691722 106.16196831 64.06025723 105.43891594 61.125 103.1875 C58.53530758 99.30296137 58.87249671 96.08231607 58.9296875 91.58203125 C58.93170166 90.83804077 58.93371582 90.09405029 58.93579102 89.32751465 C58.94624532 86.55161361 58.97416797 83.77580053 59 81 C59.04125 74.791875 59.0825 68.58375 59.125 62.1875 C44.605 62.5175 30.085 62.8475 15.125 63.1875 C15.24351764 75.13924402 15.24351764 75.13924402 15.39526367 87.09057617 C15.40403042 88.59553386 15.41167391 90.10049869 15.41796875 91.60546875 C15.43331665 92.3787854 15.44866455 93.15210205 15.46447754 93.94885254 C15.46669783 98.54560343 15.00599843 101.5418303 12.125 105.1875 C8.74877513 106.72898352 4.84518855 106.35548192 1.1875 106.375 C-0.62041016 106.39626953 -0.62041016 106.39626953 -2.46484375 106.41796875 C-5.78956949 106.19327365 -7.95549414 105.75954162 -10.875 104.1875 C-12.8987066 101.1519401 -13.1263262 100.56832242 -13.14242554 97.16442871 C-13.15095551 96.34846725 -13.15948547 95.5325058 -13.16827393 94.69181824 C-13.16736755 93.80029556 -13.16646118 92.90877289 -13.16552734 91.99023438 C-13.17224457 91.04851883 -13.17896179 90.10680328 -13.18588257 89.1365509 C-13.20490885 86.01806389 -13.20878883 82.89979147 -13.2109375 79.78125 C-13.2173612 77.6179597 -13.22408924 75.45467028 -13.23110962 73.29138184 C-13.24309327 68.75526921 -13.24678922 64.21923281 -13.24560547 59.68310547 C-13.24540199 53.86191833 -13.27272931 48.04121783 -13.30714989 42.22014618 C-13.32935065 37.75239807 -13.33344514 33.28476846 -13.33238602 28.81697083 C-13.33475131 26.67029642 -13.34362669 24.5236192 -13.35905075 22.3769989 C-13.37857671 19.37923732 -13.37292591 16.38254322 -13.36083984 13.38476562 C-13.37207886 12.49324295 -13.38331787 11.60172028 -13.39489746 10.68318176 C-13.3332594 4.6878995 -13.3332594 4.6878995 -11.03213501 2.1751709 C-7.1975634 0.41946494 -4.18519523 0.02609224 0 0 Z ",
    fill: "#FBFDF5",
    transform: "translate(687.875,432.8125)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.8001523 4.10679697 8.06297353 6.97296098 8.8984375 13.41796875 C8.31147011 18.28141282 6.93796236 19.64496719 3.4609375 23.04296875 C0.5164524 25.27671606 -2.71748977 25.64330291 -6.3984375 25.5546875 C-10.69913359 24.52660139 -13.46104501 21.04283345 -16.5390625 18.04296875 C-24.5576991 11.10496872 -31.77243421 9.4649506 -42.2890625 9.671875 C-49.26680437 10.46861235 -54.53240346 13.65141222 -59.4140625 18.60546875 C-66.69509174 27.83154836 -67.51476426 38.68387297 -66.5390625 50.04296875 C-65.29516508 58.83249185 -62.73532106 65.98760528 -55.58203125 71.5703125 C-46.86731824 77.31902376 -37.8165257 78.48491292 -27.6015625 76.4609375 C-21.07182307 74.42966913 -16.68801599 71.00783303 -11.828125 66.26171875 C-5.54395059 60.17057359 -5.54395059 60.17057359 -0.6015625 59.54296875 C3.62630123 59.75875764 6.20198269 61.32717307 9.4609375 64.04296875 C11.89366699 67.69206298 11.91092796 69.28868087 11.30078125 73.51171875 C8.38285121 82.30622417 -0.49152522 87.92700744 -8.125 92.3515625 C-24.26269491 100.34655323 -43.06726705 101.44764022 -60.17578125 96.2265625 C-74.12442914 91.31780488 -84.86240192 82.43267499 -91.5390625 69.04296875 C-97.99126087 52.94207007 -98.79983085 36.21175106 -92.3203125 19.9921875 C-86.02264348 6.22478329 -75.83756764 -2.97099809 -61.7265625 -8.33203125 C-42.514042 -15.01717454 -16.28504906 -12.55201473 0 0 Z ",
    fill: "#FBFDF5",
    transform: "translate(1029.5390625,442.95703125)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.04897461 0.17789062 1.04897461 0.17789062 2.11914062 0.359375 C6.91252453 1.27410869 10.29272222 2.79187756 14.1875 5.875 C16.83432276 9.93346157 17.95806791 13.05895054 17.1875 17.875 C14.24663506 25.13804522 8.65707295 28.85507118 2.1875 32.875 C2.82816406 33.143125 3.46882812 33.41125 4.12890625 33.6875 C11.6860554 37.11130528 16.55923951 41.27554414 20.6875 48.5 C21.5873356 52.7742191 20.83579469 55.74048429 18.6875 59.5 C15.18300784 62.82926755 10.17476293 65.875 5.1875 65.875 C4.8575 66.535 4.5275 67.195 4.1875 67.875 C3.5275 66.555 2.8675 65.235 2.1875 63.875 C1.5275 64.535 0.8675 65.195 0.1875 65.875 C-1.80071313 66.27264263 -3.80194339 66.61275349 -5.8125 66.875 C-6.4725 64.895 -7.1325 62.915 -7.8125 60.875 C-6.42224609 61.10896484 -6.42224609 61.10896484 -5.00390625 61.34765625 C-3.20759766 61.63962891 -3.20759766 61.63962891 -1.375 61.9375 C-0.18003906 62.13472656 1.01492188 62.33195312 2.24609375 62.53515625 C3.21675781 62.64730469 4.18742188 62.75945312 5.1875 62.875 C5.5175 62.545 5.8475 62.215 6.1875 61.875 C5.18009766 61.98328125 5.18009766 61.98328125 4.15234375 62.09375 C0.19787477 61.80198417 -2.80122341 60.18771164 -6.25 58.375 C-7.30453369 57.8346814 -7.30453369 57.8346814 -8.38037109 57.28344727 C-14.13590256 54.30468458 -19.74254439 51.09667518 -25.3359375 47.82421875 C-27.7876009 46.44963444 -30.19969955 45.17184523 -32.7265625 43.95703125 C-33.36835449 43.64838135 -34.01014648 43.33973145 -34.67138672 43.02172852 C-36.45772506 42.1746822 -38.2520834 41.34460946 -40.046875 40.515625 C-42.88485358 38.83207839 -43.77107554 37.94586698 -44.8125 34.875 C-43.8125 33.875 -43.8125 33.875 -42.05979919 33.75474548 C-41.29812943 33.75696609 -40.53645966 33.75918671 -39.75170898 33.76147461 C-38.89089218 33.76155014 -38.03007538 33.76162567 -37.14317322 33.76170349 C-36.20776199 33.76686478 -35.27235077 33.77202606 -34.30859375 33.77734375 C-33.35557877 33.7787587 -32.40256378 33.78017365 -31.42066956 33.78163147 C-28.36374835 33.78724848 -25.30689923 33.79980384 -22.25 33.8125 C-20.18294376 33.81751281 -18.11588638 33.82207609 -16.04882812 33.82617188 C-10.97002412 33.83722344 -5.8912743 33.85449945 -0.8125 33.875 C-1.1425 32.885 -1.4725 31.895 -1.8125 30.875 C-0.1625 30.215 1.4875 29.555 3.1875 28.875 C1.88232422 29.03726074 0.57714844 29.19952148 -0.76757812 29.36669922 C-5.3721839 29.87646114 -9.90214048 30.02051178 -14.53125 30.0078125 C-15.70717712 30.00924759 -15.70717712 30.00924759 -16.90686035 30.01071167 C-18.543702 30.01138596 -20.18054645 30.00958473 -21.81738281 30.00537109 C-24.33404398 29.99995362 -26.85053136 30.00537096 -29.3671875 30.01171875 C-30.96354206 30.01105897 -32.55989651 30.00977988 -34.15625 30.0078125 C-35.28734192 30.01084885 -35.28734192 30.01084885 -36.44128418 30.01394653 C-41.69750941 29.98999059 -41.69750941 29.98999059 -42.8125 28.875 C-43.65629112 23.89663242 -43.65629112 23.89663242 -42.8125 20.875 C-37.16019917 15.45176564 -29.1159109 12.58653517 -22 9.625 C-19.97232733 8.76640136 -17.94497045 7.90705647 -15.91796875 7.046875 C-15.03262451 6.6765918 -14.14728027 6.30630859 -13.23510742 5.92480469 C-11.05100879 4.97835461 -8.92887557 3.96315824 -6.8125 2.875 C-8.1325 2.215 -9.4525 1.555 -10.8125 0.875 C-6.88413398 -1.74391068 -4.36879251 -0.871382 0 0 Z ",
    fill: "#FC7285",
    transform: "translate(986.8125,331.125)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.88846448 0.72406031 15.57518378 1.52851441 22 8 C22.94875 8.9075 23.8975 9.815 24.875 10.75 C27.70433512 15.07721843 28.99261275 18.80676331 29 24 C28.03150459 27.84964759 26.65737695 31.39760216 25 35 C25.99 34.67 26.98 34.34 28 34 C28 34.66 28 35.32 28 36 C25 37 25 37 22 36 C21.67128906 36.44730469 21.34257813 36.89460938 21.00390625 37.35546875 C17.63672308 41.63516769 14.41639273 44.2163813 9.5703125 46.6640625 C5.50215269 48.77851639 1.67066836 51.29288429 -2.203125 53.7421875 C-5.37807874 55.17002983 -6.74315301 55.05788096 -10 54 C-9.59343737 48.11408196 -7.00259693 44.51257389 -3.75 39.8125 C3.69226448 29.67625982 3.69226448 29.67625982 7 18 C6.5153125 18.89460938 6.030625 19.78921875 5.53125 20.7109375 C1.28862699 28.411106 -3.28197456 35.2849239 -9 42 C-10.02287109 43.36318359 -10.02287109 43.36318359 -11.06640625 44.75390625 C-13 47 -13 47 -15.6875 47.375 C-18 47 -18 47 -19 46 C-18.64215719 39.14697258 -17.03868362 33.69706127 -14.3125 27.4375 C-13.98572266 26.63892578 -13.65894531 25.84035156 -13.32226562 25.01757812 C-11.21261631 20.06817143 -8.70398022 15.92357192 -5.35620117 11.71118164 C-2.59007263 8.27572333 -2.59007263 8.27572333 -2 4 C-1 1.8125 -1 1.8125 0 0 Z ",
    fill: "#FC7084",
    transform: "translate(948,293)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.01148588 2.40936821 8.63583144 5.96147055 11 11 C12.2664912 15.62522585 13.19384768 20.27450551 14 25 C17.26011642 24.30621489 18.79038253 23.54106009 21 21 C21.66 21.33 22.32 21.66 23 22 C20.22237877 25.60062011 17.26008643 28.83047153 14 32 C13.01 31.67 12.02 31.34 11 31 C10.85304688 31.69222656 10.70609375 32.38445312 10.5546875 33.09765625 C9.13704285 39.28152 7.35543586 45.25419768 5.125 51.1875 C4.89280762 51.84693604 4.66061523 52.50637207 4.42138672 53.18579102 C3.6953125 55.04296875 3.6953125 55.04296875 2 58 C-0.475 58.495 -0.475 58.495 -3 59 C-3 46.46 -3 33.92 -3 21 C-3.66 21 -4.32 21 -5 21 C-4.97679687 21.69480469 -4.95359375 22.38960938 -4.9296875 23.10546875 C-4.79881706 30.4809529 -5.20797704 37.71955182 -5.875 45.0625 C-5.95347168 45.97862061 -6.03194336 46.89474121 -6.11279297 47.83862305 C-6.23871826 49.14246948 -6.23871826 49.14246948 -6.3671875 50.47265625 C-6.44050293 51.24875244 -6.51381836 52.02484863 -6.58935547 52.82446289 C-7.03180849 55.1685169 -7.84011082 56.92641063 -9 59 C-12.875 58.125 -12.875 58.125 -14 57 C-14.41055077 54.06021676 -14.76089412 51.13892898 -15.0625 48.1875 C-15.15192871 47.33051514 -15.24135742 46.47353027 -15.33349609 45.59057617 C-15.97915536 39.04605085 -16.23629777 32.57695446 -16 26 C-16.66 26 -17.32 26 -18 26 C-18 27.98 -18 29.96 -18 32 C-19.32 30.68 -20.64 29.36 -22 28 C-21.67 27.34 -21.34 26.68 -21 26 C-20.67 26 -20.34 26 -20 26 C-19.75765625 24.85402344 -19.5153125 23.70804687 -19.265625 22.52734375 C-18.92769264 20.99726113 -18.58911656 19.46732059 -18.25 17.9375 C-18.09273437 17.18533203 -17.93546875 16.43316406 -17.7734375 15.65820312 C-15.44648882 5.32118112 -11.54928041 -1.56499683 0 0 Z ",
    fill: "#FC6E82",
    transform: "translate(922,278)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.94049267 2.14824367 6.83754972 4.41464134 9.75 7.8125 C9.42 8.4725 9.09 9.1325 8.75 9.8125 C8.255 8.3275 8.255 8.3275 7.75 6.8125 C7.09 6.8125 6.43 6.8125 5.75 6.8125 C6.13671875 7.37195313 6.5234375 7.93140625 6.921875 8.5078125 C14.47427956 20.13552448 16.36979701 32.23925327 16.75 45.8125 C14.275 46.3075 14.275 46.3075 11.75 46.8125 C4.16855773 36.31694086 -2.68517512 25.51469321 -8.25 13.8125 C-6.1164949 20.89284403 -3.19651962 27.12801098 0.3125 33.625 C1.2931125 35.46476714 2.27358666 37.30460802 3.25390625 39.14453125 C3.90081421 40.34686401 3.90081421 40.34686401 4.56079102 41.57348633 C4.95322998 42.31236084 5.34566895 43.05123535 5.75 43.8125 C6.13921631 44.51205811 6.52843262 45.21161621 6.92944336 45.93237305 C8.05062576 48.5013185 7.48387318 50.17055655 6.75 52.8125 C1.69037665 52.45043521 -0.85692076 49.75322495 -4.1875 46.25 C-4.71674072 45.70351807 -5.24598145 45.15703613 -5.79125977 44.59399414 C-13.1747589 36.8713116 -21.54249916 27.42547293 -21.5625 16.125 C-21.459375 15.031875 -21.35625 13.93875 -21.25 12.8125 C-21.91 12.8125 -22.57 12.8125 -23.25 12.8125 C-23.25 14.7925 -23.25 16.7725 -23.25 18.8125 C-23.58 18.8125 -23.91 18.8125 -24.25 18.8125 C-24.62711864 11.64724585 -23.44147726 6.96274856 -19.25 0.9375 C-14.15295282 -4.47811263 -6.08402636 -2.90105293 0 0 Z ",
    fill: "#FD7084",
    transform: "translate(888.25,291.1875)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.0198034 0.99635055 27.4964247 11.94410136 35.4375 20.375 C40.12732633 26.08520695 44.57211454 32.13006083 44.0625 39.8125 C43.33348172 43.74225569 41.90134655 46.18398717 39 49 C35.91220132 51.05853246 33.87871995 51.73042233 30.16552734 51.62866211 C22.43539327 49.3845702 17.01047291 37.6977737 13.0625 31.25 C8.43269784 23.79000732 3.68487764 16.55412312 -1.62109375 9.55859375 C-3 7 -3 7 -2.84765625 4.28515625 C-2 2 -2 2 0 0 Z ",
    fill: "#FE6E84",
    transform: "translate(937,372)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.4430689 2.4929947 5.8598892 5.46196591 7.76953125 9.28125 C8.27917201 15.39693908 7.86954523 18.42597029 3.76953125 23.28125 C-1.00518216 28.00363779 -5.21026378 30.33185241 -11.91796875 30.65625 C-18.33394096 30.49369929 -24.32887637 28.92387673 -29.15625 24.52734375 C-33.46317868 19.60367111 -34.59832061 16.37266911 -34.50390625 9.8203125 C-33.94907061 4.66826725 -31.25267412 2.16406373 -27.48046875 -1.09375 C-19.80132964 -5.04967015 -7.4045179 -3.96417784 0 0 Z ",
    fill: "#FEBD35",
    transform: "translate(929.23046875,344.71875)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.16047332 8.87668678 2.74190467 12.27201074 6.08984375 16.91796875 C9.22006981 20.32985115 12.79208585 22.17912079 17 24 C17.94875 24.433125 18.8975 24.86625 19.875 25.3125 C24.57178064 26.34579174 29.21136185 26.15337275 34 26 C30.66181821 22.34961416 26.53566273 19.58324424 22.5625 16.671875 C18.10887198 13.32661595 18.10887198 13.32661595 17 10 C21.1810556 11.50549203 24.74042527 13.57898174 28.5 15.9375 C30.15515625 16.97197266 30.15515625 16.97197266 31.84375 18.02734375 C33.40609375 19.00380859 33.40609375 19.00380859 35 20 C36.66409557 21.00427273 38.32976963 22.00596364 40 23 C39.54851905 20.748615 39.08855496 18.49893002 38.625 16.25 C38.36976563 14.99703125 38.11453125 13.7440625 37.8515625 12.453125 C37.1569875 9.63659152 36.44319917 7.48481248 35 5 C41.53631285 7.3603352 41.53631285 7.3603352 44 10 C45.98766257 16.54759434 44.32163026 20.53518866 41.421875 26.58203125 C38.76028065 31.10820406 36.33820423 32.45957196 31.328125 34.015625 C30.19479736 34.37664307 29.06146973 34.73766113 27.89379883 35.10961914 C26.09011841 35.67410767 26.09011841 35.67410767 24.25 36.25 C14.09602004 39.51625407 4.46461887 43.06952015 -5 48 C12.03712397 49.26548101 27.76385781 44.73745792 44 40 C44 44 44 44 42.51171875 46.08203125 C39.15531982 48.64500462 35.85288181 49.59482916 31.8125 50.6875 C31.04655518 50.90172607 30.28061035 51.11595215 29.49145508 51.33666992 C24.3307316 52.73975019 19.36280187 53.85427169 14 54 C13.0821875 54.05027344 12.164375 54.10054688 11.21875 54.15234375 C3.65813552 54.39592025 -5.51690935 54.19431715 -11.90234375 49.64453125 C-13 48 -13 48 -13.11328125 46.02734375 C-11.36529521 42.84416918 -8.39307716 41.92580044 -5.1875 40.5625 C-4.518396 40.264646 -3.84929199 39.96679199 -3.15991211 39.65991211 C-1.11381975 38.75541843 0.94078135 37.87414974 3 37 C4.20914063 36.484375 5.41828125 35.96875 6.6640625 35.4375 C9.43569224 34.27328321 12.21278918 33.12630307 15 32 C12.41994157 30.00736559 9.81557298 28.26375146 7 26.625 C3.57044715 24.48552103 1.1399266 22.50947963 -1 19 C-1.75 15.6875 -1.75 15.6875 -2 13 C-2.66 13 -3.32 13 -4 13 C-4.29543354 7.97762985 -4.00679573 5.0892422 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F0F7EE",
    transform: "translate(804,354)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.23542686 0.80353933 2.23542686 0.80353933 5.12890625 0.65625 C5.62390625 2.63625 5.62390625 2.63625 6.12890625 4.65625 C2.49890625 3.66625 -1.13109375 2.67625 -4.87109375 1.65625 C-4.071875 2.12933594 -3.27265625 2.60242188 -2.44921875 3.08984375 C3.48986952 6.66584408 9.32530684 10.33756522 14.94140625 14.40625 C15.93785156 15.12296875 16.93429687 15.8396875 17.9609375 16.578125 C18.67636719 17.26390625 19.39179687 17.9496875 20.12890625 18.65625 C20.12890625 19.97625 20.12890625 21.29625 20.12890625 22.65625 C13.12486948 23.11878073 7.69274947 21.5011264 1.12890625 19.15625 C0.16339844 18.82238281 -0.80210937 18.48851562 -1.796875 18.14453125 C-4.15899241 17.32597571 -6.516594 16.49641314 -8.87109375 15.65625 C-0.40763482 20.16699459 8.0557022 23.62290072 17.12890625 26.65625 C16.79890625 27.97625 16.46890625 29.29625 16.12890625 30.65625 C4.66162789 31.31221719 -8.75314575 30.54590311 -18.10546875 23.24609375 C-18.688125 22.72144531 -19.27078125 22.19679688 -19.87109375 21.65625 C-20.391875 21.20378906 -20.91265625 20.75132812 -21.44921875 20.28515625 C-26.08538379 15.58237965 -26.87109375 9.00212104 -26.87109375 2.65625 C-19.17337391 -4.61381873 -9.39235579 -3.2564187 0 0 Z ",
    fill: "#FE6E82",
    transform: "translate(869.87109375,328.34375)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.25 0.875 2.25 0.875 3.25 1.875 C3.64730635 9.68869158 2.47759637 17.16964066 1.25 24.875 C1.91 24.875 2.57 24.875 3.25 24.875 C3.28738281 24.19695312 3.32476563 23.51890625 3.36328125 22.8203125 C4.31211624 9.38778574 4.31211624 9.38778574 7.25 3.875 C9.35546875 3.1015625 9.35546875 3.1015625 11.25 2.875 C14.45674085 8.11776679 14.70926402 12.29534266 14.625 18.25 C14.63660156 19.06210937 14.64820313 19.87421875 14.66015625 20.7109375 C14.62677843 27.65352378 13.42069952 33.31468774 8.8125 38.75 C4.53286239 42.29896777 1.93858314 43.28859897 -3.7890625 43.12890625 C-7.66169651 42.62746958 -9.95044597 40.76022053 -12.5 37.9375 C-16.14034682 31.93092774 -15.28535895 23.90650582 -14.0625 17.25 C-12.49940992 11.01965504 -7.27816395 -0.33082563 0 0 Z ",
    fill: "#FE6E83",
    transform: "translate(903.75,378.125)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.92856812 0.19118689 4.53978648 0.60935801 6.79101562 2.52026367 C10.98119517 7.60535308 14.83171061 12.83916173 18.5 18.3125 C19.06098389 19.14555664 19.62196777 19.97861328 20.19995117 20.83691406 C21.30436938 22.48083314 22.40627574 24.12644318 23.50537109 25.77392578 C24.78208838 27.67544623 26.08028208 29.55797325 27.39453125 31.43359375 C30.09488181 35.39887431 31.85545643 38.17215957 32.6875 42.9375 C32 46 32 46 30.625 48.4375 C26.41439601 50.9438119 22.74695908 51.1029699 18 50 C8.64518712 44.92774756 4.23524082 34.52493091 0.9375 24.8984375 C-1.23137764 17.32822035 -2.40043232 9.87516896 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#FE6E84",
    transform: "translate(924,379)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-0.99 2.495 -0.99 2.495 -2 3 C-2.33 3.99 -2.66 4.98 -3 6 C-2.34 6 -1.68 6 -1 6 C-1 5.01 -1 4.02 -1 3 C3.1089256 4.36964187 4.00442476 6.22266115 6 10 C5.8455345 15.32538192 3.60761479 18.33483245 0.0625 22.0625 C-0.42822998 22.58618164 -0.91895996 23.10986328 -1.42456055 23.64941406 C-6.55509912 28.90432434 -11.92437716 32.20085827 -19.1875 33.625 C-23.26957937 32.71787125 -26.20923968 31.15011849 -29 28 C-30.84977039 21.83409869 -29.95276542 16.70047769 -27 11 C-20.68088292 1.88036512 -10.60006178 -0.69508602 0 0 Z ",
    fill: "#FE7085",
    transform: "translate(889,362)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.56847656 0.19335938 1.13695312 0.38671875 1.72265625 0.5859375 C6.45364938 2.18136423 11.18794425 3.66900586 16 5 C15.278125 5.66 14.55625 6.32 13.8125 7 C8.62349968 12.18900032 4.38210914 18.94964308 3.6875 26.3125 C4.17520916 32.06746804 5.5440046 37.11237136 10 41 C14.21141369 43.1658699 18.34855818 43.52697202 23 44 C23 44.33 23 44.66 23 45 C15.90922904 45.42544626 11.2609806 44.82030755 5.6875 40 C4 38 4 38 3 35 C2.505 35.99 2.505 35.99 2 37 C1.34 37 0.68 37 0 37 C-0.33 38.98 -0.66 40.96 -1 43 C-1.99 43 -2.98 43 -4 43 C-3.34 41.35 -2.68 39.7 -2 38 C-2.55042969 38.15855469 -3.10085938 38.31710937 -3.66796875 38.48046875 C-6.77076598 39.35117619 -9.88485883 40.17445534 -13 41 C-13.75635742 41.20882812 -14.51271484 41.41765625 -15.29199219 41.6328125 C-27.7660055 45.04954342 -39.06828699 46.71053368 -52 46 C-48.90906179 42.6592712 -45.29788293 41.05984509 -41.1875 39.25 C-40.41011475 38.90364502 -39.63272949 38.55729004 -38.83178711 38.20043945 C-31.45611011 35.01392047 -23.88358271 32.59115279 -16.17456055 30.34667969 C-15.28293213 30.08145508 -14.39130371 29.81623047 -13.47265625 29.54296875 C-12.68125244 29.31633545 -11.88984863 29.08970215 -11.07446289 28.85620117 C-7.11295617 27.22115303 -5.46986554 24.44773585 -3.8125 20.625 C-1.41611866 14.46547991 -1.63232132 8.51608334 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#228E3B",
    transform: "translate(850,357)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.4287704 2.4287704 -4.27007026 2.88474386 -7.5390625 3.91796875 C-8.66916748 4.28156494 -9.79927246 4.64516113 -10.96362305 5.01977539 C-12.77600464 5.59779907 -12.77600464 5.59779907 -14.625 6.1875 C-25.05142648 9.59192194 -35.127601 13.22644517 -45 18 C-45.64404785 18.30760254 -46.2880957 18.61520508 -46.95166016 18.93212891 C-51.68044763 21.20153239 -56.35395677 23.56598269 -61 26 C-61.67595215 26.35320312 -62.3519043 26.70640625 -63.04833984 27.0703125 C-86.00891104 39.19096532 -109.5122923 57.00352088 -118.4375 82.25 C-122.30303905 96.23956989 -120.37742024 109.92396086 -113.6875 122.75 C-111.27113695 126.83516378 -108.37696912 130.4994851 -105.35546875 134.15234375 C-104 136 -104 136 -104 138 C-103.13375 138.3403125 -103.13375 138.3403125 -102.25 138.6875 C-100 140 -100 140 -98.14453125 142.328125 C-84.43750739 159.40572849 -60.37246714 169.29118135 -41 178 C-40.28924316 178.32194336 -39.57848633 178.64388672 -38.84619141 178.97558594 C-26.36712639 184.5444302 -13.07148096 188.11167627 0 192 C0 192.33 0 192.66 0 193 C-7.72404474 192.47799486 -14.50245723 190.48826005 -21.8125 188 C-23.00085449 187.59845703 -24.18920898 187.19691406 -25.41357422 186.78320312 C-60.22158414 174.77624262 -98.86201579 155.7134276 -117 122 C-118.16090743 119.02644763 -119.06787814 116.05528831 -120 113 C-120.99 112.67 -121.98 112.34 -123 112 C-122.505 111.505 -122.505 111.505 -122 111 C-122.66 110.34 -123.32 109.68 -124 109 C-124.33 108.01 -124.66 107.02 -125 106 C-124.01 105.505 -124.01 105.505 -123 105 C-123.01160156 103.96359375 -123.02320313 102.9271875 -123.03515625 101.859375 C-123.04453837 100.48958514 -123.05363812 99.11979332 -123.0625 97.75 C-123.07506836 96.72712891 -123.07506836 96.72712891 -123.08789062 95.68359375 C-123.10428392 92.30657446 -123.05628768 89.22708361 -122 86 C-122.66 85.67 -123.32 85.34 -124 85 C-123.01 85 -122.02 85 -121 85 C-121.061875 84.113125 -121.12375 83.22625 -121.1875 82.3125 C-120.97133906 78.49365669 -120.04523032 77.18300485 -118 74 C-117.39285156 72.9790625 -116.78570312 71.958125 -116.16015625 70.90625 C-106.65166852 55.28958495 -93.97066845 42.13462532 -78 33 C-78.33 32.34 -78.66 31.68 -79 31 C-77.9466748 30.84615845 -77.9466748 30.84615845 -76.87207031 30.68920898 C-73.56423968 29.89543086 -71.03589624 28.59697179 -68.046875 26.97265625 C-66.87094482 26.34295312 -65.69465992 25.71391205 -64.51806641 25.08544922 C-63.90392883 24.75510681 -63.28979126 24.4247644 -62.65704346 24.08441162 C-48.81885238 16.6690545 -34.76088647 10.38915168 -20 5 C-19.19208008 4.70351563 -18.38416016 4.40703125 -17.55175781 4.1015625 C-5.40934866 -0.30051937 -5.40934866 -0.30051937 0 0 Z ",
    fill: "#196425",
    transform: "translate(599,401)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.17026043 0.55728247 7.55381675 1.50106982 11.3515625 3.30078125 C12.35880371 3.77797607 13.36604492 4.2551709 14.40380859 4.74682617 C15.46680176 5.26349854 16.52979492 5.7801709 17.625 6.3125 C18.72279785 6.84141846 19.8205957 7.37033691 20.95166016 7.9152832 C30.7284297 12.70752621 40.03385028 18.1409399 49.22021484 23.9753418 C51.13204382 25.15472662 51.13204382 25.15472662 54 26 C55.35646909 27.30978898 56.68787623 28.64578924 58 30 C59.35715755 31.08519797 60.73300917 32.14735925 62.125 33.1875 C78.05439442 45.44894176 92.57782511 60.68132024 97 81 C98.1292511 103.10726198 91.33948291 116.47210452 77.171875 133.15234375 C64.81531649 146.31597477 48.78908441 155.61521856 33 164 C32.09362793 164.49113281 31.18725586 164.98226562 30.25341797 165.48828125 C29.36412598 165.95621094 28.47483398 166.42414063 27.55859375 166.90625 C26.75607178 167.33228516 25.9535498 167.75832031 25.12670898 168.19726562 C23 169 23 169 20 168 C21.16273437 167.40574219 22.32546875 166.81148437 23.5234375 166.19921875 C39.26854629 158.07961073 54.6572564 149.76771485 68 138 C69.06927734 137.12794922 69.06927734 137.12794922 70.16015625 136.23828125 C81.16965402 127.13794494 92.59028918 112.60269371 94.22753906 97.96582031 C95.38365687 81.52567973 91.30940354 67.32978868 80.86328125 54.34375 C78.6383524 51.8276001 76.34059936 49.4085007 74 47 C73.34773438 46.27425781 72.69546875 45.54851562 72.0234375 44.80078125 C55.60655678 27.14788055 32.02989311 16.2116885 10.54248047 6.20019531 C6.99705877 4.52655472 3.49748133 2.77139808 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#196024",
    transform: "translate(1011,407)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C43.89 0 87.78 0 133 0 C133 0.33 133 0.66 133 1 C106.68688753 3.6225313 80.51643033 4.13575985 54.09472656 3.96337891 C53.17742264 3.95907867 52.26011871 3.95477844 51.3150177 3.9503479 C49.57434007 3.9419488 47.8336762 3.92940728 46.09306335 3.91220093 C41.9138266 3.77744794 41.9138266 3.77744794 38 5 C38 4.34 38 3.68 38 3 C36.43765625 3.01740234 36.43765625 3.01740234 34.84375 3.03515625 C9.8038966 3.22645743 9.8038966 3.22645743 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#165F21",
    transform: "translate(721,614)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.2475 0.53625 0.495 1.0725 0.75 1.625 C2.29814886 4.56648283 4.13010957 7.25359843 6 10 C6.99 11.485 6.99 11.485 8 13 C5.11005281 11.8646636 4.09717758 11.16098445 2.45581055 8.44189453 C-0.25853422 5.74293078 -0.68993668 5.63103924 -4.30541992 5.47216797 C-6.05180928 5.49342417 -7.7980021 5.54357382 -9.54296875 5.6171875 C-10.477957 5.63820526 -11.41294525 5.65922302 -12.37626648 5.68087769 C-15.25289454 5.75636095 -18.1252885 5.87156939 -21 6 C-22.240914 6.05057556 -22.240914 6.05057556 -23.50689697 6.10217285 C-29.11668053 6.3429856 -34.71298004 6.71283915 -40.3125 7.125 C-41.61241882 7.21704208 -41.61241882 7.21704208 -42.93859863 7.3109436 C-60.54921465 8.57608778 -78.03713465 10.69708059 -95.53637695 13.01806641 C-96.52497208 13.14853867 -97.5135672 13.27901093 -98.53211975 13.41343689 C-100.38011378 13.65880031 -102.22760201 13.90801758 -104.07444763 14.16188049 C-108.42082686 14.74311885 -112.60177765 15.13828355 -117 15 C-114.31197076 12.31197076 -112.41121291 12.40221854 -108.66015625 11.8515625 C-107.67526215 11.70553841 -107.67526215 11.70553841 -106.67047119 11.55656433 C-104.46921964 11.23518543 -102.26623441 10.92886305 -100.0625 10.625 C-99.29747162 10.51739349 -98.53244324 10.40978699 -97.74423218 10.29891968 C-70.19643778 6.44772561 -42.41127201 4.01903203 -14.63012695 2.68286133 C-13.42445068 2.61993896 -12.21877441 2.5570166 -10.9765625 2.4921875 C-9.93580566 2.44433105 -8.89504883 2.39647461 -7.82275391 2.34716797 C-4.91643488 1.9897224 -2.6547035 1.21000837 0 0 Z ",
    fill: "#1A6625",
    transform: "translate(801,367)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.34 1.99 0.68 2.98 0 4 C0.97610229 4.029729 0.97610229 4.029729 1.97192383 4.06005859 C4.91919151 4.15529299 7.86574885 4.26497818 10.8125 4.375 C12.34874023 4.42140625 12.34874023 4.42140625 13.91601562 4.46875 C14.89892578 4.50742187 15.88183594 4.54609375 16.89453125 4.5859375 C17.80050049 4.6173584 18.70646973 4.6487793 19.63989258 4.68115234 C22 5 22 5 25 7 C24.30551758 7.01458252 23.61103516 7.02916504 22.89550781 7.04418945 C19.67984235 7.11969836 16.46510173 7.21601054 13.25 7.3125 C12.15816406 7.33505859 11.06632813 7.35761719 9.94140625 7.38085938 C-0.21474451 7.71138499 -9.67308781 9.27939647 -18.625 14.25 C-20.38754632 15.22148222 -22.17338585 16.15511658 -24 17 C-24.66 16.67 -25.32 16.34 -26 16 C-25.67 14.68 -25.34 13.36 -25 12 C-27.97 12 -30.94 12 -34 12 C-34 11.67 -34 11.34 -34 11 C-33.27554688 10.84144531 -32.55109375 10.68289063 -31.8046875 10.51953125 C-25.28828589 9.09459837 -25.28828589 9.09459837 -20 5.3125 C-16.03043945 2.25263041 -13.4819608 2.76983473 -8.62890625 3.02734375 C-5.18728947 2.99154684 -2.92567516 1.72539817 0 0 Z ",
    fill: "#137A25",
    transform: "translate(979,425)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 24.75 1 49.5 1 75 C0.67 75 0.34 75 0 75 C-0.33 54.21 -0.66 33.42 -1 12 C-5.3399238 26.32704415 -5.3399238 26.32704415 -9.67431641 40.65576172 C-12.47719803 49.90453746 -15.314233 59.14034197 -18.3359375 68.3203125 C-18.57688141 69.0607077 -18.81782532 69.80110291 -19.06607056 70.56393433 C-20.11697278 73.71289765 -21.14573961 76.21860942 -23 79 C-23.66 78.67 -24.32 78.34 -25 78 C-24.15634888 76.23523315 -24.15634888 76.23523315 -23.2956543 74.43481445 C-20.36763087 67.8337666 -18.36255111 60.94050283 -16.26953125 54.04296875 C-15.8297028 52.60795608 -15.38940204 51.1730881 -14.94865417 49.73835754 C-13.79816193 45.98832202 -12.65460934 42.23620484 -11.51239014 38.48364258 C-10.57766137 35.41706056 -9.63790907 32.35202912 -8.69791126 29.28705883 C-7.5742557 25.62288065 -6.45282692 21.9580226 -5.33203125 18.29296875 C-5.1192988 17.59752645 -4.90656635 16.90208416 -4.68738747 16.18556786 C-4.08572896 14.21676488 -3.48557984 12.24750889 -2.88598633 10.27807617 C-2.54497391 9.15938644 -2.20396149 8.04069672 -1.85261536 6.8881073 C-1.1771584 4.60009763 -0.55151344 2.32024125 0 0 Z ",
    fill: "#0C6211",
    transform: "translate(890,460)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.89731072 19.34203104 -6.71441848 31.8902662 -18.828125 46.15234375 C-31.18468351 59.31597477 -47.21091559 68.61521856 -63 77 C-64.35955811 77.73669922 -64.35955811 77.73669922 -65.74658203 78.48828125 C-66.63587402 78.95621094 -67.52516602 79.42414063 -68.44140625 79.90625 C-69.24392822 80.33228516 -70.0464502 80.75832031 -70.87329102 81.19726562 C-73 82 -73 82 -76 81 C-74.83726563 80.40574219 -73.67453125 79.81148437 -72.4765625 79.19921875 C-56.73145371 71.07961073 -41.3427436 62.76771485 -28 51 C-27.28714844 50.41863281 -26.57429688 49.83726562 -25.83984375 49.23828125 C-10.35644643 36.43986612 -2.37382824 19.64655212 0 0 Z ",
    fill: "#165B21",
    transform: "translate(1107,494)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.08636719 0.68964844 2.17273438 1.37929688 2.26171875 2.08984375 C4.5250732 17.22732445 14.19667157 27.71385219 25 38 C24.01 38.99 23.02 39.98 22 41 C21.51273438 40.67128906 21.02546875 40.34257812 20.5234375 40.00390625 C13.41403283 35.23414203 6.21011834 30.61529623 -1 26 C2.40931897 24.86356034 3.00335456 25.13252236 6.1875 26.4375 C7.26064453 26.86869141 7.26064453 26.86869141 8.35546875 27.30859375 C9.16951172 27.65083984 9.16951172 27.65083984 10 28 C10 27.01 10 26.02 10 25 C9.39542969 24.77183594 8.79085937 24.54367187 8.16796875 24.30859375 C5.37655985 22.62368928 4.67820046 20.99638648 3.3125 18.0625 C2.89613281 17.18722656 2.47976563 16.31195313 2.05078125 15.41015625 C0.41714365 11.66311387 -0.11519198 8.8697824 -0.0625 4.8125 C-0.05347656 3.91144531 -0.04445313 3.01039063 -0.03515625 2.08203125 C-0.02355469 1.39496094 -0.01195312 0.70789063 0 0 Z ",
    fill: "#FCF0EC",
    transform: "translate(865,304)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 0.5625 3 0.5625 5.375 2.125 C7.64970619 5.53705929 7.63534983 7.53861774 7 11.5625 C4.875 14.5625 4.875 14.5625 2 16.5625 C-1.55953149 16.63369063 -3.22119455 16.2634249 -5.875 13.875 C-7.36633241 10.80948338 -7.48231822 8.93872756 -7 5.5625 C-5.00082867 2.02550457 -4.03889466 0.75729275 0 0 Z ",
    fill: "#E9F3E8",
    transform: "translate(1004,555.4375)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-23.90601157 15.29446519 -69.59765223 28.73891925 -98 27 C-95.02928256 25.01952171 -93.69719365 24.60941564 -90.28515625 24.0625 C-89.30675781 23.89500244 -88.32835937 23.72750488 -87.3203125 23.55493164 C-86.24523437 23.3718042 -85.17015625 23.18867676 -84.0625 23 C-57.60074258 18.20475153 -29.7634103 11.04308744 -5.28515625 -0.21484375 C-3 -1 -3 -1 0 0 Z ",
    fill: "#186023",
    transform: "translate(1030,577)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.84380195 2.61322341 3.8891602 4.22412143 4.4375 8.0625 C3.93406086 11.44273423 3.66803551 12.83222115 1 15 C-1.77515685 15.56659452 -4.22422681 15.5609375 -7 15 C-9.90460477 12.73077752 -9.97856495 11.15004537 -10.5 7.5 C-10 4 -10 4 -7.8125 1.5625 C-4.74756952 -0.14023915 -3.41697468 -0.78853262 0 0 Z ",
    fill: "#E4F1E3",
    transform: "translate(909,556)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.33794538 1.16102448 4.3364746 1.83747557 5.875 5 C6.28495912 8.27967299 6.15792178 10.32806078 4.875 13.375 C2.16961574 15.57312471 0.16630645 15.57358548 -3.25 15.37890625 C-5.125 15 -5.125 15 -7.125 13.4375 C-8.52858168 10.01626965 -8.64806944 7.66148608 -8.125 4 C-5.45946825 0.86408029 -4.13747529 0 0 0 Z ",
    fill: "#E5F1E5",
    transform: "translate(947.125,556)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7 0 7 0 9.9375 1.5625 C12 4 12 4 12.5625 7.5 C12 11 12 11 10.5 13.4375 C6.86353539 15.71029038 4.24217465 15.28281164 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#F2F7F0",
    transform: "translate(671,556)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6.31626692 3.61973402 7 6.09567131 7 10 C7.66 10 8.32 10 9 10 C9.144375 8.906875 9.28875 7.81375 9.4375 6.6875 C10 3 10 3 11 0 C12.65 0 14.3 0 16 0 C16 4.95 16 9.9 16 15 C15.01 15 14.02 15 13 15 C12.67 12.69 12.34 10.38 12 8 C11.34 10.31 10.68 12.62 10 15 C8.68 15 7.36 15 6 15 C5.01 11.7 4.02 8.4 3 5 C2.67 8.3 2.34 11.6 2 15 C1.01 15 0.02 15 -1 15 C-0.67 10.05 -0.34 5.1 0 0 Z ",
    fill: "#E6F2E5",
    transform: "translate(772,556)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-1.17989502 1.22550537 -2.35979004 1.45101074 -3.57543945 1.68334961 C-9.15711833 2.7545399 -14.73547023 3.84237778 -20.3125 4.9375 C-21.82756134 5.23488068 -21.82756134 5.23488068 -23.37322998 5.53826904 C-38.92667302 8.60972007 -54.28410213 12.14457971 -69.5715332 16.34350586 C-70.2605925 16.53012283 -70.94965179 16.71673981 -71.65959167 16.90901184 C-73.49549023 17.40798975 -75.32821187 17.91861638 -77.16064453 18.43017578 C-80 19 -80 19 -83 18 C-76.40612465 15.37833872 -69.72886473 13.44829072 -62.875 11.625 C-61.18020508 11.17036377 -61.18020508 11.17036377 -59.45117188 10.70654297 C-50.90357408 8.44049683 -42.31894186 6.39314052 -33.67919922 4.51025391 C-32.39940186 4.23060791 -32.39940186 4.23060791 -31.09375 3.9453125 C-29.97516602 3.70578857 -29.97516602 3.70578857 -28.83398438 3.46142578 C-26.92050007 3.05002632 -26.92050007 3.05002632 -25 2 C-23.42110238 1.79553844 -21.83638095 1.63460202 -20.25 1.5 C-17.43184493 1.24600319 -14.72305219 0.94913203 -11.9375 0.4375 C-7.94881615 -0.1565593 -4.02458016 -0.0804916 0 0 Z ",
    fill: "#176123",
    transform: "translate(683,382)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.423125 -0.061875 2.84625 -0.12375 4.3125 -0.1875 C5.51326172 -0.23970703 5.51326172 -0.23970703 6.73828125 -0.29296875 C9 0 9 0 10.765625 1.26171875 C12.63637468 3.89616054 12.4843298 5.98098363 12.33984375 9.125 C12 11 12 11 10.5 13 C6.87920862 14.44831655 3.88716564 14.19435828 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#ECF5EC",
    transform: "translate(751,557)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.37042925 -0.36248013 7.37042925 -0.36248013 10.0625 1.1875 C11.38486778 3.74407771 10.65621888 5.2438807 10 8 C10.185625 8.886875 10.37125 9.77375 10.5625 10.6875 C10.706875 11.450625 10.85125 12.21375 11 13 C9 15 9 15 6.8359375 15.1953125 C4.55729167 15.13020833 2.27864583 15.06510417 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#A8CAA8",
    transform: "translate(723,556)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.66327442 2.66327442 -4.53668727 2.60745793 -8.24609375 3.18359375 C-9.54554932 3.38766846 -10.84500488 3.59174316 -12.18383789 3.80200195 C-13.60160785 4.01461905 -15.01949842 4.22643317 -16.4375 4.4375 C-17.15163055 4.54605316 -17.86576111 4.65460632 -18.60153198 4.76644897 C-58.32070781 10.79956598 -58.32070781 10.79956598 -76 10 C-76 9.67 -76 9.34 -76 9 C-66.57476025 7.56683848 -57.18143429 6.48934399 -47.6875 5.625 C-36.70176536 4.58689658 -25.84918342 3.18339062 -14.98120117 1.27001953 C-9.8983657 0.38780696 -5.16019028 -0.20813007 0 0 Z ",
    fill: "#175F22",
    transform: "translate(931,604)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.98613281 0.00322266 1.97226562 0.00644531 2.98828125 0.00976562 C4.02082031 0.01814453 5.05335938 0.02652344 6.1171875 0.03515625 C7.67759766 0.04192383 7.67759766 0.04192383 9.26953125 0.04882812 C11.84380712 0.06063673 14.41796896 0.0771055 16.9921875 0.09765625 C16.9921875 0.42765625 16.9921875 0.75765625 16.9921875 1.09765625 C14.0221875 1.09765625 11.0521875 1.09765625 7.9921875 1.09765625 C7.9921875 6.37765625 7.9921875 11.65765625 7.9921875 17.09765625 C10.9621875 17.09765625 13.9321875 17.09765625 16.9921875 17.09765625 C16.9921875 17.42765625 16.9921875 17.75765625 16.9921875 18.09765625 C15.34644184 18.12453776 13.70057337 18.14399748 12.0546875 18.16015625 C11.13816406 18.17175781 10.22164062 18.18335938 9.27734375 18.1953125 C6.9921875 18.09765625 6.9921875 18.09765625 5.9921875 17.09765625 C5.91992248 15.24478123 5.9083753 13.38931747 5.9296875 11.53515625 C5.93871094 10.52324219 5.94773437 9.51132812 5.95703125 8.46875 C5.96863281 7.68628906 5.98023438 6.90382813 5.9921875 6.09765625 C5.3321875 6.09765625 4.6721875 6.09765625 3.9921875 6.09765625 C3.9921875 9.72765625 3.9921875 13.35765625 3.9921875 17.09765625 C3.6621875 17.09765625 3.3321875 17.09765625 2.9921875 17.09765625 C2.9921875 13.13765625 2.9921875 9.17765625 2.9921875 5.09765625 C3.9821875 5.09765625 4.9721875 5.09765625 5.9921875 5.09765625 C5.9921875 3.77765625 5.9921875 2.45765625 5.9921875 1.09765625 C2.6921875 1.09765625 -0.6078125 1.09765625 -4.0078125 1.09765625 C-4.0078125 2.41765625 -4.0078125 3.73765625 -4.0078125 5.09765625 C-3.0178125 5.09765625 -2.0278125 5.09765625 -1.0078125 5.09765625 C-1.0078125 8.72765625 -1.0078125 12.35765625 -1.0078125 16.09765625 C-4.0078125 15.09765625 -4.0078125 15.09765625 -5.2109375 12.69921875 C-5.55640625 11.71695313 -5.901875 10.7346875 -6.2578125 9.72265625 C-6.61359375 8.74554687 -6.969375 7.7684375 -7.3359375 6.76171875 C-8.0078125 4.09765625 -8.0078125 4.09765625 -7.0078125 1.09765625 C-4.50284246 -0.15482877 -2.79927976 -0.01608781 0 0 Z ",
    fill: "#097117",
    transform: "translate(606.0078125,554.90234375)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.2065625 0.0309375 1.2065625 0.0309375 2.4375 0.0625 C1.83421875 0.24554687 1.2309375 0.42859375 0.609375 0.6171875 C-2.57290364 2.73489091 -3.21301686 5.69543091 -4.3125 9.1875 C-4.53292969 9.84621094 -4.75335937 10.50492188 -4.98046875 11.18359375 C-5.52111188 12.80552313 -6.04359707 14.43348507 -6.5625 16.0625 C-5.2425 16.0625 -3.9225 16.0625 -2.5625 16.0625 C-2.5625 16.7225 -2.5625 17.3825 -2.5625 18.0625 C-7.66097078 18.5242483 -12.48119617 18.79766736 -17.5625 18.0625 C-20.2740772 15.7727237 -21.47832851 13.41221604 -22.5625 10.0625 C-21.9025 9.0725 -21.2425 8.0825 -20.5625 7.0625 C-20.90855611 4.77852968 -21.52954519 3.12840963 -22.5625 1.0625 C-20.9125 1.0625 -19.2625 1.0625 -17.5625 1.0625 C-17.5625 6.0125 -17.5625 10.9625 -17.5625 16.0625 C-14.5925 16.0625 -11.6225 16.0625 -8.5625 16.0625 C-8.5625 15.0725 -8.5625 14.0825 -8.5625 13.0625 C-10.5425 13.0625 -12.5225 13.0625 -14.5625 13.0625 C-14.5625 12.0725 -14.5625 11.0825 -14.5625 10.0625 C-12.5825 10.0625 -10.6025 10.0625 -8.5625 10.0625 C-8.2325 9.0725 -7.9025 8.0825 -7.5625 7.0625 C-7.2325 7.7225 -6.9025 8.3825 -6.5625 9.0625 C-6.35753906 8.49660156 -6.15257812 7.93070313 -5.94140625 7.34765625 C-5.67199219 6.61417969 -5.40257812 5.88070312 -5.125 5.125 C-4.85816406 4.39410156 -4.59132813 3.66320312 -4.31640625 2.91015625 C-3.18463599 0.13643951 -3.11570179 0.07599273 0 0 Z ",
    fill: "#1C7D2C",
    transform: "translate(595.5625,554.9375)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C6.8125 4.5625 6.8125 4.5625 8 8 C8.33 5.36 8.66 2.72 9 0 C9.99 0 10.98 0 12 0 C12 4.95 12 9.9 12 15 C10.35 14.67 8.7 14.34 7 14 C5.1875 10.9375 5.1875 10.9375 4 8 C3.67 10.31 3.34 12.62 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FBFDFB",
    transform: "translate(806,556)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.17026043 0.55728247 7.55381675 1.50106982 11.3515625 3.30078125 C12.35880371 3.77797607 13.36604492 4.2551709 14.40380859 4.74682617 C15.46680176 5.26349854 16.52979492 5.7801709 17.625 6.3125 C18.72279785 6.84141846 19.8205957 7.37033691 20.95166016 7.9152832 C30.7284297 12.70752621 40.03385028 18.1409399 49.22021484 23.9753418 C51.13204382 25.15472662 51.13204382 25.15472662 54 26 C55.37562854 27.28965176 56.70766393 28.62689293 58 30 C58.5775 30.5775 59.155 31.155 59.75 31.75 C60.1625 32.1625 60.575 32.575 61 33 C57.39215416 33 56.70064183 32.2614609 53.875 30.125 C40.32948798 20.41900722 25.60840987 13.21976775 10.54248047 6.20019531 C6.99705877 4.52655472 3.49748133 2.77139808 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#1C6A2A",
    transform: "translate(1011,407)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C6.8125 4.0625 6.8125 4.0625 8 7 C8.33 4.69 8.66 2.38 9 0 C9.99 0 10.98 0 12 0 C12 4.95 12 9.9 12 15 C10.68 15 9.36 15 8 15 C6.68 12.36 5.36 9.72 4 7 C3.67 9.64 3.34 12.28 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#E6F2E5",
    transform: "translate(1013,556)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7 0 7 0 10 2 C10.27324172 4.5957963 10.13200425 6.56438597 9.375 9.0625 C8.87811029 11.6297635 9.67320572 12.81469177 11 15 C9.35 14.67 7.7 14.34 6 14 C5.67 12.68 5.34 11.36 5 10 C4.34 10 3.68 10 3 10 C3 11.65 3 13.3 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#EAF5EA",
    transform: "translate(915,556)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.8359375 -0.1953125 6.8359375 -0.1953125 9 0 C9.66 0.66 10.32 1.32 11 2 C10.64644564 4.26274788 10.02455574 5.95088852 9 8 C9.60578253 10.01927511 10.26919734 12.02253397 11 14 C9.125 13.75 9.125 13.75 7 13 C5.75 10.9375 5.75 10.9375 5 9 C4.67 10.65 4.34 12.3 4 14 C2.68 14 1.36 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FBFDF9",
    transform: "translate(565,557)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 1.98 3 3.96 3 6 C4.65 6 6.3 6 8 6 C8 4.02 8 2.04 8 0 C9.32 0 10.64 0 12 0 C12 4.95 12 9.9 12 15 C10.68 15 9.36 15 8 15 C8 13.02 8 11.04 8 9 C6.35 9 4.7 9 3 9 C3 10.98 3 12.96 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#D7EAD8",
    transform: "translate(644,556)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C5.65 4.95 7.3 9.9 9 15 C7.35 15 5.7 15 4 15 C4 14.01 4 13.02 4 12 C2.35 12 0.7 12 -1 12 C-1.33 12.99 -1.66 13.98 -2 15 C-2.99 15 -3.98 15 -5 15 C-3.97137215 9.55432314 -2.75385216 4.88182883 0 0 Z ",
    fill: "#EBF5EB",
    transform: "translate(594,556)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C5.65 4.62 7.3 9.24 9 14 C7.68 14.33 6.36 14.66 5 15 C4.67 14.34 4.34 13.68 4 13 C2.35 13 0.7 13 -1 13 C-1.33 13.66 -1.66 14.32 -2 15 C-2.99 15 -3.98 15 -5 15 C-3.97137215 9.55432314 -2.75385216 4.88182883 0 0 Z ",
    fill: "#E8F3E8",
    transform: "translate(861,556)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C5.67031719 2.9570868 6.33614683 4.91571113 7 6.875 C7.556875 8.51082031 7.556875 8.51082031 8.125 10.1796875 C9 13 9 13 9 15 C7.68 15 6.36 15 5 15 C5 14.01 5 13.02 5 12 C3.02 12 1.04 12 -1 12 C-1 12.99 -1 13.98 -1 15 C-2.32 14.67 -3.64 14.34 -5 14 C-3.35 9.38 -1.7 4.76 0 0 Z ",
    fill: "#E9F4E7",
    transform: "translate(740,556)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.5778125 0.4021875 1.5778125 0.4021875 3.1875 0.8125 C3.1875 1.8025 3.1875 2.7925 3.1875 3.8125 C2.218125 3.791875 1.24875 3.77125 0.25 3.75 C-2.68715895 3.45631501 -2.68715895 3.45631501 -3.8125 4.8125 C-3.85330783 6.81208364 -3.85504356 8.81295254 -3.8125 10.8125 C-2.4925 11.4725 -1.1725 12.1325 0.1875 12.8125 C0.1875 11.4925 0.1875 10.1725 0.1875 8.8125 C-0.8025 8.8125 -1.7925 8.8125 -2.8125 8.8125 C-2.8125 8.1525 -2.8125 7.4925 -2.8125 6.8125 C-0.5025 6.8125 1.8075 6.8125 4.1875 6.8125 C4.1875 9.4525 4.1875 12.0925 4.1875 14.8125 C-3.83888522 15.42991425 -3.83888522 15.42991425 -7.375 13.1875 C-9.27793651 10.04351795 -9.4771293 8.43103729 -8.8125 4.8125 C-6.008316 0.81866219 -4.96013314 -0.24394097 0 0 Z ",
    fill: "#EBF5EB",
    transform: "translate(558.8125,556.1875)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C5.65 4.95 7.3 9.9 9 15 C7.68 15 6.36 15 5 15 C5 14.01 5 13.02 5 12 C3.02 12 1.04 12 -1 12 C-1 12.99 -1 13.98 -1 15 C-2.32 15 -3.64 15 -5 15 C-4.54705135 13.24859857 -4.08741252 11.49892656 -3.625 9.75 C-3.36976563 8.77546875 -3.11453125 7.8009375 -2.8515625 6.796875 C-2.10401491 4.34162697 -1.22876183 2.24382595 0 0 Z ",
    fill: "#EFF7EE",
    transform: "translate(713,556)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93359375 -0.09765625 6.93359375 -0.09765625 9 0 C10 1 10 1 10.125 3.3125 C10 6 10 6 9.4375 8.0625 C8.91957523 10.35616685 9.2883622 11.78601575 10 14 C8.68 13.67 7.36 13.34 6 13 C5.67 11.68 5.34 10.36 5 9 C4.34 9 3.68 9 3 9 C3 10.65 3 12.3 3 14 C2.01 14 1.02 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FAFDF9",
    transform: "translate(955,557)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C5.67031719 2.9570868 6.33614683 4.91571113 7 6.875 C7.556875 8.51082031 7.556875 8.51082031 8.125 10.1796875 C9 13 9 13 9 15 C7.68 15 6.36 15 5 15 C5 14.01 5 13.02 5 12 C3.02 12 1.04 12 -1 12 C-1 12.99 -1 13.98 -1 15 C-1.99 15 -2.98 15 -4 15 C-3.43179252 9.54520815 -2.05362055 5.08940744 0 0 Z ",
    fill: "#F0F7EF",
    transform: "translate(971,556)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.99 10 1.98 10 3 C8.02 3 6.04 3 4 3 C4 3.99 4 4.98 4 6 C5.65 6 7.3 6 9 6 C9 6.99 9 7.98 9 9 C7.35 9 5.7 9 4 9 C4 9.99 4 10.98 4 12 C5.98 12 7.96 12 10 12 C10 12.99 10 13.98 10 15 C6.7 15 3.4 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#F6FBF5",
    transform: "translate(685,556)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.2475 0.53625 0.495 1.0725 0.75 1.625 C2.29814886 4.56648283 4.13010957 7.25359843 6 10 C6.66 10.99 7.32 11.98 8 13 C5.11586138 11.86694554 4.08720726 11.14056185 2.41699219 8.44848633 C-0.1974596 5.79996744 -0.55061805 5.63422145 -4.03417969 5.43237305 C-5.66362593 5.43316147 -7.29321101 5.46122816 -8.921875 5.51171875 C-9.78186096 5.51879349 -10.64184692 5.52586823 -11.52789307 5.53315735 C-14.2694875 5.56110389 -17.009025 5.6238402 -19.75 5.6875 C-21.61064755 5.71258266 -23.47132717 5.73539589 -25.33203125 5.75585938 C-29.88881106 5.81093113 -34.44405704 5.89720345 -39 6 C-36.14083585 3.14083585 -33.98261857 3.62425871 -29.98046875 3.4375 C-29.28488358 3.40068115 -28.5892984 3.3638623 -27.87263489 3.32592773 C-25.64460244 3.20836482 -23.41625722 3.10284723 -21.1875 3 C-18.26371762 2.86411349 -15.34084209 2.71657832 -12.41796875 2.5625 C-11.11625732 2.50191406 -9.8145459 2.44132812 -8.47338867 2.37890625 C-5.25270428 2.02756709 -2.90875547 1.37818027 0 0 Z ",
    fill: "#136D24",
    transform: "translate(801,367)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.59008837 3.40728644 -0.7975628 5.14595741 -4 7 C-5.38717836 7.38667935 -6.78431418 7.73868789 -8.1875 8.0625 C-9.445625 8.371875 -10.70375 8.68125 -12 9 C-12.33 9.66 -12.66 10.32 -13 11 C-13.66 9.68 -14.32 8.36 -15 7 C-15.66 7.66 -16.32 8.32 -17 9 C-18.98821313 9.39764263 -20.98944339 9.73775349 -23 10 C-23.66 8.02 -24.32 6.04 -25 4 C-24.07316406 4.15597656 -23.14632812 4.31195313 -22.19140625 4.47265625 C-20.39509766 4.76462891 -20.39509766 4.76462891 -18.5625 5.0625 C-17.36753906 5.25972656 -16.17257812 5.45695312 -14.94140625 5.66015625 C-13.97074219 5.77230469 -13.00007812 5.88445312 -12 6 C-11.67 5.67 -11.34 5.34 -11 5 C-11.78375 5.061875 -12.5675 5.12375 -13.375 5.1875 C-14.24125 5.125625 -15.1075 5.06375 -16 5 C-16.66 4.01 -17.32 3.02 -18 2 C-12.39 2.33 -6.78 2.66 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#EE747F",
    transform: "translate(1004,388)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.33 3.63 3.66 7.26 4 11 C5.32 11 6.64 11 8 11 C8.33 7.7 8.66 4.4 9 1 C9.99 1 10.98 1 12 1 C12.05389087 2.95803507 12.09274217 4.91648909 12.125 6.875 C12.14820313 7.96554687 12.17140625 9.05609375 12.1953125 10.1796875 C12 13 12 13 10 15 C8.125 15.30078125 8.125 15.30078125 6 15.3125 C5.29875 15.32925781 4.5975 15.34601562 3.875 15.36328125 C3.25625 15.24339844 2.6375 15.12351562 2 15 C-0.35119399 11.47320901 -0.21443452 9.97120515 -0.125 5.8125 C-0.10695313 4.72582031 -0.08890625 3.63914062 -0.0703125 2.51953125 C-0.04710937 1.68808594 -0.02390625 0.85664062 0 0 Z ",
    fill: "#F7FBF6",
    transform: "translate(791,556)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.20335937 2.01707031 1.20335937 2.01707031 0.390625 3.0546875 C-3.76969283 8.53598216 -6.92680802 13.35536525 -8.8203125 20.00390625 C-10 22 -10 22 -16 24 C-14.02 14.595 -14.02 14.595 -12 5 C-11.67 5 -11.34 5 -11 5 C-11 6.98 -11 8.96 -11 11 C-9.72486237 9.92173635 -8.45507431 8.83714481 -7.1875 7.75 C-6.47980469 7.14671875 -5.77210938 6.5434375 -5.04296875 5.921875 C-3.08110329 4.07629602 -1.54330375 2.20054668 0 0 Z ",
    fill: "#FBEFED",
    transform: "translate(945,299)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C2.99 3.33 3.98 3.66 5 4 C5 7.96 5 11.92 5 16 C5.99 16.33 6.98 16.66 8 17 C3.70700357 18.26264601 1.12168689 17.62950412 -3 16 C-3 15.34 -3 14.68 -3 14 C-4.32 14 -5.64 14 -7 14 C-7.33 14.66 -7.66 15.32 -8 16 C-8 14.68 -8 13.36 -8 12 C-6.02 12 -4.04 12 -2 12 C-2 12.99 -2 13.98 -2 15 C-0.68 15 0.64 15 2 15 C1.69964844 14.24074219 1.39929688 13.48148438 1.08984375 12.69921875 C0.51943359 11.20841797 0.51943359 11.20841797 -0.0625 9.6875 C-0.44535156 8.70136719 -0.82820312 7.71523438 -1.22265625 6.69921875 C-2 4 -2 4 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#10741F",
    transform: "translate(978,556)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-0.34 4.33 0.32 4.66 1 5 C1.33 4.34 1.66 3.68 2 3 C2 3.66 2 4.32 2 5 C4.97 5 7.94 5 11 5 C7.90178117 7.06547922 4.81550648 8.56243611 1.4375 10.125 C-0.29693359 10.93324219 -0.29693359 10.93324219 -2.06640625 11.7578125 C-5 13 -5 13 -7 13 C-7 12.01 -7 11.02 -7 10 C-7.99 10.495 -7.99 10.495 -9 11 C-8.40300869 7.66864109 -7.27987719 5.78724333 -5.0625 3.25 C-4.53785156 2.63640625 -4.01320313 2.0228125 -3.47265625 1.390625 C-2 0 -2 0 0 0 Z ",
    fill: "#F9F2ED",
    transform: "translate(972,328)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.32 0 2.64 0 4 C-1.65 3.67 -3.3 3.34 -5 3 C-5 3.99 -5 4.98 -5 6 C-4.195625 6.226875 -3.39125 6.45375 -2.5625 6.6875 C0 8 0 8 0.9375 10.5 C0.958125 11.325 0.97875 12.15 1 13 C-1 15 -1 15 -2.9453125 15.1953125 C-4.96354167 15.13020833 -6.98177083 15.06510417 -9 15 C-9 14.01 -9 13.02 -9 12 C-7.35 12 -5.7 12 -4 12 C-3.67 11.34 -3.34 10.68 -3 10 C-3.804375 9.773125 -4.60875 9.54625 -5.4375 9.3125 C-8 8 -8 8 -9 5.5625 C-9 3 -9 3 -7.9375 1.1875 C-5.24448045 -0.46306037 -3.09429572 -0.20628638 0 0 Z ",
    fill: "#E9F3E9",
    transform: "translate(706,556)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-1.670625 1.433125 -1.670625 1.433125 -3.375 1.875 C-7.00291092 2.69241329 -7.00291092 2.69241329 -9 5 C-9.47325628 10.0165166 -8.97071449 12.91526758 -6 17 C-6.495 16.731875 -6.99 16.46375 -7.5 16.1875 C-10.9236946 14.56124507 -14.44132285 13.30484829 -18 12 C-18.125 9.125 -18.125 9.125 -18 6 C-17.34 5.34 -16.68 4.68 -16 4 C-13.375 4.375 -13.375 4.375 -11 5 C-10.67 3.68 -10.34 2.36 -10 1 C-6.61981469 -0.04005702 -3.5219721 -0.08004482 0 0 Z ",
    fill: "#0B6A16",
    transform: "translate(909,555)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.99954746 -0.04254356 4.00041636 -0.04080783 6 0 C7 1 7 1 7.125 3.3125 C7 6 7 6 6.375 8.0625 C5.87811029 10.6297635 6.67320572 11.81469177 8 14 C5.625 13.75 5.625 13.75 3 13 C1.6875 10.9375 1.6875 10.9375 1 9 C0.67 10.65 0.34 12.3 0 14 C-0.99 14 -1.98 14 -3 14 C-3 9.71 -3 5.42 -3 1 C-1 4 -1 4 -1 6 C0.32 6 1.64 6 3 6 C3 4.68 3 3.36 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#E8F2E8",
    transform: "translate(629,557)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.66 9 1.32 9 2 C8.195625 2.12375 7.39125 2.2475 6.5625 2.375 C5.2940625 2.684375 5.2940625 2.684375 4 3 C3.67 3.66 3.34 4.32 3 5 C4.98 5 6.96 5 9 5 C9 5.99 9 6.98 9 8 C7.02 8 5.04 8 3 8 C3 8.99 3 9.98 3 11 C4.98 11 6.96 11 9 11 C9 11.99 9 12.98 9 14 C6.03 14 3.06 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#F2F9F2",
    transform: "translate(578,557)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.77988281 -0.01417969 1.55976562 -0.02835938 2.36328125 -0.04296875 C4.6875 0.1875 4.6875 0.1875 8.6875 2.1875 C8.6875 6.8075 8.6875 11.4275 8.6875 16.1875 C4.6875 12.1875 4.6875 12.1875 4.515625 9.828125 C4.90625 7.61458333 5.296875 5.40104167 5.6875 3.1875 C1.2325 2.1975 1.2325 2.1975 -3.3125 1.1875 C-3.3125 6.4675 -3.3125 11.7475 -3.3125 17.1875 C-2.3225 17.5175 -1.3325 17.8475 -0.3125 18.1875 C-1.9625 17.8575 -3.6125 17.5275 -5.3125 17.1875 C-5.34988281 16.45144531 -5.38726563 15.71539063 -5.42578125 14.95703125 C-5.84234473 7.58337342 -5.84234473 7.58337342 -9.3125 1.1875 C-7.9925 1.1875 -6.6725 1.1875 -5.3125 1.1875 C-3.74222683 -0.38277317 -2.16980053 0.01775614 0 0 Z ",
    fill: "#0A6A14",
    transform: "translate(918.3125,554.8125)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.66 9 1.32 9 2 C7.02 2 5.04 2 3 2 C3 2.99 3 3.98 3 5 C4.98 5 6.96 5 9 5 C9 5.99 9 6.98 9 8 C7.02 8 5.04 8 3 8 C3 8.99 3 9.98 3 11 C4.98 11 6.96 11 9 11 C9 11.99 9 12.98 9 14 C6.03 14 3.06 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#EFF8F0",
    transform: "translate(614,557)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0725 0.268125 2.145 0.53625 3.25 0.8125 C3.25 1.8025 3.25 2.7925 3.25 3.8125 C2.0434375 3.7815625 2.0434375 3.7815625 0.8125 3.75 C-1.68354885 3.51616379 -1.68354885 3.51616379 -2.75 4.8125 C-2.79080783 6.81208364 -2.79254356 8.81295254 -2.75 10.8125 C0.22 11.3075 0.22 11.3075 3.25 11.8125 C3.25 12.8025 3.25 13.7925 3.25 14.8125 C-4.07215357 15.17260591 -4.07215357 15.17260591 -6.75 13.75 C-8.36407542 10.62272887 -8.16705529 8.26810099 -7.75 4.8125 C-5.54816941 0.58498527 -4.85510537 -0.24275527 0 0 Z ",
    fill: "#DCECDD",
    transform: "translate(894.75,556.1875)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.02578125 0.58007812 0.0515625 1.16015625 0.078125 1.7578125 C0.47855458 7.27281992 1.49754161 10.54232569 5 15 C5.99 16.485 5.99 16.485 7 18 C6.01 19.32 5.02 20.64 4 22 C-0.79051117 16.90819882 -3.61100345 12.9677648 -4.3125 5.8125 C-4 3 -4 3 -2.5625 1.125 C-1 0 -1 0 0 0 Z ",
    fill: "#E8DCD0",
    transform: "translate(844,333)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.3303125 0.4021875 1.3303125 0.4021875 2.6875 0.8125 C2.6875 1.8025 2.6875 2.7925 2.6875 3.8125 C1.4809375 3.7815625 1.4809375 3.7815625 0.25 3.75 C-2.24604885 3.51616379 -2.24604885 3.51616379 -3.3125 4.8125 C-3.35330783 6.81208364 -3.35504356 8.81295254 -3.3125 10.8125 C-0.3425 11.3075 -0.3425 11.3075 2.6875 11.8125 C2.6875 12.8025 2.6875 13.7925 2.6875 14.8125 C-4.71506709 15.29791424 -4.71506709 15.29791424 -7.3125 13.1875 C-8.6306446 10.05690659 -8.86264903 8.1821628 -8.3125 4.8125 C-5.66467109 1.15226592 -4.61635888 -0.26130333 0 0 Z ",
    fill: "#EEF7EE",
    transform: "translate(834.3125,556.1875)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.51425805 3.0285161 2.66387653 5.73448186 3.7265625 8.9140625 C4.0359375 9.83960938 4.3453125 10.76515625 4.6640625 11.71875 C4.98117187 12.6778125 5.29828125 13.636875 5.625 14.625 C5.94984375 15.59179688 6.2746875 16.55859375 6.609375 17.5546875 C6.91617188 18.47765625 7.22296875 19.400625 7.5390625 20.3515625 C7.81959473 21.19541504 8.10012695 22.03926758 8.38916016 22.90869141 C9 25 9 25 9 27 C8.34 27 7.68 27 7 27 C5.35 22.38 3.7 17.76 2 13 C1.67 23.89 1.34 34.78 1 46 C0.67 46 0.34 46 0 46 C0 30.82 0 15.64 0 0 Z ",
    fill: "#39833F",
    transform: "translate(821,459)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.2475 0.94875 0.495 1.8975 0.75 2.875 C1.6857077 6.08693191 1.6857077 6.08693191 4.125 7.375 C4.74375 7.58125 5.3625 7.7875 6 8 C5.67 8.99 5.34 9.98 5 11 C3.35 10.67 1.7 10.34 0 10 C-0.33 10.99 -0.66 11.98 -1 13 C-1.33 12.01 -1.66 11.02 -2 10 C-3.98 10 -5.96 10 -8 10 C-8 9.01 -8 8.02 -8 7 C-6.35 7 -4.7 7 -3 7 C-3 6.01 -3 5.02 -3 4 C-4.65 4 -6.3 4 -8 4 C-8 3.01 -8 2.02 -8 1 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#107523",
    transform: "translate(697,558)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.875 0.25 1.875 0.25 4 1 C5.25 3.0625 5.25 3.0625 6 5 C6.4125 4.175 6.825 3.35 7.25 2.5 C7.8275 1.675 8.405 0.85 9 0 C10.32 0 11.64 0 13 0 C11.87548273 2.9719385 10.77706209 5.33440687 9 8 C8.60612212 10.32387947 8.26513915 12.65793749 8 15 C6.68 15 5.36 15 4 15 C3.87882813 14.41992188 3.75765625 13.83984375 3.6328125 13.2421875 C2.66264526 8.71971558 1.56602217 4.36249034 0 0 Z ",
    fill: "#EAF5EA",
    transform: "translate(657,556)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.32 10 2.64 10 4 C9.01 4 8.02 4 7 4 C7 7.63 7 11.26 7 15 C5.68 15 4.36 15 3 15 C3 11.37 3 7.74 3 4 C2.01 4 1.02 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#D6EAD7",
    transform: "translate(602,556)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.66 -0.66 1.32 -1 2 C-3.5625 2.625 -3.5625 2.625 -6 3 C-5.34 4.32 -4.68 5.64 -4 7 C-11.42857143 7.14285714 -11.42857143 7.14285714 -15 6 C-15 5.34 -15 4.68 -15 4 C-28.86 3.505 -28.86 3.505 -43 3 C-43 2.67 -43 2.34 -43 2 C-42.02651611 1.97494385 -41.05303223 1.9498877 -40.05004883 1.92407227 C-36.42508653 1.82962722 -32.80029934 1.72949833 -29.17553711 1.62768555 C-27.60917264 1.58447661 -26.04276533 1.54279209 -24.47631836 1.50268555 C-22.2197582 1.44464129 -19.96341092 1.38104698 -17.70703125 1.31640625 C-17.01100296 1.29969376 -16.31497467 1.28298126 -15.59785461 1.26576233 C-10.30767826 1.1059674 -5.28337502 -0.15095357 0 0 Z ",
    fill: "#FAD9D5",
    transform: "translate(991,359)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.23542686 0.80353933 2.23542686 0.80353933 5.12890625 0.65625 C5.62390625 2.63625 5.62390625 2.63625 6.12890625 4.65625 C5.57203125 4.45128906 5.01515625 4.24632812 4.44140625 4.03515625 C-0.72922919 2.20971232 -5.41944678 1.19247757 -10.87109375 0.65625 C-12.44890625 0.3159375 -12.44890625 0.3159375 -14.05859375 -0.03125 C-17.38041052 -0.40034075 -19.03955505 -0.12357433 -21.87109375 1.65625 C-22.76495539 4.20400306 -22.76495539 4.20400306 -22.87109375 6.65625 C-23.20109375 5.99625 -23.53109375 5.33625 -23.87109375 4.65625 C-25.19109375 4.98625 -26.51109375 5.31625 -27.87109375 5.65625 C-26.47549648 2.2835566 -24.97893495 0.57579898 -21.87109375 -1.34375 C-14.40868835 -3.63622624 -7.23443425 -2.50824687 0 0 Z ",
    fill: "#E08885",
    transform: "translate(869.87109375,328.34375)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.32479534 2.14800003 3.85514519 4.24917509 5.375 7.01953125 C5.80296875 7.79490234 6.2309375 8.57027344 6.671875 9.36914062 C7.11015625 10.17544922 7.5484375 10.98175781 8 11.8125 C8.43828125 12.60720703 8.8765625 13.40191406 9.328125 14.22070312 C11.64439637 18.43813097 13.88445026 22.67843294 16 27 C15.01 27.66 14.02 28.32 13 29 C11.39128326 25.98156906 9.78886951 22.95983439 8.1875 19.9375 C7.73568359 19.08994141 7.28386719 18.24238281 6.81835938 17.36914062 C0 4.47895757 0 4.47895757 0 0 Z ",
    fill: "#FCF2EE",
    transform: "translate(879,304)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 1.32 11 2.64 11 4 C9.68 4 8.36 4 7 4 C7 7.63 7 11.26 7 15 C6.01 15 5.02 15 4 15 C4 11.37 4 7.74 4 4 C2.68 3.67 1.36 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#CAE2CB",
    transform: "translate(979,556)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.66 5 1.32 5 2 C4.34 2 3.68 2 3 2 C3 3.32 3 4.64 3 6 C3.99 6 4.98 6 6 6 C6.33 5.01 6.66 4.02 7 3 C7.99 3 8.98 3 10 3 C9.125 7.875 9.125 7.875 8 9 C6.33382885 9.04063832 4.66611905 9.042721 3 9 C3 10.65 3 12.3 3 14 C2.01 14 1.02 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FBFEFA",
    transform: "translate(846,557)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.125 0.375 3.125 0.375 5.5 1.9375 C7.66955002 5.19182503 7.41951507 7.54630414 7.125 11.375 C6.135 11.705 5.145 12.035 4.125 12.375 C3.135 9.735 2.145 7.095 1.125 4.375 C0.526875 4.684375 -0.07125 4.99375 -0.6875 5.3125 C-2.875 6.375 -2.875 6.375 -5.875 7.375 C-4.80957944 0.62733645 -4.80957944 0.62733645 0 0 Z ",
    fill: "#E9F3E8",
    transform: "translate(1003.875,555.625)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.0546875 -0.1953125 6.0546875 -0.1953125 8 0 C8.66 0.66 9.32 1.32 10 2 C9.625 4.625 9.625 4.625 9 7 C8.7525 6.360625 8.505 5.72125 8.25 5.0625 C7.18437567 2.81258459 7.18437567 2.81258459 4.875 2.25 C3.946875 2.12625 3.946875 2.12625 3 2 C3 3.65 3 5.3 3 7 C3.66 7 4.32 7 5 7 C5 7.66 5 8.32 5 9 C4.34 9 3.68 9 3 9 C3 10.65 3 12.3 3 14 C2.01 14 1.02 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#F9FCF7",
    transform: "translate(928,557)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2 2.32 2 3.64 2 5 C3.65 5 5.3 5 7 5 C7.66 3.68 8.32 2.36 9 1 C10.18270333 5.28729957 10.02376944 8.67741793 9 13 C8 14 8 14 4.9375 14.0625 C3.968125 14.041875 2.99875 14.02125 2 14 C3.375 12.5 3.375 12.5 5 11 C5.66 11 6.32 11 7 11 C6.10664203 8.64214682 6.10664203 8.64214682 2.9375 7.875 C1.4834375 7.441875 1.4834375 7.441875 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#F1F8F0",
    transform: "translate(724,557)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.155 0.391875 2.31 0.78375 3.5 1.1875 C8.05196807 2.69999813 12.61570283 4.17372753 17.1875 5.625 C17.86425781 5.84309326 18.54101562 6.06118652 19.23828125 6.28588867 C23.13921051 7.51592433 26.94922753 8.43301785 31 9 C30.01 9.33 29.02 9.66 28 10 C28 10.66 28 11.32 28 12 C23.21755998 11.38837824 18.9989645 10.00631505 14.5625 8.1875 C13.93279297 7.93935547 13.30308594 7.69121094 12.65429688 7.43554688 C8.19789534 5.63558202 4.13042663 3.45693765 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FCEEE9",
    transform: "translate(857,342)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.08636719 0.68964844 2.17273438 1.37929688 2.26171875 2.08984375 C3.1747262 8.19610461 4.62272886 12.86873739 7.87890625 18.125 C9 20 9 20 10 23 C9.34 23.66 8.68 24.32 8 25 C1.94987655 16.43850455 -0.37439198 10.52457445 0 0 Z ",
    fill: "#F3D0CA",
    transform: "translate(865,304)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2 1.66 2 2.32 2 3 C2.99 3 3.98 3 5 3 C5.33 2.01 5.66 1.02 6 0 C6 4.95 6 9.9 6 15 C9.3 15 12.6 15 16 15 C14 17 14 17 11.1796875 17.1953125 C10.08914063 17.17210937 8.99859375 17.14890625 7.875 17.125 C6.77929688 17.10695313 5.68359375 17.08890625 4.5546875 17.0703125 C3.71164062 17.04710937 2.86859375 17.02390625 2 17 C2.99 16.67 3.98 16.34 5 16 C4.6390625 15.01257813 4.278125 14.02515625 3.90625 13.0078125 C3.43733319 11.71360209 2.96859231 10.41932794 2.5 9.125 C2.14228516 8.14853516 2.14228516 8.14853516 1.77734375 7.15234375 C0 2.2265625 0 2.2265625 0 0 Z ",
    fill: "#0F701B",
    transform: "translate(717,556)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.4375 0.25 2.4375 0.25 5 1 C7.32579101 4.48868651 7.41865457 5.89718519 7 10 C5.9375 12.375 5.9375 12.375 4 14 C0.3125 14.25 0.3125 14.25 -3 14 C-3 13.34 -3 12.68 -3 12 C-1.35 11.34 0.3 10.68 2 10 C2.40749675 5.74268432 2.40749675 5.74268432 0.5 2.125 C0.005 1.75375 -0.49 1.3825 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F5FAF4",
    transform: "translate(906,557)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 3.96 3 7.92 3 12 C4.98 12 6.96 12 9 12 C9 12.99 9 13.98 9 15 C6.03 15 3.06 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#F3F8F3",
    transform: "translate(871,556)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C3.32 1.34 4.64 0.68 6 0 C5.505 0.70125 5.01 1.4025 4.5 2.125 C2.7531032 5.47321887 2.44533434 7.2758163 3 11 C4.3530128 13.60314994 4.3530128 13.60314994 7 15 C9.82119539 15.0269198 12.20494577 14.55901085 15 14 C14.01 15.485 14.01 15.485 13 17 C8.65413172 17.39507893 6.67996503 17.45331002 3 15 C2.34 15.66 1.68 16.32 1 17 C-1.125 16.625 -1.125 16.625 -3 16 C-2.01 16 -1.02 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#0B6F19",
    transform: "translate(995,556)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.3125 -0.25 2.3125 -0.25 5 0 C7.50907308 2.24951379 7.95656309 3.65250472 8.375 7 C7.95954192 10.32366465 7.44659771 11.72815927 5 14 C3.68 14 2.36 14 1 14 C1.33 13.46375 1.66 12.9275 2 12.375 C3.25954167 9.38358852 3.34952958 7.21567216 3 4 C2.01 3.34 1.02 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EEF7EE",
    transform: "translate(945,557)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.12046792 3.53411321 2.53199289 6.94393835 3 11 C6.26954202 10.43628586 7.82575883 9.50037734 10 7 C10.66 7.33 11.32 7.66 12 8 C9.2239921 11.59852875 6.34645017 14.91774326 3 18 C2.34 18 1.68 18 1 18 C-1.3938068 5.98821945 -1.3938068 5.98821945 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#EB9A9E",
    transform: "translate(933,292)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.02578125 0.97839844 0.0515625 1.95679688 0.078125 2.96484375 C0.42208605 14.08057603 0.42208605 14.08057603 5 24 C7.24088508 26.03410813 9.37910479 27.43754324 12 29 C9 30 9 30 7.31640625 29.171875 C1.83964164 24.73191438 -0.48023904 19.84352968 -2 13 C-2.27368059 9.63058809 -2.2630515 6.36852066 -2 3 C-2.99 2.67 -3.98 2.34 -5 2 C-1.125 0 -1.125 0 0 0 Z ",
    fill: "#0E7218",
    transform: "translate(883,397)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.65 0 3.3 0 5 C0.99 5 1.98 5 3 5 C3 8.63 3 12.26 3 16 C0 15 0 15 -1.203125 12.6015625 C-1.54859375 11.61929688 -1.8940625 10.63703125 -2.25 9.625 C-2.60578125 8.64789062 -2.9615625 7.67078125 -3.328125 6.6640625 C-4 4 -4 4 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#0A6E18",
    transform: "translate(602,555)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 4.95 4 9.9 4 15 C2.68 15 1.36 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#DDEDDC",
    transform: "translate(839,556)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C3.49396008 4.16874252 3.00016187 5.99967627 2 8 C2.60578253 10.01927511 3.26919734 12.02253397 4 14 C2.1875 13.875 2.1875 13.875 0 13 C-2.38482838 9.25241255 -3.39145737 6.43651689 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#ACCCAD",
    transform: "translate(572,557)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.04898437 1.12277344 1.09796875 2.24554688 1.1484375 3.40234375 C1.52202856 11.13386692 1.95321159 18.49510917 4 26 C3.34 26.33 2.68 26.66 2 27 C2 26.34 2 25.68 2 25 C1.01 24.67 0.02 24.34 -1 24 C-0.67 23.67 -0.34 23.34 0 23 C-0.66 22.34 -1.32 21.68 -2 21 C-2.33 20.01 -2.66 19.02 -3 18 C-2.34 17.67 -1.68 17.34 -1 17 C-1.01160156 15.94039063 -1.02320313 14.88078125 -1.03515625 13.7890625 C-1.04453476 12.40104342 -1.05363489 11.01302245 -1.0625 9.625 C-1.07506836 8.57699219 -1.07506836 8.57699219 -1.08789062 7.5078125 C-1.11328125 2.2265625 -1.11328125 2.2265625 0 0 Z ",
    fill: "#216F2C",
    transform: "translate(477,489)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.41623216 -0.05447047 2.83308191 -0.09300508 4.25 -0.125 C5.03890625 -0.14820313 5.8278125 -0.17140625 6.640625 -0.1953125 C9.20731941 0.0171622 10.7916067 0.71345895 13 2 C12.67 3.65 12.34 5.3 12 7 C10 6 10 6 9.0625 4 C8.1108154 1.65391779 8.1108154 1.65391779 5 1 C5.28875 1.4846875 5.5775 1.969375 5.875 2.46875 C8.72856297 7.62101647 9.41931138 11.12964063 9 17 C7.58622659 14.36095629 6.62759865 11.92879371 6 9 C5.67 11.31 5.34 13.62 5 16 C4.67 16 4.34 16 4 16 C4 11.05 4 6.1 4 1 C2.68 0.67 1.36 0.34 0 0 Z ",
    fill: "#086E16",
    transform: "translate(652,555)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.01822917 1.42317708 -4.03645833 1.84635417 -6.0546875 2.26953125 C-8.37046549 2.92308838 -8.37046549 2.92308838 -10 6 C-10.50010524 8.95769177 -10.50010524 8.95769177 -10 12 C-7.73059668 14.91780427 -5.38019657 16.55134433 -2 18 C-8.75 17.25 -8.75 17.25 -11 15 C-11.99 15.495 -11.99 15.495 -13 16 C-13 11.05 -13 6.1 -13 1 C-11.68 1 -10.36 1 -9 1 C-6.04335481 -0.4783226 -3.25770263 -0.06032783 0 0 Z ",
    fill: "#056810",
    transform: "translate(837,555)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-11.32896246 2.8121781 -22.52814175 4.44919886 -34 5 C-31.72056975 2.72056975 -30.94360818 2.62275903 -27.8515625 2.1484375 C-27.01592773 2.01928955 -26.18029297 1.8901416 -25.31933594 1.75708008 C-24.43020508 1.63099365 -23.54107422 1.50490723 -22.625 1.375 C-21.72555664 1.24311279 -20.82611328 1.11122559 -19.89941406 0.9753418 C-13.2402203 0.05058661 -6.72509507 -0.3690601 0 0 Z ",
    fill: "#145D20",
    transform: "translate(718,377)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.4370809 -0.05422947 2.87475462 -0.09289723 4.3125 -0.125 C5.11300781 -0.14820313 5.91351562 -0.17140625 6.73828125 -0.1953125 C9 0 9 0 12 2 C12.99 3.485 12.99 3.485 14 5 C14.66 4.34 15.32 3.68 16 3 C15.68950274 4.43793392 15.3765224 5.8753318 15.0625 7.3125 C14.88847656 8.11300781 14.71445312 8.91351562 14.53515625 9.73828125 C14 12 14 12 13 15 C12.01 14.67 11.02 14.34 10 14 C9.61781233 12.34385343 9.28604898 10.67542976 9 9 C9.33 8.67 9.66 8.34 10 8 C10 6.35 10 4.7 10 3 C6.7 2.34 3.4 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#117420",
    transform: "translate(954,555)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C4.37996094 0.20882812 3.75992188 0.41765625 3.12109375 0.6328125 C0.12329616 2.56509456 -0.03636099 4.47807969 -0.9375 7.875 C-2.10407215 11.67547332 -2.77311869 13.74403134 -5.4375 16.75 C-8.2194624 18.10705483 -9.94501486 18.34914116 -13 18 C-12.401875 17.71125 -11.80375 17.4225 -11.1875 17.125 C-8.80672208 15.95257974 -8.80672208 15.95257974 -6 14 C-6.18828772 11.55519921 -6.18828772 11.55519921 -7 9 C-8.96758273 7.63979849 -8.96758273 7.63979849 -11 7 C-11 6.01 -11 5.02 -11 4 C-7.20411134 4.54226981 -5.52788007 6.20127563 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#096C15",
    transform: "translate(712,555)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 2.31 3 4.62 3 7 C4.65 7 6.3 7 8 7 C7.67 7.66 7.34 8.32 7 9 C5.68 9 4.36 9 3 9 C3 10.98 3 12.96 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#F5FAF4",
    transform: "translate(644,556)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 0 2 0 3.9375 1.5625 C6.48303131 4.57085518 7.58892394 7.33120225 9 11 C9.33 9.35 9.66 7.7 10 6 C10.66 6 11.32 6 12 6 C11.67 8.97 11.34 11.94 11 15 C9.68 15.33 8.36 15.66 7 16 C6.74605469 15.32453125 6.49210938 14.6490625 6.23046875 13.953125 C5.88628906 13.06109375 5.54210937 12.1690625 5.1875 11.25 C4.85105469 10.36828125 4.51460937 9.4865625 4.16796875 8.578125 C3.03112171 6.06869674 1.6558864 4.18254368 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F7E4DE",
    transform: "translate(894,298)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.67 4.3 3.34 7.6 3 11 C4.32 11.33 5.64 11.66 7 12 C6.67 12.66 6.34 13.32 6 14 C4.02 14 2.04 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#F7FBF6",
    transform: "translate(751,557)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C5.15837626 4.05431692 4.83691257 6.21812119 3 10 C1.68 10 0.36 10 -1 10 C-1 9.34 -1 8.68 -1 8 C-1.66 8 -2.32 8 -3 8 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#E7F3E5",
    transform: "translate(594,556)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0354051 3.1848935 0.94040666 5.13031874 0.00390625 8.328125 C-0.22490234 9.12734375 -0.45371094 9.9265625 -0.68945312 10.75 C-0.93630859 11.575 -1.18316406 12.4 -1.4375 13.25 C-1.68048828 14.09046875 -1.92347656 14.9309375 -2.17382812 15.796875 C-2.77373949 17.86715734 -3.38570819 19.93393897 -4 22 C-5.52355282 19.0233818 -6.6983344 16.1366063 -7.6875 12.9375 C-7.95949219 12.08027344 -8.23148438 11.22304688 -8.51171875 10.33984375 C-9 8 -9 8 -8 5 C-7.67 6.32 -7.34 7.64 -7 9 C-6.01 9 -5.02 9 -4 9 C-4.33 10.32 -4.66 11.64 -5 13 C-3.09610151 10.14415227 -2.30537823 8.0688238 -1.375 4.8125 C-1.11460937 3.91144531 -0.85421875 3.01039063 -0.5859375 2.08203125 C-0.39257812 1.39496094 -0.19921875 0.70789063 0 0 Z ",
    fill: "#0C5E13",
    transform: "translate(861,480)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.68 2.65 0.36 4.3 -1 6 C0.65 6.66 2.3 7.32 4 8 C2 10 2 10 -0.24658203 10.13525391 C-1.15778809 10.08288574 -2.06899414 10.03051758 -3.0078125 9.9765625 C-3.99394531 9.925 -4.98007812 9.8734375 -5.99609375 9.8203125 C-7.54490234 9.72363281 -7.54490234 9.72363281 -9.125 9.625 C-10.68541016 9.53992188 -10.68541016 9.53992188 -12.27734375 9.453125 C-14.85223418 9.31138791 -17.4261874 9.15995446 -20 9 C-20 8.67 -20 8.34 -20 8 C-12.08 7.505 -12.08 7.505 -4 7 C-4.33 6.01 -4.66 5.02 -5 4 C-3.35 3.34 -1.7 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EF9DA0",
    transform: "translate(990,358)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C1.35 14.67 -0.3 14.34 -2 14 C-2 13.34 -2 12.68 -2 12 C-1.34 12 -0.68 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#F7FCF6",
    transform: "translate(815,556)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C4 1.99 4 2.98 4 4 C4.66 4.33 5.32 4.66 6 5 C6.5625 6.875 6.5625 6.875 7 9 C7.33 9.99 7.66 10.98 8 12 C6.35 11.67 4.7 11.34 3 11 C2.67 9.68 2.34 8.36 2 7 C1.34 7 0.68 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#8DB98F",
    transform: "translate(918,559)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.53720703 0.01450195 1.53720703 0.01450195 3.10546875 0.02929688 C4.70068359 0.06700195 4.70068359 0.06700195 6.328125 0.10546875 C7.94654297 0.12577148 7.94654297 0.12577148 9.59765625 0.14648438 C12.2583192 0.18180291 14.91796796 0.23112676 17.578125 0.29296875 C17.578125 0.62296875 17.578125 0.95296875 17.578125 1.29296875 C14.608125 1.29296875 11.638125 1.29296875 8.578125 1.29296875 C8.578125 1.95296875 8.578125 2.61296875 8.578125 3.29296875 C2.638125 3.29296875 -3.301875 3.29296875 -9.421875 3.29296875 C-5.29632592 0.19880694 -4.76516524 -0.07941942 0 0 Z ",
    fill: "#FDEFE9",
    transform: "translate(957.421875,362.70703125)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.125 0.9375 2.125 0.9375 4 2 C4 3.98 4 5.96 4 8 C2.02 8.99 2.02 8.99 0 10 C-2 8 -2 8 -2.125 4.375 C-2.08375 3.26125 -2.0425 2.1475 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#18782A",
    transform: "translate(905,559)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.67 4.63 3.34 8.26 3 12 C3.99 12 4.98 12 6 12 C6 12.66 6 13.32 6 14 C4.02 14 2.04 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FCFDFB",
    transform: "translate(671,557)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.88036541 1.67491831 8.99152948 4.36791961 13.3125 7.125 C14.05306641 7.59292969 14.79363281 8.06085938 15.55664062 8.54296875 C17.37341968 9.69164196 19.18703037 10.84532369 21 12 C21.33 10.68 21.66 9.36 22 8 C22.33 10.31 22.66 12.62 23 15 C17.92998211 13.29647399 13.69576679 10.40136888 9.25 7.5 C8.47011719 7.00113281 7.69023438 6.50226563 6.88671875 5.98828125 C6.14550781 5.50746094 5.40429688 5.02664063 4.640625 4.53125 C3.62790527 3.87479492 3.62790527 3.87479492 2.59472656 3.20507812 C1 2 1 2 0 0 Z ",
    fill: "#158127",
    transform: "translate(821,362)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C4 3.98 4 5.96 4 8 C2.02 8.99 2.02 8.99 0 10 C-2 8 -2 8 -2.25 5 C-2 2 -2 2 0 0 Z ",
    fill: "#177729",
    transform: "translate(1003,559)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 1.32 11 2.64 11 4 C11.66 4.33 12.32 4.66 13 5 C12.34 6.65 11.68 8.3 11 10 C10.67 8.68 10.34 7.36 10 6 C7.69 6 5.38 6 3 6 C3.33 5.01 3.66 4.02 4 3 C5.65 3 7.3 3 9 3 C9 2.34 9 1.68 9 1 C6.03 1 3.06 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#409450",
    transform: "translate(578,556)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.9765625 4.8203125 1.9765625 4.8203125 1.625 8.125 C1.51414062 9.22070312 1.40328125 10.31640625 1.2890625 11.4453125 C1.14597656 12.70988281 1.14597656 12.70988281 1 14 C0.34 14 -0.32 14 -1 14 C-1 15.98 -1 17.96 -1 20 C-2.32 18.68 -3.64 17.36 -5 16 C-4.67 15.34 -4.34 14.68 -4 14 C-3.67 14 -3.34 14 -3 14 C-2.01 9.38 -1.02 4.76 0 0 Z ",
    fill: "#EF9A9C",
    transform: "translate(905,290)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.06058594 0.74765625 3.12117187 1.4953125 3.18359375 2.265625 C3.26738281 3.25046875 3.35117187 4.2353125 3.4375 5.25 C3.51871094 6.22453125 3.59992187 7.1990625 3.68359375 8.203125 C3.95074584 10.56461753 4.35371968 12.71901065 5 15 C3.0625 14.625 3.0625 14.625 1 14 C-0.38226016 11.23547967 -0.09525387 8.9538637 -0.0625 5.875 C-0.05347656 4.77929688 -0.04445313 3.68359375 -0.03515625 2.5546875 C-0.02355469 1.71164062 -0.01195312 0.86859375 0 0 Z ",
    fill: "#EAF3EA",
    transform: "translate(791,556)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 5.28 5 10.56 5 16 C1 11 1 11 0 8 C0.66 7.34 1.32 6.68 2 6 C1.64644564 3.73725212 1.02455574 2.04911148 0 0 Z ",
    fill: "#04660C",
    transform: "translate(573,556)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C4 3.98 4 5.96 4 8 C2.34385343 8.38218767 0.67542976 8.71395102 -1 9 C-2 8 -2 8 -2.1875 5.0625 C-2 2 -2 2 0 0 Z ",
    fill: "#147526",
    transform: "translate(945,559)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 0.99 10 1.98 10 3 C8.02 3 6.04 3 4 3 C3.67 3.99 3.34 4.98 3 6 C2.67 5.34 2.34 4.68 2 4 C1.67 7.63 1.34 11.26 1 15 C0.67 15 0.34 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#D2E7D1",
    transform: "translate(685,556)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C7.01 0.66 6.02 1.32 5 2 C5.66 2.33 6.32 2.66 7 3 C7 4.32 7 5.64 7 7 C5.68 7 4.36 7 3 7 C2.67 6.34 2.34 5.68 2 5 C1.67 8.3 1.34 11.6 1 15 C0.67 15 0.34 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#7FB585",
    transform: "translate(625,556)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.29585916 0.42492126 2.5866044 0.86545882 3.875 1.3125 C4.59429688 1.55613281 5.31359375 1.79976563 6.0546875 2.05078125 C8 3 8 3 10 6 C11.32 6 12.64 6 14 6 C14 7.65 14 9.3 14 11 C12.9275 10.360625 11.855 9.72125 10.75 9.0625 C8.67398291 7.85949613 7.17474059 7.03494812 4.8125 6.5625 C1.90475357 5.66009593 0.72084147 3.39688634 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#A4B690",
    transform: "translate(834,353)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.455 0.99 4.455 0.99 9 2 C8.67 3.32 8.34 4.64 8 6 C6.2709226 6.02725341 4.54171824 6.04650987 2.8125 6.0625 C1.36810547 6.07990234 1.36810547 6.07990234 -0.10546875 6.09765625 C-2.85576513 6.00486622 -5.32479591 5.62111685 -8 5 C-8 4.67 -8 4.34 -8 4 C-4.7 3.67 -1.4 3.34 2 3 C1.34 2.01 0.68 1.02 0 0 Z ",
    fill: "#FE5974",
    transform: "translate(878,353)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C4.99 4.63 5.98 8.26 7 12 C5.68 11.67 4.36 11.34 3 11 C2.67 9.68 2.34 8.36 2 7 C1.34 7 0.68 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#B4D0B4",
    transform: "translate(958,559)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.95 3 9.9 3 15 C2.01 15 1.02 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#F4FBF4",
    transform: "translate(821,556)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.66 -0.66 1.32 -1 2 C0.32 2.66 1.64 3.32 3 4 C0.72923158 4.02699725 -1.54162821 4.04639453 -3.8125 4.0625 C-5.70935547 4.07990234 -5.70935547 4.07990234 -7.64453125 4.09765625 C-11 4 -11 4 -14 3 C-14 2.34 -14 1.68 -14 1 C-9.27616037 0.34843591 -4.78025483 -0.11950637 0 0 Z ",
    fill: "#F7FBF6",
    transform: "translate(814,403)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 1.32 -0.66 2.64 -1 4 C-0.34 4.33 0.32 4.66 1 5 C1.33 4.34 1.66 3.68 2 3 C2.33 3.99 2.66 4.98 3 6 C2.38511719 6.19335938 1.77023437 6.38671875 1.13671875 6.5859375 C0.32847656 6.84632813 -0.47976563 7.10671875 -1.3125 7.375 C-2.11300781 7.63023437 -2.91351562 7.88546875 -3.73828125 8.1484375 C-6.22724528 8.98831811 -6.22724528 8.98831811 -9 11 C-8.40300869 7.66864109 -7.27987719 5.78724333 -5.0625 3.25 C-4.53785156 2.63640625 -4.01320313 2.0228125 -3.47265625 1.390625 C-2 0 -2 0 0 0 Z ",
    fill: "#F6DDD7",
    transform: "translate(972,328)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 0 4 0 6 0 C6 5.28 6 10.56 6 16 C6.99 16.33 7.98 16.66 9 17 C7.35 16.67 5.7 16.34 4 16 C3.96261719 15.26394531 3.92523437 14.52789063 3.88671875 13.76953125 C3.47015527 6.39587342 3.47015527 6.39587342 0 0 Z ",
    fill: "#157624",
    transform: "translate(909,556)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.03738281 0.83144531 3.07476563 1.66289063 3.11328125 2.51953125 C3.17902344 3.60621094 3.24476563 4.69289063 3.3125 5.8125 C3.37050781 6.89144531 3.42851563 7.97039063 3.48828125 9.08203125 C4.03839868 12.2189604 4.49684514 13.13490422 7 15 C9.09989652 16.17574711 9.09989652 16.17574711 11 17 C7.53058454 16.54177532 4.32604951 16.10868317 1 15 C0.67 10.05 0.34 5.1 0 0 Z ",
    fill: "#056C11",
    transform: "translate(788,556)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.81690103 2.84971819 -0.39750267 4.67944216 -1.625 6.5 C-2.29789063 7.5209375 -2.97078125 8.541875 -3.6640625 9.59375 C-6 12 -6 12 -9.2734375 12.34375 C-10.17320312 12.2303125 -11.07296875 12.116875 -12 12 C-12.33 12.66 -12.66 13.32 -13 14 C-12.67 11.03 -12.34 8.06 -12 5 C-11.67 5 -11.34 5 -11 5 C-11 6.98 -11 8.96 -11 11 C-9.72486237 9.92173635 -8.45507431 8.83714481 -7.1875 7.75 C-6.47980469 7.14671875 -5.77210938 6.5434375 -5.04296875 5.921875 C-3.08110329 4.07629602 -1.54330375 2.20054668 0 0 Z ",
    fill: "#F8E4DE",
    transform: "translate(945,299)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 4.62 3 9.24 3 14 C2.01 14 1.02 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#F9FCF7",
    transform: "translate(992,557)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.08450717 0.2831556 4.16758367 0.57685669 6.25 0.875 C7.99023438 1.11863281 7.99023438 1.11863281 9.765625 1.3671875 C12.58193313 1.91820431 14.55217557 2.55796482 17 4 C16.360625 4.12375 15.72125 4.2475 15.0625 4.375 C14.381875 4.58125 13.70125 4.7875 13 5 C12.67 5.66 12.34 6.32 12 7 C11.34 5.68 10.68 4.36 10 3 C9.34 3.66 8.68 4.32 8 5 C6.01178687 5.39764263 4.01055661 5.73775349 2 6 C1.34 4.02 0.68 2.04 0 0 Z ",
    fill: "#AE9E86",
    transform: "translate(979,392)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.66 -0.66 1.32 -1 2 C-6.94 1.01 -6.94 1.01 -13 0 C-12.67 0.99 -12.34 1.98 -12 3 C-12.66 3 -13.32 3 -14 3 C-14.66 1.02 -15.32 -0.96 -16 -3 C-10.64501462 -4.78499513 -5.19086048 -1.77248894 0 0 Z ",
    fill: "#F4E7DF",
    transform: "translate(993,393)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.84614024 2.84614024 2.45579076 5.80369142 2.625 9.625 C2.66367187 10.33140625 2.70234375 11.0378125 2.7421875 11.765625 C2.83647724 13.50998524 2.91932891 15.25495691 3 17 C1.35 17.33 -0.3 17.66 -2 18 C-2.66 16.68 -3.32 15.36 -4 14 C-3.34 14 -2.68 14 -2 14 C-2 14.66 -2 15.32 -2 16 C-1.01 16 -0.02 16 1 16 C0.67 10.72 0.34 5.44 0 0 Z ",
    fill: "#FE5672",
    transform: "translate(902,320)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.125 5.75 1.125 5.75 0 8 C0.99 8.33 1.98 8.66 3 9 C2.01 9.33 1.02 9.66 0 10 C-0.33 10.99 -0.66 11.98 -1 13 C-2.32 12.67 -3.64 12.34 -5 12 C-4.35758106 10.186287 -3.71096881 8.37405876 -3.0625 6.5625 C-2.70285156 5.55316406 -2.34320312 4.54382813 -1.97265625 3.50390625 C-1 1 -1 1 0 0 Z ",
    fill: "#F2F8F0",
    transform: "translate(740,558)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.37095624 3.69037278 0.60010967 5.70883835 -0.9375 9.25 C-1.31777344 10.14203125 -1.69804688 11.0340625 -2.08984375 11.953125 C-2.39019531 12.62859375 -2.69054687 13.3040625 -3 14 C-3.33 14 -3.66 14 -4 14 C-6.21538462 6.73846154 -6.21538462 6.73846154 -5.125 3 C-4.75375 2.34 -4.3825 1.68 -4 1 C-3.01 1.66 -2.02 2.32 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#147724",
    transform: "translate(738,557)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.625 -0.25 6.625 -0.25 10 2 C10.66 1.67 11.32 1.34 12 1 C12 6.28 12 11.56 12 17 C9.63988504 13.45982755 9.65480981 11.28664147 9.44140625 7.15625 C8.90015185 4.51224618 8.13291551 3.61721058 6 2 C2.89160979 1.2730774 2.89160979 1.2730774 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#04630C",
    transform: "translate(1001,555)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C5 3.98 5 5.96 5 8 C3.35 8.33 1.7 8.66 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#127724",
    transform: "translate(674,559)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C5 3.98 5 5.96 5 8 C3.35 8.33 1.7 8.66 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#137626",
    transform: "translate(754,559)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.47238653 1.41807378 8.71146306 3.11304374 13 5 C9.75518249 7.16321167 6.64944241 8.6314591 3 10 C2.01 9.67 1.02 9.34 0 9 C1.98 8.34 3.96 7.68 6 7 C6 6.01 6 5.02 6 4 C4.02 3.34 2.04 2.68 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#177B26",
    transform: "translate(809,380)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 1.65 8 3.3 8 5 C5.36 5 2.72 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FE899A",
    transform: "translate(944,352)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 5.28 1 10.56 1 16 C0.67 14.68 0.34 13.36 0 12 C-2.31 12 -4.62 12 -7 12 C-7 11.01 -7 10.02 -7 9 C-5.02 9 -3.04 9 -1 9 C-0.67 6.03 -0.34 3.06 0 0 Z ",
    fill: "#0B6E19",
    transform: "translate(624,556)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.65 0 3.3 0 5 C1.32 5 2.64 5 4 5 C4 5.66 4 6.32 4 7 C3.195625 7.12375 2.39125 7.2475 1.5625 7.375 C0.2940625 7.684375 0.2940625 7.684375 -1 8 C-1.33 8.66 -1.66 9.32 -2 10 C-2.99 10 -3.98 10 -5 10 C-4.71872579 8.51882199 -4.42466268 7.04006751 -4.125 5.5625 C-3.96257813 4.73878906 -3.80015625 3.91507813 -3.6328125 3.06640625 C-3.42398438 2.38449219 -3.21515625 1.70257812 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#F1F9F0",
    transform: "translate(861,561)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.125 3.75 1.125 3.75 0 6 C0.66 6.33 1.32 6.66 2 7 C1.01 7.33 0.02 7.66 -1 8 C-1 8.99 -1 9.98 -1 11 C-2.32 11 -3.64 11 -5 11 C-4.54917531 9.53932801 -4.08906463 8.08151968 -3.625 6.625 C-3.36976563 5.81289063 -3.11453125 5.00078125 -2.8515625 4.1640625 C-2 2 -2 2 0 0 Z ",
    fill: "#F1F9F0",
    transform: "translate(713,560)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.37125 0.639375 0.7425 1.27875 1.125 1.9375 C3.58052793 4.63858072 5.44578805 4.68407005 9 5 C9 5.99 9 6.98 9 8 C2.9453125 8.1953125 2.9453125 8.1953125 1 8 C0.34 7.34 -0.32 6.68 -1 6 C-0.625 2.875 -0.625 2.875 0 0 Z ",
    fill: "#F8FAF5",
    transform: "translate(889,563)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.33218272 0.84806644 3.44954313 1.8950996 5.0625 3.75 C4.0725 3.75 3.0825 3.75 2.0625 3.75 C2.0625 4.41 2.0625 5.07 2.0625 5.75 C2.7225 5.75 3.3825 5.75 4.0625 5.75 C4.0625 6.41 4.0625 7.07 4.0625 7.75 C1.1875 7.0625 1.1875 7.0625 -1.9375 5.75 C-3.3125 3.125 -3.3125 3.125 -3.9375 0.75 C-1.9375 -0.25 -1.9375 -0.25 0 0 Z ",
    fill: "#F5EFE8",
    transform: "translate(851.9375,351.25)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 5.28 1 10.56 1 16 C3.97 16 6.94 16 10 16 C10 16.33 10 16.66 10 17 C5.71 17 1.42 17 -3 17 C-2.01 16.67 -1.02 16.34 0 16 C-0.66 13.36 -1.32 10.72 -2 8 C-1.34 8 -0.68 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#056810",
    transform: "translate(870,556)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 0 -1.32 0 -2 0 C-2 2.31 -2 4.62 -2 7 C-4.31 6.67 -6.62 6.34 -9 6 C-9 5.01 -9 4.02 -9 3 C-7.02 3 -5.04 3 -3 3 C-3 2.34 -3 1.68 -3 1 C-5.97 1 -8.94 1 -12 1 C-12 0.67 -12 0.34 -12 0 C-10.56359829 -0.19573608 -9.12580496 -0.38127816 -7.6875 -0.5625 C-6.88699219 -0.66691406 -6.08648438 -0.77132812 -5.26171875 -0.87890625 C-3 -1 -3 -1 0 0 Z ",
    fill: "#3E914C",
    transform: "translate(626,556)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 1.32 0 2.64 0 4 C-1.65 3.67 -3.3 3.34 -5 3 C-5 3.99 -5 4.98 -5 6 C-6.32 6.33 -7.64 6.66 -9 7 C-8.625 4.0625 -8.625 4.0625 -8 1 C-5.29120665 -0.35439668 -2.99066732 -0.06501451 0 0 Z ",
    fill: "#E1F0E1",
    transform: "translate(706,556)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 3 2 3 2 5 C3.32 5.33 4.64 5.66 6 6 C5.01 6.33 4.02 6.66 3 7 C3 8.98 3 10.96 3 13 C2.01 13 1.02 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#F9FDFA",
    transform: "translate(626,558)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.03656917 2.5988655 4.46163739 5.62071728 6.1875 9.1875 C6.71730469 10.27417969 7.24710938 11.36085938 7.79296875 12.48046875 C8.19128906 13.31191406 8.58960938 14.14335937 9 15 C8.01 15.33 7.02 15.66 6 16 C4.99303432 13.89915791 3.9946411 11.79420511 3 9.6875 C2.443125 8.51574219 1.88625 7.34398437 1.3125 6.13671875 C0 3 0 3 0 0 Z ",
    fill: "#FCE5E1",
    transform: "translate(879,304)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.70840281 1.63412443 2.93453047 2.86906094 4 5 C4.99 5 5.98 5 7 5 C7.33 4.34 7.66 3.68 8 3 C8.5625 4.9375 8.5625 4.9375 9 7 C8 8 8 8 5.4375 8.0625 C4.633125 8.041875 3.82875 8.02125 3 8 C3 7.34 3 6.68 3 6 C2.01 6.66 1.02 7.32 0 8 C-0.99 7.67 -1.98 7.34 -3 7 C-2.34 6.67 -1.68 6.34 -1 6 C-0.34227572 2.97065509 -0.34227572 2.97065509 0 0 Z ",
    fill: "#157A26",
    transform: "translate(629,565)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0.66 4.62 1.32 7 2 C7 2.66 7 3.32 7 4 C4.09451118 6.04169485 2.59857954 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#97C09B",
    transform: "translate(724,564)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.52307692 -0.36923077 6.52307692 -0.36923077 8.9375 1.5 C9.288125 1.995 9.63875 2.49 10 3 C8.1875 5 8.1875 5 6 7 C5.01 7 4.02 7 3 7 C3 5.68 3 4.36 3 3 C3.66 3 4.32 3 5 3 C5 2.34 5 1.68 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#95BE96",
    transform: "translate(846,556)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.67 3.3 3.34 6.6 3 10 C2.01 10 1.02 10 0 10 C0 8.35 0 6.7 0 5 C-0.99 5.495 -0.99 5.495 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z ",
    fill: "#A4C6A3",
    transform: "translate(713,556)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 5.28 1.66 10.56 2 16 C1.67 16 1.34 16 1 16 C0.67 17.65 0.34 19.3 0 21 C-0.33 21 -0.66 21 -1 21 C-1.33 16.71 -1.66 12.42 -2 8 C-1.67 8 -1.34 8 -1 8 C-0.67 5.36 -0.34 2.72 0 0 Z ",
    fill: "#FCD9D8",
    transform: "translate(906,316)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.4370809 -0.05422947 2.87475462 -0.09289723 4.3125 -0.125 C5.11300781 -0.14820313 5.91351562 -0.17140625 6.73828125 -0.1953125 C9 0 9 0 12 2 C13.3125 4.3125 13.3125 4.3125 14 7 C13.125 9.8125 13.125 9.8125 12 12 C11.01 11.34 10.02 10.68 9 10 C9.33 9.67 9.66 9.34 10 9 C10.04092937 6.66702567 10.04241723 4.33294775 10 2 C6.7 1.67 3.4 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#076B12",
    transform: "translate(845,555)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.67 1.33 3.34 1.66 3 2 C2.95907063 4.33297433 2.95758277 6.66705225 3 9 C2.01 9 1.02 9 0 9 C-1.125 6.75 -1.125 6.75 -2 4 C-1.125 1.6875 -1.125 1.6875 0 0 Z ",
    fill: "#AFD0B1",
    transform: "translate(861,556)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C-6.92 4 -14.84 4 -23 4 C-23 3.67 -23 3.34 -23 3 C-21.75863281 2.95101563 -20.51726563 2.90203125 -19.23828125 2.8515625 C-17.59633306 2.77650201 -15.95440703 2.70095561 -14.3125 2.625 C-13.49587891 2.5940625 -12.67925781 2.563125 -11.83789062 2.53125 C-7.49873367 2.32044076 -3.95716543 1.98261241 0 0 Z ",
    fill: "#539151",
    transform: "translate(801,367)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.59391114 1.33488128 6.75490696 2.96022723 10 5 C9.34 6.32 8.68 7.64 8 9 C6.66079162 7.88200014 5.32877444 6.75538103 4 5.625 C2.88625 4.68527344 2.88625 4.68527344 1.75 3.7265625 C1.1725 3.15679687 0.595 2.58703125 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#E8F3E7",
    transform: "translate(821,364)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4.33 2.31 4.66 4.62 5 7 C3.02 6.34 1.04 5.68 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#269148",
    transform: "translate(893,561)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C3.67 3.3 3.34 6.6 3 10 C2.34 10 1.68 10 1 10 C0.67 8.68 0.34 7.36 0 6 C-0.99 6.495 -0.99 6.495 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#A0C4A1",
    transform: "translate(971,556)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.22987798 0.50512524 11.45474233 3.32604123 17 6 C16.01 6.66 15.02 7.32 14 8 C9.38 5.69 4.76 3.38 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#246F32",
    transform: "translate(1011,407)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.29399934 0.22760307 4.58527637 0.48278879 6.875 0.75 C8.15117188 0.88921875 9.42734375 1.0284375 10.7421875 1.171875 C14 2 14 2 15.4453125 4.078125 C15.62835937 4.71234375 15.81140625 5.3465625 16 6 C12.34056353 5.31092878 8.77558041 4.43178734 5.1875 3.4375 C4.21167969 3.16808594 3.23585938 2.89867187 2.23046875 2.62109375 C1.12638672 2.31365234 1.12638672 2.31365234 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#63965D",
    transform: "translate(817,349)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.24864725 0.22245975 -4.49902623 0.42746557 -6.75 0.625 C-8.62945313 0.79902344 -8.62945313 0.79902344 -10.546875 0.9765625 C-13.83586903 0.99888599 -15.31020776 0.77961002 -18 -1 C-5.51291306 -3.03870807 -5.51291306 -3.03870807 0 0 Z ",
    fill: "#1A712C",
    transform: "translate(732,377)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02708567 1.60407328 1.04643483 3.2082785 1.0625 4.8125 C1.07410156 5.70582031 1.08570313 6.59914063 1.09765625 7.51953125 C1 10 1 10 0 13 C-0.66 13 -1.32 13 -2 13 C-2.66 14.65 -3.32 16.3 -4 18 C-4.33 17.34 -4.66 16.68 -5 16 C-4.2578125 13.828125 -4.2578125 13.828125 -3.125 11.25 C-1.54312175 7.4862207 -0.43070758 4.09172196 0 0 Z ",
    fill: "#1B832F",
    transform: "translate(849,366)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 1.32 7 2.64 7 4 C6.34 4.66 5.68 5.32 5 6 C4.34 4.68 3.68 3.36 3 2 C2.34 3.32 1.68 4.64 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#177F2C",
    transform: "translate(849,566)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.45125548 2.45125548 3.48196328 4.99671265 4.90234375 8.125 C6.00230009 10.31773269 6.00230009 10.31773269 9 12 C6.23723823 11.47731534 3.6739124 10.89130413 1 10 C-0.1577506 6.52674819 -0.06866652 3.63932552 0 0 Z ",
    fill: "#127521",
    transform: "translate(1016,561)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0.66 5.28 1.32 8 2 C8 2.99 8 3.98 8 5 C5.36 5 2.72 5 0 5 C-0.33 4.01 -0.66 3.02 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#E7F3E8",
    transform: "translate(829,566)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6.4606285 2.64738916 7 3.89448334 7 7 C6.01 7 5.02 7 4 7 C3.34 5.68 2.68 4.36 2 3 C1.67 4.65 1.34 6.3 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#D6E9D6",
    transform: "translate(808,561)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 1 1.68 1 1 1 C1 4.96 1 8.92 1 13 C0.01 13 -0.98 13 -2 13 C-1.85966889 11.02043559 -1.7125877 9.04134859 -1.5625 7.0625 C-1.48128906 5.96035156 -1.40007813 4.85820313 -1.31640625 3.72265625 C-1 1 -1 1 0 0 Z ",
    fill: "#F9FDF8",
    transform: "translate(773,558)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.75 -0.125 6.75 -0.125 9 1 C9 3.97 9 6.94 9 10 C8.67 10 8.34 10 8 10 C7.979375 9.2575 7.95875 8.515 7.9375 7.75 C6.85412074 4.57208751 6.25525588 4.27248768 3.4375 2.6875 C2.303125 2.130625 1.16875 1.57375 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#CDE5CD",
    transform: "translate(671,556)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.15171623 -0.09038099 9.91913204 0.15318867 15 1 C15.33 2.32 15.66 3.64 16 5 C15.43152344 4.79503906 14.86304688 4.59007812 14.27734375 4.37890625 C9.4915546 2.70907331 5.04056799 1.53623064 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F0ACA9",
    transform: "translate(860,328)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C1.99 14 2.98 14 4 14 C4 14.66 4 15.32 4 16 C1.03 15.67 -1.94 15.34 -5 15 C-5 14.67 -5 14.34 -5 14 C-3.35 14 -1.7 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#4EA262",
    transform: "translate(927,557)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.92759992 1.67617384 2.90534623 2.59772148 3.5 5.125 C3.665 5.74375 3.83 6.3625 4 7 C4.99 7.33 5.98 7.66 7 8 C3.37 8 -0.26 8 -4 8 C-2.68 7.67 -1.36 7.34 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#107420",
    transform: "translate(569,565)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C2.98 3 4.96 3 7 3 C7 3.99 7 4.98 7 6 C4.03 6 1.06 6 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z ",
    fill: "#E6F2E7",
    transform: "translate(688,565)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 1.98 1.66 3.96 2 6 C2.66 6 3.32 6 4 6 C4 7.98 4 9.96 4 12 C2.68 12 1.36 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#D1E6D0",
    transform: "translate(565,559)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 2.32 1.68 3.64 1 5 C1.99 5 2.98 5 4 5 C4 6.32 4 7.64 4 9 C1.525 8.01 1.525 8.01 -1 7 C-1.04254356 5.00045254 -1.04080783 2.99958364 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#157222",
    transform: "translate(555,560)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.65 0.66 3.3 1 5 C0.01 5.495 0.01 5.495 -1 6 C-1.33 4.68 -1.66 3.36 -2 2 C-3.32 1.67 -4.64 1.34 -6 1 C-6.33 1.99 -6.66 2.98 -7 4 C-7.33 2.68 -7.66 1.36 -8 0 C-4.94736336 -0.98120464 -3.05263664 -0.98120464 0 0 Z ",
    fill: "#F0F9F0",
    transform: "translate(937,558)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C2.125 4.75 2.125 4.75 1 7 C-0.65 7 -2.3 7 -4 7 C-2.76582217 4.53164435 -1.60337726 2.25660504 0 0 Z ",
    fill: "#E0EFE2",
    transform: "translate(666,556)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.05391993 1.79133978 0.09275571 3.58313899 0.125 5.375 C0.14820313 6.37273437 0.17140625 7.37046875 0.1953125 8.3984375 C0 11 0 11 -2 13 C-2 9.7 -2 6.4 -2 3 C-2.99 2.67 -3.98 2.34 -5 2 C-1.125 0 -1.125 0 0 0 Z ",
    fill: "#117C23",
    transform: "translate(883,397)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.63 1 7.26 1 11 C0.01 11 -0.98 11 -2 11 C-1.85957123 9.35369672 -1.71250671 7.70795821 -1.5625 6.0625 C-1.48128906 5.14597656 -1.40007813 4.22945312 -1.31640625 3.28515625 C-1 1 -1 1 0 0 Z ",
    fill: "#FAFBF9",
    transform: "translate(985,560)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.6875 5.3125 -0.6875 5.3125 -3 8 C-4.38105716 9.97161022 -5.68616021 11.98231747 -7 14 C-7.33 13.01 -7.66 12.02 -8 11 C-6.6015625 8.5546875 -6.6015625 8.5546875 -4.625 5.875 C-3.65433594 4.54082031 -3.65433594 4.54082031 -2.6640625 3.1796875 C-1 1 -1 1 0 0 Z ",
    fill: "#2EA34B",
    transform: "translate(492,462)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.44333045 1.9884096 -1.12062426 2.96535082 -2.6875 3.9375 C-3.55761719 4.48277344 -4.42773438 5.02804687 -5.32421875 5.58984375 C-7.94624689 6.97167172 -10.08310075 7.58480173 -13 8 C-9.10904843 4.59541738 -4.88634235 1.75822032 0 0 Z M-15 8 C-14.01 8.495 -14.01 8.495 -13 9 C-13.99 9.495 -13.99 9.495 -15 10 C-15 9.34 -15 8.68 -15 8 Z ",
    fill: "#2EA34A",
    transform: "translate(542,424)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97851562 0.53710938 2.97851562 0.53710938 5.95703125 1.07421875 C6.28703125 2.06421875 6.61703125 3.05421875 6.95703125 4.07421875 C2.99703125 3.74421875 -0.96296875 3.41421875 -5.04296875 3.07421875 C-2.04296875 0.07421875 -2.04296875 0.07421875 0 0 Z ",
    fill: "#EC9A9A",
    transform: "translate(981.04296875,329.92578125)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C1.66 1.67 2.32 1.34 3 1 C4.99960012 0.960008 7.00047242 0.95653201 9 1 C9 1.99 9 2.98 9 4 C6.03 4 3.06 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#E8F3EA",
    transform: "translate(871,567)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.67 1.66 1.34 2.32 1 3 C1.60578253 5.01927511 2.26919734 7.02253397 3 9 C1.68 8.67 0.36 8.34 -1 8 C-1.625 5.125 -1.625 5.125 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#F4F9F2",
    transform: "translate(573,562)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 3.31 2 5.62 2 8 C1.01 8.33 0.02 8.66 -1 9 C-1.33 6.69 -1.66 4.38 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F5FAF2",
    transform: "translate(1009,559)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.875 0.1875 1.875 0.1875 4 1 C5.25 3.5625 5.25 3.5625 6 6 C4.68 6.33 3.36 6.66 2 7 C2 6.34 2 5.68 2 5 C1.34 5 0.68 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#86B387",
    transform: "translate(931,559)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.66 5 1.32 5 2 C4.34 2 3.68 2 3 2 C2.87625 2.78375 2.7525 3.5675 2.625 4.375 C2 7 2 7 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#FBFEFA",
    transform: "translate(846,557)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-1.85625 1.37125 -1.85625 1.37125 -3.75 1.75 C-7.53631789 2.67479977 -9.46605499 3.95926599 -12 7 C-12.33 7 -12.66 7 -13 7 C-13 5.02 -13 3.04 -13 1 C-11.68 1 -10.36 1 -9 1 C-6.04335481 -0.4783226 -3.25770263 -0.06032783 0 0 Z ",
    fill: "#0D751D",
    transform: "translate(837,555)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-3.63 3.66 -7.26 4.32 -11 5 C-10.34 4.67 -9.68 4.34 -9 4 C-8.67 3.01 -8.34 2.02 -8 1 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#259B49",
    transform: "translate(976,429)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.66 3.96 1.32 6 2 C2.45612679 4.12632393 -0.90080096 4.70187643 -5 5 C-5.99 4.34 -6.98 3.68 -8 3 C-5.36 2.34 -2.72 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#1D6D2B",
    transform: "translate(656,384)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0.33 -1.98 0.66 -3 1 C-3.33 2.65 -3.66 4.3 -4 6 C-4.33 5.34 -4.66 4.68 -5 4 C-6.32 4.33 -7.64 4.66 -9 5 C-7.93411431 2.09303901 -7.29651501 1.15567038 -4.5 -0.3125 C-2 -1 -2 -1 0 0 Z ",
    fill: "#F59B9B",
    transform: "translate(851,329)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.60018816 3.90028225 2.15085514 7.47434569 2 12 C1.34 12 0.68 12 0 12 C-0.19401633 10.18818595 -0.38004375 8.37551468 -0.5625 6.5625 C-0.66691406 5.55316406 -0.77132812 4.54382813 -0.87890625 3.50390625 C-0.91886719 2.67761719 -0.95882812 1.85132813 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F28B94",
    transform: "translate(933,292)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.95 1 9.9 1 15 C1.99 15.33 2.98 15.66 4 16 C0.67465243 17.10844919 -1.62182575 16.84454356 -5 16 C-5 15.67 -5 15.34 -5 15 C-3.35 15 -1.7 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#3B9752",
    transform: "translate(845,556)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5 2.65 5 4.3 5 6 C4.01 6.495 4.01 6.495 3 7 C2.34 6.34 1.68 5.68 1 5 C1.33 4.34 1.66 3.68 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#EFF6EF",
    transform: "translate(960,557)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 1.66 1.68 2.32 1 3 C-0.81500351 6.17625614 -1.89357499 9.52266426 -3 13 C-3.33 13 -3.66 13 -4 13 C-4.29543354 7.97762985 -4.00679573 5.0892422 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#AFCAA8",
    transform: "translate(804,354)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 2.98 0.02 4.96 -1 7 C-3.475 6.01 -3.475 6.01 -6 5 C-6 4.34 -6 3.68 -6 3 C-4.03533587 1.93224776 -2.03144641 0.93446535 0 0 Z ",
    fill: "#FDEDE9",
    transform: "translate(959,338)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C1.66 4 2.32 4 3 4 C3 4.66 3 5.32 3 6 C3.66 6 4.32 6 5 6 C5 6.66 5 7.32 5 8 C3.33388095 8.042721 1.66617115 8.04063832 0 8 C-1 7 -1 7 -1.125 4 C-1 1 -1 1 0 0 Z ",
    fill: "#FE5D77",
    transform: "translate(930,332)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.22245393 1.60226955 2.42746669 3.20696767 2.625 4.8125 C2.74101563 5.70582031 2.85703125 6.59914063 2.9765625 7.51953125 C3 10 3 10 1 13 C-0.00496852 9.98509443 -0.10335303 7.95818308 -0.0625 4.8125 C-0.05347656 3.91144531 -0.04445313 3.01039063 -0.03515625 2.08203125 C-0.02355469 1.39496094 -0.01195312 0.70789063 0 0 Z ",
    fill: "#EDC5BC",
    transform: "translate(865,304)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 2.64 3 5.28 3 8 C2.01 8 1.02 8 0 8 C-0.98120464 4.94736336 -0.98120464 3.05263664 0 0 Z ",
    fill: "#1F893C",
    transform: "translate(979,561)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.0625 1.75 2.0625 1.75 4 4 C3.75 6.25 3.75 6.25 3 8 C0.525 7.01 0.525 7.01 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z ",
    fill: "#1B8B3B",
    transform: "translate(706,556)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.625 1.875 6.625 1.875 7 4 C6.34 4.66 5.68 5.32 5 6 C5 5.01 5 4.02 5 3 C3.35 3 1.7 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#298038",
    transform: "translate(689,559)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5.33 2.98 5.66 4.96 6 7 C5.67 6.34 5.34 5.68 5 5 C2.97536745 4.34786708 2.97536745 4.34786708 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#E8F5E7",
    transform: "translate(806,556)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.66 9 1.32 9 2 C7.02 2 5.04 2 3 2 C2.67 3.32 2.34 4.64 2 6 C2 5.01 2 4.02 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#FCFDF9",
    transform: "translate(614,557)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.80345877 -1.13786331 4.77701015 -3.5 7.6875 C-4.47453125 8.89986328 -4.47453125 8.89986328 -5.46875 10.13671875 C-5.9740625 10.75160156 -6.479375 11.36648438 -7 12 C-7.33 11.34 -7.66 10.68 -8 10 C-7.04367001 8.70684939 -6.08486149 7.41553147 -5.125 6.125 C-4.59132813 5.40570313 -4.05765625 4.68640625 -3.5078125 3.9453125 C-2 2 -2 2 0 0 Z ",
    fill: "#145D20",
    transform: "translate(494,457)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 2.485 1.01 2.485 0 4 C0.66 4.33 1.32 4.66 2 5 C0 7 0 7 -3 8 C-3.33 6.02 -3.66 4.04 -4 2 C-2.125 0.9375 -2.125 0.9375 0 0 Z ",
    fill: "#238636",
    transform: "translate(979,425)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7.33 0.66 7.66 1.32 8 2 C4.7 2.66 1.4 3.32 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#3B9248",
    transform: "translate(810,350)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.05495026 2.03663351 -5.44441261 3.1292439 -9 4 C-11.375 3.125 -11.375 3.125 -13 2 C-8.50343896 -0.24828052 -4.92127034 -0.16682272 0 0 Z ",
    fill: "#F7E6DC",
    transform: "translate(983,333)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.41824533 2.41824533 3.50075874 4.9390491 5 8 C5.99 9.485 5.99 9.485 7 11 C6.67 11.99 6.34 12.98 6 14 C2.84345952 9.41078616 0.42797202 5.70629354 0 0 Z ",
    fill: "#FC697D",
    transform: "translate(868,311)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 1 6 C-1.64 6 -4.28 6 -7 6 C-7 5.01 -7 4.02 -7 3 C-6.21625 3.061875 -5.4325 3.12375 -4.625 3.1875 C-3.75875 3.125625 -2.8925 3.06375 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#F4FAF4",
    transform: "translate(704,565)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.13586678 3.20380017 2.23132175 4.01939967 2.125 7.6875 C2.10695313 8.49574219 2.08890625 9.30398438 2.0703125 10.13671875 C2.04710937 10.75160156 2.02390625 11.36648438 2 12 C1.01 12 0.02 12 -1 12 C-0.67 8.04 -0.34 4.08 0 0 Z ",
    fill: "#FAFEFB",
    transform: "translate(1014,559)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.625 1.875 3.625 1.875 4 4 C3.34 4.66 2.68 5.32 2 6 C1.01 6 0.02 6 -1 6 C-1 5.34 -1 4.68 -1 4 C-1.66 3.67 -2.32 3.34 -3 3 C-2.01 3 -1.02 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#DAEBDB",
    transform: "translate(852,560)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2 1.66 2 2.32 2 3 C2.99 3 3.98 3 5 3 C5 5.31 5 7.62 5 10 C4.67 9.34 4.34 8.68 4 8 C3.34 8 2.68 8 2 8 C1.34 5.36 0.68 2.72 0 0 Z ",
    fill: "#198331",
    transform: "translate(717,556)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C4.01 1.495 4.01 1.495 3 2 C3 4.31 3 6.62 3 9 C2.34 9 1.68 9 1 9 C0.67 6.03 0.34 3.06 0 0 Z ",
    fill: "#99BE96",
    transform: "translate(740,556)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.40844718 3.21524305 -3.10344786 5.32183868 -5.625 7.75 C-6.57246094 8.67039062 -6.57246094 8.67039062 -7.5390625 9.609375 C-8.02117187 10.06828125 -8.50328125 10.5271875 -9 11 C-9 7.25983417 -8.0658409 6.54723807 -5.625 3.8125 C-4.99851562 3.09707031 -4.37203125 2.38164063 -3.7265625 1.64453125 C-2 0 -2 0 0 0 Z ",
    fill: "#1B6226",
    transform: "translate(1092,534)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-7.28571429 4.57142857 -7.28571429 4.57142857 -12 4 C-8.66437635 0.13769893 -4.98576775 -1.84658065 0 0 Z ",
    fill: "#2D9F48",
    transform: "translate(574,412)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.37305699 -0.35233161 5.37305699 -0.35233161 8 0 C10 2 10 2 11 4 C6.44262737 3.56179109 3.42346555 3.14958831 0 0 Z ",
    fill: "#35783E",
    transform: "translate(992,400)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.375 -0.125 3.375 -0.125 7 0 C7.66 0.66 8.32 1.32 9 2 C6.69 2.66 4.38 3.32 2 4 C1.34 2.68 0.68 1.36 0 0 Z ",
    fill: "#4A7E48",
    transform: "translate(982,397)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.11697928 1.45305151 7.54012204 3.32645794 11 6 C11.875 8.25 11.875 8.25 12 10 C11.34 9.67 10.68 9.34 10 9 C10 8.34 10 7.68 10 7 C8.68 6.67 7.36 6.34 6 6 C6 5.34 6 4.68 6 4 C5.195625 3.71125 4.39125 3.4225 3.5625 3.125 C1 2 1 2 0 0 Z ",
    fill: "#EB8C8F",
    transform: "translate(886,291)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.33 1.32 5.66 2.64 6 4 C5.34 3.67 4.68 3.34 4 3 C3.01 3.33 2.02 3.66 1 4 C0.67 2.68 0.34 1.36 0 0 Z M-4 4 C-2.35 4 -0.7 4 1 4 C1 4.33 1 4.66 1 5 C-0.65 5 -2.3 5 -4 5 C-4 4.67 -4 4.34 -4 4 Z ",
    fill: "#107722",
    transform: "translate(860,568)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 2.64 0.34 5.28 0 8 C-1.32 8 -2.64 8 -4 8 C-4 7.01 -4 6.02 -4 5 C-3.34 4.67 -2.68 4.34 -2 4 C-0.86649466 1.98330173 -0.86649466 1.98330173 0 0 Z ",
    fill: "#F6FAF4",
    transform: "translate(782,563)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.01 9 -0.98 9 -2 9 C-2.25 3.375 -2.25 3.375 0 0 Z ",
    fill: "#FBFDF9",
    transform: "translate(787,562)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.625 2.375 5.625 2.375 6 5 C5.34 5.66 4.68 6.32 4 7 C3.566875 6.0409375 3.566875 6.0409375 3.125 5.0625 C2.17176549 2.84793921 2.17176549 2.84793921 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F5FBF4",
    transform: "translate(945,557)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.93673644 1.31224548 6.22719294 2.91910327 9 6 C7.02 6.33 5.04 6.66 3 7 C2.01 4.69 1.02 2.38 0 0 Z ",
    fill: "#EAF1E7",
    transform: "translate(839,359)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 3.3 1.66 6.6 2 10 C1.01 10.33 0.02 10.66 -1 11 C-1.02688151 9.35425434 -1.04634123 7.70838587 -1.0625 6.0625 C-1.07410156 5.14597656 -1.08570313 4.22945313 -1.09765625 3.28515625 C-1 1 -1 1 0 0 Z ",
    fill: "#F8F1EA",
    transform: "translate(843,333)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C-2.455 4.485 -2.455 4.485 -7 6 C-5 2 -5 2 -3 1 C-2.01 1.33 -1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EDA6A5",
    transform: "translate(973,331)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.46735884 2.46735884 2.9072384 4.72171521 4 8 C4.66 8.66 5.32 9.32 6 10 C3.83125748 9.49396008 2.00032373 9.00016187 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#0E6D18",
    transform: "translate(775,563)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.65 0.66 3.3 1 5 C-0.32 5 -1.64 5 -3 5 C-3 4.34 -3 3.68 -3 3 C-3.66 3 -4.32 3 -5 3 C-5 2.34 -5 1.68 -5 1 C-3 0 -3 0 0 0 Z ",
    fill: "#83B285",
    transform: "translate(596,561)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2.33333333 2.33333333 2.66666667 3.66666667 3 5 C3.66 5.33 4.32 5.66 5 6 C5 6.66 5 7.32 5 8 C3.35 7.67 1.7 7.34 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#F9FDF8",
    transform: "translate(724,557)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 2.97 2.34 5.94 2 9 C-0.29013653 5.5647952 -0.17842973 4.014669 0 0 Z ",
    fill: "#F0F5ED",
    transform: "translate(815,556)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C5 2.33 5 2.66 5 3 C3.02 3 1.04 3 -1 3 C-1 5.64 -1 8.28 -1 11 C-1.33 11 -1.66 11 -2 11 C-2 8.03 -2 5.06 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#549050",
    transform: "translate(850,357)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C2.35 3.65 0.7 5.3 -1 7 C-1.66 6.34 -2.32 5.68 -3 5 C-2.01 3.35 -1.02 1.7 0 0 Z ",
    fill: "#EC9495",
    transform: "translate(948,293)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 1.98 2.66 3.96 3 6 C1.02 6.33 -0.96 6.66 -3 7 C-2.01 6.67 -1.02 6.34 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#10731F",
    transform: "translate(958,566)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.71843438 3.62457917 3.41789544 4.80884715 4 9 C3.34 8.34 2.68 7.68 2 7 C1.34 7.99 0.68 8.98 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#0D6915",
    transform: "translate(809,562)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 1.65 3.3 3.3 5 5 C3.68 5.33 2.36 5.66 1 6 C0.34 4.35 -0.32 2.7 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#F0F7F0",
    transform: "translate(632,565)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.52588702 2.36292656 3.88820837 3.66462511 5 7 C3.35 6.67 1.7 6.34 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#F2F8F0",
    transform: "translate(921,564)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.01 9.33 -0.98 9.66 -2 10 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#0D6E15",
    transform: "translate(784,562)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 2.31 2 4.62 2 7 C1.34 7 0.68 7 0 7 C-0.66 5.35 -1.32 3.7 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#137929",
    transform: "translate(575,562)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.31223496 3.93670488 0.24296256 6.12488144 -1 10 C-1.66 10 -2.32 10 -3 10 C-3.36629408 5.72656908 -2.40814077 3.51187196 0 0 Z ",
    fill: "#15711F",
    transform: "translate(782,556)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.38125 1.5775 0.7625 2.155 0.125 2.75 C-1.81347053 4.80249821 -2.90014249 6.43366582 -4 9 C-4.8125 7.3125 -4.8125 7.3125 -5 5 C-2.5625 2.25 -2.5625 2.25 0 0 Z ",
    fill: "#FEB01F",
    transform: "translate(901,345)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.55780196 0.60990891 6.6828589 1.5783681 10 3 C8.02 3.99 8.02 3.99 6 5 C3.98079663 3.69593116 1.98075027 2.36176581 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#F9E7E0",
    transform: "translate(864,329)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.99 5 1.98 5 3 C2.36 3 -0.28 3 -3 3 C-2.01 2.67 -1.02 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#E3EFE3",
    transform: "translate(893,568)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.74438677 2.3431213 2.40729228 4.67843403 2 7 C1.01 7.495 1.01 7.495 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#188330",
    transform: "translate(665,564)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C0.01 8 -0.98 8 -2 8 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#FCFEFA",
    transform: "translate(917,563)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.66 7 1.32 7 2 C6.01 2 5.02 2 4 2 C3.67 2.99 3.34 3.98 3 5 C1.5 3.625 1.5 3.625 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#F2FAF0",
    transform: "translate(565,557)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.39417765 3.12621626 5.6062718 5.56541027 7 10 C3.60582235 6.87378374 1.3937282 4.43458973 0 0 Z ",
    fill: "#2FA24B",
    transform: "translate(485,523)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98567708 0.5859375 3.97135417 1.171875 5.95703125 1.7578125 C5.62703125 2.4178125 5.29703125 3.0778125 4.95703125 3.7578125 C1.65703125 3.0978125 -1.64296875 2.4378125 -5.04296875 1.7578125 C-2.04296875 -0.2421875 -2.04296875 -0.2421875 0 0 Z ",
    fill: "#F4C7C4",
    transform: "translate(987.04296875,391.2421875)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 2.97 3 5.94 3 9 C2.34 8.67 1.68 8.34 1 8 C0.40644386 5.35139573 0.25790731 2.70802678 0 0 Z ",
    fill: "#209144",
    transform: "translate(601,561)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.67 1.99 1.34 2.98 1 4 C-0.98 4 -2.96 4 -5 4 C-4.34 3.34 -3.68 2.68 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#399046",
    transform: "translate(1044,571)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 1.66 3 2.32 3 3 C2.01 3.33 1.02 3.66 0 4 C-0.33 3.01 -0.66 2.02 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#D48E85",
    transform: "translate(996,361)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.01 3 -0.98 3 -2 3 C-1.34 2.67 -0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#3F8E43",
    transform: "translate(1092,449)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.68 1.33 -0.64 1.66 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#359043",
    transform: "translate(972,597)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#3C9348",
    transform: "translate(1108,507)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.34 3.34 -0.32 2.68 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#369044",
    transform: "translate(474,499)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#5C9F5D",
    transform: "translate(787,368)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#348F42",
    transform: "translate(672,611)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#389044",
    transform: "translate(489,538)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#369346",
    transform: "translate(1093,534)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#49934D",
    transform: "translate(1042,419)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#DD8180",
    transform: "translate(995,330)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#DD7A7B",
    transform: "translate(972,299)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#A7A74E",
    transform: "translate(948,1013)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#339043",
    transform: "translate(699,614)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#358F42",
    transform: "translate(676,612)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#359143",
    transform: "translate(633,604)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#369143",
    transform: "translate(602,597)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389246",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F44",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC55",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#369347",
    transform: "translate(562,410)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#389147",
    transform: "translate(568,408)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#389244",
    transform: "translate(674,380)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#E79292",
    transform: "translate(867,323)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#E49495",
    transform: "translate(865,317)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64C",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A8A64E",
    transform: "translate(948,1021)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#ACAA51",
    transform: "translate(1090,1003)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A7A64E",
    transform: "translate(948,997)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A750",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#ABA951",
    transform: "translate(1090,979)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A9A850",
    transform: "translate(1090,955)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54E",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A8A850",
    transform: "translate(1090,931)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A6A64F",
    transform: "translate(1090,891)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#A4A44F",
    transform: "translate(1090,843)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8F9747",
    transform: "translate(948,805)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95994A",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9EA24F",
    transform: "translate(1090,795)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#9BA04D",
    transform: "translate(1090,771)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#939C4C",
    transform: "translate(1090,739)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#919B4B",
    transform: "translate(1090,731)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#728A40",
    transform: "translate(948,717)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8C984A",
    transform: "translate(1090,715)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E8E45",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#88974A",
    transform: "translate(1090,699)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#859649",
    transform: "translate(1090,691)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#819448",
    transform: "translate(1090,675)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5E873F",
    transform: "translate(948,669)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7F9448",
    transform: "translate(1090,667)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7C9347",
    transform: "translate(1090,659)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#769146",
    transform: "translate(1090,643)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#698D41",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#6F9046",
    transform: "translate(1090,627)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#6C8F46",
    transform: "translate(1090,619)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#378E40",
    transform: "translate(798,619)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#339042",
    transform: "translate(864,615)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#348D41",
    transform: "translate(709,615)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#688F44",
    transform: "translate(1090,611)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#348F41",
    transform: "translate(902,611)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#358E42",
    transform: "translate(931,606)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#339043",
    transform: "translate(643,606)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#379042",
    transform: "translate(948,605)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#369042",
    transform: "translate(937,605)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#379244",
    transform: "translate(625,605)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#379344",
    transform: "translate(626,603)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5F8E44",
    transform: "translate(1090,595)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369045",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#399447",
    transform: "translate(521,564)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4D9044",
    transform: "translate(1090,563)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#488F43",
    transform: "translate(1090,555)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399344",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3D9245",
    transform: "translate(1090,539)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389244",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379145",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9044",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389148",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#398E45",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#388D42",
    transform: "translate(1102,464)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#368E43",
    transform: "translate(1093,456)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#408D42",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3E8F44",
    transform: "translate(1088,448)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#438C45",
    transform: "translate(1090,443)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#359146",
    transform: "translate(533,424)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B934C",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#678849",
    transform: "translate(1090,411)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379246",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#549454",
    transform: "translate(1019,408)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#6E864B",
    transform: "translate(1090,403)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#379346",
    transform: "translate(588,401)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#73844B",
    transform: "translate(1090,395)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7A814B",
    transform: "translate(1090,387)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#399444",
    transform: "translate(636,385)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#379244",
    transform: "translate(634,384)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3B9647",
    transform: "translate(704,376)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#41984C",
    transform: "translate(754,370)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#579E59",
    transform: "translate(784,368)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F8461",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A48260",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#88784B",
    transform: "translate(1090,355)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2A888",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8D754B",
    transform: "translate(1090,347)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#DE8284",
    transform: "translate(993,331)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#EB8B90",
    transform: "translate(976,330)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DD7F7F",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#906B47",
    transform: "translate(1090,323)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#906945",
    transform: "translate(1090,315)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#ED878B",
    transform: "translate(900,300)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#D88680",
    transform: "translate(864,295)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#8E6441",
    transform: "translate(1090,291)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3674F",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2654E",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#D77875",
    transform: "translate(912,273)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#855E39",
    transform: "translate(1090,251)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#825D37",
    transform: "translate(1090,243)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#815C35",
    transform: "translate(1090,235)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#845D3A",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7C5E33",
    transform: "translate(1090,219)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#795E32",
    transform: "translate(1090,211)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#765E2E",
    transform: "translate(1090,187)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#755E2E",
    transform: "translate(1090,179)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#74602C",
    transform: "translate(1090,163)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#73622C",
    transform: "translate(1090,147)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6328",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#786F2E",
    transform: "translate(1090,59)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7A7231",
    transform: "translate(1090,43)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7B7231",
    transform: "translate(1090,35)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#7C7433",
    transform: "translate(1090,27)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAC52",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB50",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A750",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64D",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A850",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A551",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC51",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAA51",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84F",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A44B",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54E",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A549",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE51",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB51",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A550",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A74F",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A74B",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAB52",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84F",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC4F",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB52",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA50",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A74E",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A74B",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A54D",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44E",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A44D",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AE52",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44A",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A54D",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB50",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64E",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A74E",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A64F",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A74F",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A34A",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC52",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA850",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44A",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A84E",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44E",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAD51",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB50",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A64F",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A54C",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84F",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A64E",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64C",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A34A",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE52",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC4F",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA850",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8AA4F",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44F",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE52",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA50",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA50",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A54D",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA94F",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A64E",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A54D",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44F",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2AE52",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA51",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA4F",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A950",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A24E",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34D",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54B",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE51",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A34A",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A74D",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64D",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54E",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A34F",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A54C",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64B",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A950",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54C",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA50",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A850",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A84F",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC52",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A74F",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A34C",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA50",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A74C",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A64D",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44D",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC50",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACA950",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A950",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A84E",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A84F",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A54E",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A44D",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A84E",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44B",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A54D",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA74D",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A850",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A44D",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A44E",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A24D",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A24A",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA50",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A74E",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A74F",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A24B",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA94E",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A951",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A64F",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44C",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A04A",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54A",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44D",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A84F",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A54D",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A44D",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34E",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A44A",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADA951",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A750",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A74E",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54D",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A14C",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A24A",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC51",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44B",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A84F",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A64D",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34C",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34D",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A850",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A94F",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A44C",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A24C",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC52",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A84D",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A750",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A34C",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A24E",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A94F",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A74F",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54E",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A449",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A74E",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA04B",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA04C",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A34A",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB52",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84E",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AF54",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A84F",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44C",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54B",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A74D",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A34D",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A04E",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64D",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A44E",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A34A",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A74D",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A64D",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A54A",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A44E",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34D",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A149",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A44D",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F4C",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB51",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A44C",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64D",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A850",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A34D",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA24D",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A54C",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64D",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A24C",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A14B",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A14D",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A04B",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34D",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A34C",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A751",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A64F",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F4B",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A24A",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A24C",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A64D",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A24E",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54B",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAB50",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A64F",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A14C",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A04E",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A34C",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64F",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A44E",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84E",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA4F",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA24B",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A84F",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A44D",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E49",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAB52",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A84F",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A64F",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA84F",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA04C",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F4D",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A04C",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A750",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34D",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A74C",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D48",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA14C",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D49",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA52",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA950",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA14A",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E4C",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34D",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA34D",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C49",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C4B",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA24B",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAB53",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D4A",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA850",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A54E",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA74D",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACA950",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F4A",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E4C",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA950",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A64D",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64E",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB50",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A74F",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA24D",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A24C",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A64E",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA74E",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A74F",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB53",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A54E",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACA94F",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA51",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E4B",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F4C",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A64E",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34D",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA14D",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B49",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F4A",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A84F",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E4A",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A54D",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A84F",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9E4A",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E4C",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A450",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A44E",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A34D",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA14C",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA14B",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F4B",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9C4A",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A650",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A44D",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C4A",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E4C",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACA951",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44F",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA04C",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D4A",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979948",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB53",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA51",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAD53",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D49",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E4C",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A34F",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D4B",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D4B",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B4B",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAD52",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A34D",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D4A",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE53",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D4B",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A4A",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B4B",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A64E",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAC52",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB53",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE54",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A74F",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA34D",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AE55",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959B48",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C4C",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE54",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A54F",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA14D",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9E4B",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999E4C",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929846",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909745",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979B4A",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAC53",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AE56",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA24D",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF55",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A48",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C4B",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A44F",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA24C",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A4A",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D4A",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A4A",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAA53",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA24C",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B156",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2AF57",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929948",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989B4C",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34F",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA14D",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A48",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D4B",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAC53",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA24C",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B156",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E4B",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919847",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969C4B",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B058",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A24F",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969C4A",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA44F",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#95994A",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA953",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA34E",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9E4C",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF56",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9646",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA04D",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAB54",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B157",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989F4B",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFB055",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B158",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999D4C",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9546",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959A4B",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B158",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989E4B",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929A4A",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A9244",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#899543",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AB54",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B158",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B259",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989E4C",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919A49",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AF56",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B259",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#93984A",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B259",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA34E",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA24F",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969C4B",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919948",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868D42",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919849",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909948",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B9346",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868C40",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858F44",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869044",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C9747",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAB53",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969D4B",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B35A",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949C4B",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#899345",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919749",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9848",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818D41",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838E40",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828D42",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E9548",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949D4B",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869244",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808C41",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F974A",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B35A",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#889446",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C9948",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828F41",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAF55",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#859244",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D8B3E",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C9547",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8AB53",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B157",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929C4B",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B35A",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839142",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9749",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999F4D",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969E4A",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B9748",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909749",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B158",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8D41",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858E44",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C9549",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A954",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909B4A",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839144",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B45B",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#809043",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D9549",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B35A",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99A24F",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989D4D",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909A49",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A9547",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C8D3F",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838F46",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55C",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA450",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79893E",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#879547",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E8F42",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55B",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D8E43",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C9548",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8B55A",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959C4D",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869447",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869345",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75893E",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8D42",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869247",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B9848",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B256",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55B",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B8E42",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#889349",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B9648",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#829246",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839245",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C8B43",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#899346",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B8D41",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B75C",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#798D41",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#788940",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#879347",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B8E43",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B158",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8B55C",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#889648",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#809144",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71873C",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#748A41",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#819346",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919B4B",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55C",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#758B42",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E863E",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#859147",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55C",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA34E",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F994B",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869546",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E9044",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#819045",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#708A3F",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B45C",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#849546",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#718940",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B158",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B45A",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7B55C",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#849146",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839346",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839045",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#849244",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A652",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#69853B",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#788E43",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#808F44",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B159",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#809546",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#718B41",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#829244",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7B65C",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E8A40",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#819146",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#788C44",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B9749",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#809245",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#758A43",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A9749",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#68843E",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A553",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7B45C",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E9146",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55B",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B8940",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B058",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839446",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E9145",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C9045",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#68863F",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A8B42",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#728D42",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D8B43",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B9146",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B45C",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BAB85E",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#688940",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D8F45",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929D4E",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B9045",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#708D43",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929D4C",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#798C44",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFB058",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA552",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B7B55C",
    transform: "translate(0,0)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66883F",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A8D45",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B974A",
    transform: "translate(0,0)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#859449",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8C42",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A8D44",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65883F",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA551",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#648940",
    transform: "translate(0,0)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#618840",
    transform: "translate(0,0)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#788C45",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C9444",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#698C42",
    transform: "translate(0,0)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61883F",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#768C43",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A651",
    transform: "translate(0,0)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C853F",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B45C",
    transform: "translate(0,0)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#768D45",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#608940",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#678B43",
    transform: "translate(0,0)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B65B",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#708E44",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C8840",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B55C",
    transform: "translate(0,0)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#59883F",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#57863E",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#51873E",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#738C44",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B55C",
    transform: "translate(0,0)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B45D",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#728C42",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B65B",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#678941",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C8F43",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#55873F",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#728D43",
    transform: "translate(0,0)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A9247",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F8B43",
    transform: "translate(0,0)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#608840",
    transform: "translate(0,0)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B45B",
    transform: "translate(0,0)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#52883F",
    transform: "translate(0,0)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8D45",
    transform: "translate(0,0)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE57",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A8A40",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#488A3E",
    transform: "translate(0,0)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAC57",
    transform: "translate(0,0)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B45C",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BBB85E",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C8A3F",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D8D44",
    transform: "translate(0,0)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B057",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969F4F",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#568B41",
    transform: "translate(0,0)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#478A3E",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E8A42",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B35A",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#608F44",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#468940",
    transform: "translate(0,0)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B45B",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#498B40",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A8D44",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D9949",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE56",
    transform: "translate(0,0)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949E4E",
    transform: "translate(0,0)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D8D43",
    transform: "translate(0,0)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C8C41",
    transform: "translate(0,0)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8C44",
    transform: "translate(0,0)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#769143",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#488941",
    transform: "translate(0,0)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#658A43",
    transform: "translate(0,0)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#358E41",
    transform: "translate(0,0)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B35C",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B8F43",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F41",
    transform: "translate(0,0)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B55B",
    transform: "translate(0,0)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#438B3F",
    transform: "translate(0,0)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#678C44",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929D4D",
    transform: "translate(0,0)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D8B42",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#388F41",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F44",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368E41",
    transform: "translate(0,0)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#388F41",
    transform: "translate(0,0)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#388F41",
    transform: "translate(0,0)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B056",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C9447",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A8F40",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389043",
    transform: "translate(0,0)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#648C42",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A8F42",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C9041",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919E4D",
    transform: "translate(0,0)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#338E43",
    transform: "translate(0,0)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368F44",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369144",
    transform: "translate(0,0)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349042",
    transform: "translate(0,0)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B45B",
    transform: "translate(0,0)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#358F40",
    transform: "translate(0,0)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#328D40",
    transform: "translate(0,0)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359143",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B45B",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368E41",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#348D40",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#358F41",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#339245",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#628D44",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B256",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378E3F",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#348D3F",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909C4D",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F9747",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#548D42",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#478D43",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389143",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379041",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389245",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E9647",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#398F42",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B9142",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B8F3F",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9D4E",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F41",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#338F41",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379042",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399241",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349043",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349144",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359244",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B35A",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#508F44",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F8D45",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B35A",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#648F45",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#508E42",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#428D43",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389344",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359041",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379545",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379445",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A8D42",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F41",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#338F41",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368D43",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C8E43",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379145",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B35A",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368F42",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399143",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#588E43",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399243",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359141",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D9044",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F42",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389144",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#899B4C",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368F44",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B35A",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B35A",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#458C42",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#328D43",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#578C44",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#88984B",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359243",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399445",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379246",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#518C43",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#869B4A",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B259",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9449",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#538E45",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38974A",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#568E45",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F8E43",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389143",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B9546",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E9044",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B9447",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7AB55",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#85994A",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9146",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378E45",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B25A",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E8E45",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B25A",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#528D45",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#488C44",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#839A4A",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B059",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399547",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B25A",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9448",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F9145",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#579045",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F9146",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#81994A",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#339144",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#35944B",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9143",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B258",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6B55A",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389046",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399244",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F8F42",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEB157",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#329143",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399246",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B159",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#409246",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B059",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#409244",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389045",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389246",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A953",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D9345",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379045",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9145",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B059",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9243",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B058",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379044",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#388F45",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D9044",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B257",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B058",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B058",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B9548",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369146",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369143",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC54",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A751",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B158",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389348",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AF58",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399146",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#378F47",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D9145",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349347",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAF56",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0B157",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AF57",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAF57",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B9447",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA52",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B9044",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#449044",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFB156",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFB058",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAF58",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B157",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359045",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#388F43",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389147",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#749247",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAE57",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAF57",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAE56",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A550",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE57",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A851",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9247",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389047",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#368E44",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#749245",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A44E",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAF56",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAE56",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAE55",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAE55",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379246",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9047",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA14D",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAE54",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC56",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAD56",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B359",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAD56",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B9246",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A951",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379145",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399146",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A44E",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#718E45",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB55",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9648",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A64E",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC55",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D9345",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAD53",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389247",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379248",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#708E44",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAC55",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC56",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369143",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8B41",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54F",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#468E44",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#339043",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8B43",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAC56",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAC55",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#339047",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AD54",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D8943",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349246",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8A42",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAB54",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB54",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E8E44",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E9146",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C9044",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#358E46",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B458",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#408E47",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359145",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9CA24C",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E8A41",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D8E44",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA04C",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E8641",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B8F44",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#468D43",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349347",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359146",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379047",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F8741",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A34E",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAA53",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74863E",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F8D43",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C8C46",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E9147",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379346",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399346",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A9146",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369146",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F9145",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C9046",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E9047",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379347",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34D",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A953",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#568A46",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399449",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#718340",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A952",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49914F",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D49",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A952",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46934C",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#468942",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48944E",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#359448",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A924E",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#438F4C",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B924D",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D944F",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#448F4D",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369346",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379045",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72813F",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#698042",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56934F",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#509352",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9D49",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA52",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#498842",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65894A",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#549353",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C924F",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#579452",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#589553",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9F4A",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737F3F",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B8344",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#679353",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A851",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8AA52",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B8641",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F803F",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C853F",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A04B",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A955E",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389548",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C7D3F",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#749763",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#799865",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#709961",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379045",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369448",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369447",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A46",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A951",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9D73",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A852",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989972",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E8340",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A752",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A853",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747B3D",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389548",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F8B41",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369446",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369445",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#349345",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D803E",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA952",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848F5B",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B057",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50813F",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379545",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369446",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369341",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389343",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#339446",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#369344",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389445",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A14D",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A751",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908B5D",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B47",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F4A",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAB51",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#537E3E",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E804D",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389746",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C49",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#389448",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399345",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#399445",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379245",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379245",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#379344",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77763A",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99885F",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#557E3C",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB8B81",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B9146",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777338",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D9949",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A823E",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40974C",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E9344",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#547D3B",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A34E",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CE8C82",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41984A",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#547C3A",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A751",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7844",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9B48",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A54E",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#587C3C",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787138",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#857A4C",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D98B8F",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A852",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5F7938",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D48E85",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#577A3A",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979946",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C49",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D68E8A",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A751",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#587A3A",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A651",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAAC8A",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75A16A",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A7A38",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A851",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C8740",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#577839",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A752",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB7E60",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999C47",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A751",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B057",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B793A",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#87A36F",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9A49",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92A173",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B6A38B",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B6F3B",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8BA16D",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AF795F",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A752",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D7839",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A752",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D7248",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#537A39",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C7837",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D7807E",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C8945",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B7736",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A750",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A752",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E7738",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9948",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B6A35",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#906E48",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DA817F",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EC9197",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D7836",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A04A",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E08282",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D97D7B",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF8285",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A850",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E69896",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EA9493",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A852",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D18F82",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#607737",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E3898F",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D98F85",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B6933",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D38F81",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DC8F84",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#658542",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B7636",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E48E8C",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A6A34",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA652",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD7159",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D47B73",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9947",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A753",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B59070",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#607436",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AC6F58",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D0796F",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D37871",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E49695",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A851",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#678341",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C7434",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A751",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B6933",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#796733",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6F56",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B47",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A852",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#607336",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A752",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E6735",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#906743",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A96E55",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB766B",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1A14B",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737A37",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#677535",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A6832",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A753",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EB8A8C",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A953",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E8848A",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#627435",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A752",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#906642",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A96B52",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E68389",
    transform: "translate(0,0)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#85643D",
    transform: "translate(0,0)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E5838A",
    transform: "translate(0,0)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A7535",
    transform: "translate(0,0)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D97577",
    transform: "translate(0,0)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D97C7D",
    transform: "translate(0,0)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#617234",
    transform: "translate(0,0)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A6630",
    transform: "translate(0,0)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E47E7F",
    transform: "translate(0,0)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#637235",
    transform: "translate(0,0)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E37F81",
    transform: "translate(0,0)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A66950",
    transform: "translate(0,0)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E37E7F",
    transform: "translate(0,0)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A7336",
    transform: "translate(0,0)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A04C",
    transform: "translate(0,0)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E37F87",
    transform: "translate(0,0)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E67F84",
    transform: "translate(0,0)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DF7C7B",
    transform: "translate(0,0)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E27C88",
    transform: "translate(0,0)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#617132",
    transform: "translate(0,0)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#796730",
    transform: "translate(0,0)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA753",
    transform: "translate(0,0)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D97A76",
    transform: "translate(0,0)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B49",
    transform: "translate(0,0)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D57973",
    transform: "translate(0,0)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#647234",
    transform: "translate(0,0)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#85613B",
    transform: "translate(0,0)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D6140",
    transform: "translate(0,0)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8B3E",
    transform: "translate(0,0)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#DE797B",
    transform: "translate(0,0)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A852",
    transform: "translate(0,0)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C6332",
    transform: "translate(0,0)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#607132",
    transform: "translate(0,0)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9A48",
    transform: "translate(0,0)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#786430",
    transform: "translate(0,0)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CB746C",
    transform: "translate(0,0)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#657233",
    transform: "translate(0,0)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#776330",
    transform: "translate(0,0)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B613C",
    transform: "translate(0,0)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA953",
    transform: "translate(0,0)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#607131",
    transform: "translate(0,0)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#D67975",
    transform: "translate(0,0)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A950",
    transform: "translate(0,0)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C6449",
    transform: "translate(0,0)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA852",
    transform: "translate(0,0)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C27065",
    transform: "translate(0,0)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#667033",
    transform: "translate(0,0)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A603C",
    transform: "translate(0,0)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BF6E62",
    transform: "translate(0,0)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A551",
    transform: "translate(0,0)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#627031",
    transform: "translate(0,0)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6853",
    transform: "translate(0,0)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA754",
    transform: "translate(0,0)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B76D5E",
    transform: "translate(0,0)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656F33",
    transform: "translate(0,0)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#657032",
    transform: "translate(0,0)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#865F39",
    transform: "translate(0,0)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A14D",
    transform: "translate(0,0)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A602F",
    transform: "translate(0,0)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946043",
    transform: "translate(0,0)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636F30",
    transform: "translate(0,0)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#946242",
    transform: "translate(0,0)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E6349",
    transform: "translate(0,0)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9C49",
    transform: "translate(0,0)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A753",
    transform: "translate(0,0)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AD6A57",
    transform: "translate(0,0)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#96724F",
    transform: "translate(0,0)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#677132",
    transform: "translate(0,0)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3644E",
    transform: "translate(0,0)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#786130",
    transform: "translate(0,0)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AB6955",
    transform: "translate(0,0)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676C34",
    transform: "translate(0,0)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#906140",
    transform: "translate(0,0)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C49",
    transform: "translate(0,0)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA953",
    transform: "translate(0,0)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A46751",
    transform: "translate(0,0)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676F31",
    transform: "translate(0,0)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09C4A",
    transform: "translate(0,0)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C6247",
    transform: "translate(0,0)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA953",
    transform: "translate(0,0)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#646E2F",
    transform: "translate(0,0)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A752",
    transform: "translate(0,0)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D5F3E",
    transform: "translate(0,0)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A1684E",
    transform: "translate(0,0)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA852",
    transform: "translate(0,0)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D664C",
    transform: "translate(0,0)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676F32",
    transform: "translate(0,0)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA753",
    transform: "translate(0,0)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B634B",
    transform: "translate(0,0)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959546",
    transform: "translate(0,0)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686E31",
    transform: "translate(0,0)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77602D",
    transform: "translate(0,0)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#895E3C",
    transform: "translate(0,0)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676E30",
    transform: "translate(0,0)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666D31",
    transform: "translate(0,0)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#776130",
    transform: "translate(0,0)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A7131",
    transform: "translate(0,0)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA954",
    transform: "translate(0,0)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#875D3A",
    transform: "translate(0,0)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#996349",
    transform: "translate(0,0)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686E31",
    transform: "translate(0,0)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74642D",
    transform: "translate(0,0)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9D4C",
    transform: "translate(0,0)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E5D34",
    transform: "translate(0,0)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#906041",
    transform: "translate(0,0)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E672B",
    transform: "translate(0,0)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676F30",
    transform: "translate(0,0)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#966346",
    transform: "translate(0,0)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#935F44",
    transform: "translate(0,0)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77662E",
    transform: "translate(0,0)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#936347",
    transform: "translate(0,0)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696F30",
    transform: "translate(0,0)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA953",
    transform: "translate(0,0)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77692D",
    transform: "translate(0,0)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#916244",
    transform: "translate(0,0)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#686E30",
    transform: "translate(0,0)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A34E",
    transform: "translate(0,0)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696E2E",
    transform: "translate(0,0)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#76602D",
    transform: "translate(0,0)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#62662F",
    transform: "translate(0,0)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666C2E",
    transform: "translate(0,0)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#76672E",
    transform: "translate(0,0)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B6428",
    transform: "translate(0,0)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA854",
    transform: "translate(0,0)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#815E36",
    transform: "translate(0,0)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#895F3E",
    transform: "translate(0,0)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E6341",
    transform: "translate(0,0)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E4A",
    transform: "translate(0,0)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA854",
    transform: "translate(0,0)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#76692D",
    transform: "translate(0,0)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B6140",
    transform: "translate(0,0)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696E2F",
    transform: "translate(0,0)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA853",
    transform: "translate(0,0)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#885D3C",
    transform: "translate(0,0)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC54",
    transform: "translate(0,0)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B663B",
    transform: "translate(0,0)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696D2F",
    transform: "translate(0,0)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75622D",
    transform: "translate(0,0)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F5C36",
    transform: "translate(0,0)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B603F",
    transform: "translate(0,0)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75682F",
    transform: "translate(0,0)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E5E35",
    transform: "translate(0,0)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6F2F",
    transform: "translate(0,0)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E4A",
    transform: "translate(0,0)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAA54",
    transform: "translate(0,0)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696D2E",
    transform: "translate(0,0)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77613A",
    transform: "translate(0,0)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#76672D",
    transform: "translate(0,0)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#795D30",
    transform: "translate(0,0)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#796238",
    transform: "translate(0,0)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#61612B",
    transform: "translate(0,0)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A651",
    transform: "translate(0,0)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AA53",
    transform: "translate(0,0)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#75642D",
    transform: "translate(0,0)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C5E34",
    transform: "translate(0,0)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#855E3B",
    transform: "translate(0,0)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#776239",
    transform: "translate(0,0)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B712F",
    transform: "translate(0,0)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E4A",
    transform: "translate(0,0)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAA53",
    transform: "translate(0,0)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#815C3A",
    transform: "translate(0,0)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696C2E",
    transform: "translate(0,0)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B5E33",
    transform: "translate(0,0)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F5D36",
    transform: "translate(0,0)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#73622D",
    transform: "translate(0,0)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#65692B",
    transform: "translate(0,0)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#76692E",
    transform: "translate(0,0)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA54",
    transform: "translate(0,0)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A5E31",
    transform: "translate(0,0)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#746036",
    transform: "translate(0,0)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6F2F",
    transform: "translate(0,0)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAA54",
    transform: "translate(0,0)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E5D37",
    transform: "translate(0,0)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54F",
    transform: "translate(0,0)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#795C31",
    transform: "translate(0,0)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C5C35",
    transform: "translate(0,0)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6E2D",
    transform: "translate(0,0)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54E",
    transform: "translate(0,0)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E5D37",
    transform: "translate(0,0)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#66692A",
    transform: "translate(0,0)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#766B2F",
    transform: "translate(0,0)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA54",
    transform: "translate(0,0)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#785E2F",
    transform: "translate(0,0)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA54",
    transform: "translate(0,0)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B5C35",
    transform: "translate(0,0)"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A6C2E",
    transform: "translate(0,0)"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#78682F",
    transform: "translate(0,0)"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#765E2E",
    transform: "translate(0,0)"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#795C32",
    transform: "translate(0,0)"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#775C30",
    transform: "translate(0,0)"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A0A14D",
    transform: "translate(0,0)"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#786D2F",
    transform: "translate(0,0)"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#775E2F",
    transform: "translate(0,0)"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB55",
    transform: "translate(0,0)"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#775C32",
    transform: "translate(0,0)"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6D2E",
    transform: "translate(0,0)"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#786A2E",
    transform: "translate(0,0)"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#795C2F",
    transform: "translate(0,0)"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AAA852",
    transform: "translate(0,0)"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696C2D",
    transform: "translate(0,0)"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B5B2D",
    transform: "translate(0,0)"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA54",
    transform: "translate(0,0)"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAB55",
    transform: "translate(0,0)"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#755B30",
    transform: "translate(0,0)"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6D2D",
    transform: "translate(0,0)"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A04D",
    transform: "translate(0,0)"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#745D2F",
    transform: "translate(0,0)"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6D2C",
    transform: "translate(0,0)"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#775B30",
    transform: "translate(0,0)"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A451",
    transform: "translate(0,0)"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC56",
    transform: "translate(0,0)"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72602C",
    transform: "translate(0,0)"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#765B30",
    transform: "translate(0,0)"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#745D2F",
    transform: "translate(0,0)"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#745C2F",
    transform: "translate(0,0)"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A14D",
    transform: "translate(0,0)"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A450",
    transform: "translate(0,0)"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAB55",
    transform: "translate(0,0)"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#725B2F",
    transform: "translate(0,0)"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6E2D",
    transform: "translate(0,0)"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72622C",
    transform: "translate(0,0)"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#745E2C",
    transform: "translate(0,0)"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#735E2D",
    transform: "translate(0,0)"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8D40",
    transform: "translate(0,0)"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74692D",
    transform: "translate(0,0)"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71642C",
    transform: "translate(0,0)"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#725A2D",
    transform: "translate(0,0)"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A550",
    transform: "translate(0,0)"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ADAA56",
    transform: "translate(0,0)"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#705B2C",
    transform: "translate(0,0)"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6F2D",
    transform: "translate(0,0)"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#725D2C",
    transform: "translate(0,0)"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#725D2B",
    transform: "translate(0,0)"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A550",
    transform: "translate(0,0)"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5D21",
    transform: "translate(0,0)"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D6022",
    transform: "translate(0,0)"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7131",
    transform: "translate(0,0)"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D6124",
    transform: "translate(0,0)"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A550",
    transform: "translate(0,0)"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAB55",
    transform: "translate(0,0)"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E5B2B",
    transform: "translate(0,0)"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6F2E",
    transform: "translate(0,0)"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A34E",
    transform: "translate(0,0)"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72652D",
    transform: "translate(0,0)"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#725F2B",
    transform: "translate(0,0)"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#756B2D",
    transform: "translate(0,0)"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72672C",
    transform: "translate(0,0)"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71602A",
    transform: "translate(0,0)"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F5B2A",
    transform: "translate(0,0)"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E5D2A",
    transform: "translate(0,0)"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC56",
    transform: "translate(0,0)"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C5B29",
    transform: "translate(0,0)"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6F2D",
    transform: "translate(0,0)"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A751",
    transform: "translate(0,0)"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5B1E",
    transform: "translate(0,0)"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7532",
    transform: "translate(0,0)"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71622A",
    transform: "translate(0,0)"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAC56",
    transform: "translate(0,0)"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A5B28",
    transform: "translate(0,0)"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6F2E",
    transform: "translate(0,0)"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7231",
    transform: "translate(0,0)"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72652B",
    transform: "translate(0,0)"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D5E29",
    transform: "translate(0,0)"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5B1F",
    transform: "translate(0,0)"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAD56",
    transform: "translate(0,0)"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#695C28",
    transform: "translate(0,0)"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F712F",
    transform: "translate(0,0)"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F8D41",
    transform: "translate(0,0)"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A34F",
    transform: "translate(0,0)"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71632A",
    transform: "translate(0,0)"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D5F29",
    transform: "translate(0,0)"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D5E29",
    transform: "translate(0,0)"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F722D",
    transform: "translate(0,0)"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5B1E",
    transform: "translate(0,0)"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676A28",
    transform: "translate(0,0)"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C702D",
    transform: "translate(0,0)"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70642A",
    transform: "translate(0,0)"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AFAD56",
    transform: "translate(0,0)"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6229",
    transform: "translate(0,0)"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#625823",
    transform: "translate(0,0)"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70722F",
    transform: "translate(0,0)"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74682D",
    transform: "translate(0,0)"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6028",
    transform: "translate(0,0)"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70652A",
    transform: "translate(0,0)"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A44F",
    transform: "translate(0,0)"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AD56",
    transform: "translate(0,0)"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#695D26",
    transform: "translate(0,0)"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7834",
    transform: "translate(0,0)"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74692C",
    transform: "translate(0,0)"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6128",
    transform: "translate(0,0)"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#78722E",
    transform: "translate(0,0)"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F722E",
    transform: "translate(0,0)"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#71662A",
    transform: "translate(0,0)"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AD58",
    transform: "translate(0,0)"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#695D26",
    transform: "translate(0,0)"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727332",
    transform: "translate(0,0)"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#766D2E",
    transform: "translate(0,0)"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807834",
    transform: "translate(0,0)"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#74682C",
    transform: "translate(0,0)"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6028",
    transform: "translate(0,0)"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70662A",
    transform: "translate(0,0)"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#695D26",
    transform: "translate(0,0)"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5D5B1D",
    transform: "translate(0,0)"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6127",
    transform: "translate(0,0)"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817A34",
    transform: "translate(0,0)"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#70672A",
    transform: "translate(0,0)"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AE57",
    transform: "translate(0,0)"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#685D26",
    transform: "translate(0,0)"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#727431",
    transform: "translate(0,0)"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A5F26",
    transform: "translate(0,0)"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#766B2D",
    transform: "translate(0,0)"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#645A21",
    transform: "translate(0,0)"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABA953",
    transform: "translate(0,0)"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AE57",
    transform: "translate(0,0)"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72682A",
    transform: "translate(0,0)"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A5F26",
    transform: "translate(0,0)"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF57",
    transform: "translate(0,0)"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#685D26",
    transform: "translate(0,0)"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#737531",
    transform: "translate(0,0)"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72672A",
    transform: "translate(0,0)"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6227",
    transform: "translate(0,0)"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A19F4C",
    transform: "translate(0,0)"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7631",
    transform: "translate(0,0)"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A5E25",
    transform: "translate(0,0)"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A5A851",
    transform: "translate(0,0)"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847E37",
    transform: "translate(0,0)"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858037",
    transform: "translate(0,0)"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72692A",
    transform: "translate(0,0)"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6328",
    transform: "translate(0,0)"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF57",
    transform: "translate(0,0)"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#695E25",
    transform: "translate(0,0)"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747531",
    transform: "translate(0,0)"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757732",
    transform: "translate(0,0)"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#776F2D",
    transform: "translate(0,0)"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757730",
    transform: "translate(0,0)"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6226",
    transform: "translate(0,0)"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747632",
    transform: "translate(0,0)"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#726A2B",
    transform: "translate(0,0)"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AE57",
    transform: "translate(0,0)"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#696024",
    transform: "translate(0,0)"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757733",
    transform: "translate(0,0)"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF57",
    transform: "translate(0,0)"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6429",
    transform: "translate(0,0)"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#645D21",
    transform: "translate(0,0)"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767831",
    transform: "translate(0,0)"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A54D",
    transform: "translate(0,0)"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E6528",
    transform: "translate(0,0)"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#747731",
    transform: "translate(0,0)"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAF57",
    transform: "translate(0,0)"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858037",
    transform: "translate(0,0)"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#736C2C",
    transform: "translate(0,0)"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B058",
    transform: "translate(0,0)"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B8B45C",
    transform: "translate(0,0)"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A5F25",
    transform: "translate(0,0)"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777833",
    transform: "translate(0,0)"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79702F",
    transform: "translate(0,0)"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#746A2C",
    transform: "translate(0,0)"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#746A2D",
    transform: "translate(0,0)"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F6628",
    transform: "translate(0,0)"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#767832",
    transform: "translate(0,0)"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868138",
    transform: "translate(0,0)"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABAB53",
    transform: "translate(0,0)"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1AF58",
    transform: "translate(0,0)"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B257",
    transform: "translate(0,0)"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#746C2D",
    transform: "translate(0,0)"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6228",
    transform: "translate(0,0)"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A851",
    transform: "translate(0,0)"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B058",
    transform: "translate(0,0)"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#736B2C",
    transform: "translate(0,0)"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6126",
    transform: "translate(0,0)"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#635B22",
    transform: "translate(0,0)"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797A35",
    transform: "translate(0,0)"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878038",
    transform: "translate(0,0)"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#77702E",
    transform: "translate(0,0)"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#706729",
    transform: "translate(0,0)"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#656624",
    transform: "translate(0,0)"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787A32",
    transform: "translate(0,0)"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72672A",
    transform: "translate(0,0)"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6127",
    transform: "translate(0,0)"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#636120",
    transform: "translate(0,0)"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666926",
    transform: "translate(0,0)"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6D2B",
    transform: "translate(0,0)"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777A34",
    transform: "translate(0,0)"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6F672A",
    transform: "translate(0,0)"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5E5F22",
    transform: "translate(0,0)"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2AF58",
    transform: "translate(0,0)"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#756E2E",
    transform: "translate(0,0)"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A950",
    transform: "translate(0,0)"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B059",
    transform: "translate(0,0)"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6B6227",
    transform: "translate(0,0)"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797A34",
    transform: "translate(0,0)"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B059",
    transform: "translate(0,0)"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#88823A",
    transform: "translate(0,0)"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6226",
    transform: "translate(0,0)"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969646",
    transform: "translate(0,0)"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#626121",
    transform: "translate(0,0)"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#757731",
    transform: "translate(0,0)"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#776F2F",
    transform: "translate(0,0)"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B158",
    transform: "translate(0,0)"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6326",
    transform: "translate(0,0)"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7C36",
    transform: "translate(0,0)"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B059",
    transform: "translate(0,0)"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#89833B",
    transform: "translate(0,0)"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#73682A",
    transform: "translate(0,0)"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#837E35",
    transform: "translate(0,0)"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#786F2F",
    transform: "translate(0,0)"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#716A2D",
    transform: "translate(0,0)"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#777832",
    transform: "translate(0,0)"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72682B",
    transform: "translate(0,0)"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAC55",
    transform: "translate(0,0)"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#78702F",
    transform: "translate(0,0)"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6C6127",
    transform: "translate(0,0)"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ACAA52",
    transform: "translate(0,0)"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B258",
    transform: "translate(0,0)"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6328",
    transform: "translate(0,0)"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#655E25",
    transform: "translate(0,0)"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7D37",
    transform: "translate(0,0)"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A450",
    transform: "translate(0,0)"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7534",
    transform: "translate(0,0)"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#736A2C",
    transform: "translate(0,0)"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676024",
    transform: "translate(0,0)"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7F35",
    transform: "translate(0,0)"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6A6C29",
    transform: "translate(0,0)"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#726A2C",
    transform: "translate(0,0)"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797230",
    transform: "translate(0,0)"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B158",
    transform: "translate(0,0)"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6D6428",
    transform: "translate(0,0)"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7E38",
    transform: "translate(0,0)"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7633",
    transform: "translate(0,0)"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7130",
    transform: "translate(0,0)"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A551",
    transform: "translate(0,0)"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#847E36",
    transform: "translate(0,0)"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7F37",
    transform: "translate(0,0)"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B0AD57",
    transform: "translate(0,0)"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B25A",
    transform: "translate(0,0)"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#676025",
    transform: "translate(0,0)"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B25A",
    transform: "translate(0,0)"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E662A",
    transform: "translate(0,0)"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#665F26",
    transform: "translate(0,0)"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7F37",
    transform: "translate(0,0)"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B4B15B",
    transform: "translate(0,0)"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E883E",
    transform: "translate(0,0)"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#817933",
    transform: "translate(0,0)"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#746C2D",
    transform: "translate(0,0)"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#6E6E29",
    transform: "translate(0,0)"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828439",
    transform: "translate(0,0)"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#72662A",
    transform: "translate(0,0)"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#666324",
    transform: "translate(0,0)"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7A34",
    transform: "translate(0,0)"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#86893D",
    transform: "translate(0,0)"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7E38",
    transform: "translate(0,0)"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B3B259",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhmcLogo);
export default __webpack_public_path__ + "static/media/GHMC Logo.7d17c31c071f0ec98b163999d43846ae.svg";
export { ForwardRef as ReactComponent };